export const LeftArrowSvg = () => {
  return (
    <svg
      width="18"
      height="14"
      viewBox="0 0 18 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 7L1.29289 6.29289L0.585786 7L1.29289 7.70711L2 7ZM17 8C17.5523 8 18 7.55228 18 7C18 6.44772 17.5523 6 17 6V8ZM7.29289 0.292893L1.29289 6.29289L2.70711 7.70711L8.70711 1.70711L7.29289 0.292893ZM1.29289 7.70711L7.29289 13.7071L8.70711 12.2929L2.70711 6.29289L1.29289 7.70711ZM2 8H17V6H2V8Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const SignatureClearSvg = () => {
  const SVG = <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.93077 11.2003C3.00244 6.23968 7.07619 2.25 12.0789 2.25C15.3873 2.25 18.287 3.99427 19.8934 6.60721C20.1103 6.96007 20.0001 7.42199 19.6473 7.63892C19.2944 7.85585 18.8325 7.74565 18.6156 7.39279C17.2727 5.20845 14.8484 3.75 12.0789 3.75C7.8945 3.75 4.50372 7.0777 4.431 11.1982L4.83138 10.8009C5.12542 10.5092 5.60029 10.511 5.89203 10.8051C6.18377 11.0991 6.18191 11.574 5.88787 11.8657L4.20805 13.5324C3.91565 13.8225 3.44398 13.8225 3.15157 13.5324L1.47176 11.8657C1.17772 11.574 1.17585 11.0991 1.46759 10.8051C1.75933 10.5111 2.2342 10.5092 2.52824 10.8009L2.93077 11.2003ZM19.7864 10.4666C20.0786 10.1778 20.5487 10.1778 20.8409 10.4666L22.5271 12.1333C22.8217 12.4244 22.8245 12.8993 22.5333 13.1939C22.2421 13.4885 21.7673 13.4913 21.4727 13.2001L21.0628 12.7949C20.9934 17.7604 16.9017 21.75 11.8825 21.75C8.56379 21.75 5.65381 20.007 4.0412 17.3939C3.82366 17.0414 3.93307 16.5793 4.28557 16.3618C4.63806 16.1442 5.10016 16.2536 5.31769 16.6061C6.6656 18.7903 9.09999 20.25 11.8825 20.25C16.0887 20.25 19.4922 16.9171 19.5625 12.7969L19.1546 13.2001C18.86 13.4913 18.3852 13.4885 18.094 13.1939C17.8028 12.8993 17.8056 12.4244 18.1002 12.1333L19.7864 10.4666Z"
      fill="currentColor"
    />
  </svg>
  return SVG
}
export const SaveSvg = () => {
  const SVG = <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M11.6206 1.76232C11.4868 1.75064 11.3532 1.75 11 1.75C8.62177 1.75 6.91356 1.7516 5.61358 1.92637C4.33517 2.09825 3.56445 2.42514 2.9948 2.9948C2.42514 3.56446 2.09825 4.33518 1.92637 5.61358C1.75159 6.91356 1.75 8.62178 1.75 11C1.75 13.3782 1.75159 15.0864 1.92637 16.3864C2.09825 17.6648 2.42514 18.4355 2.9948 19.0052C3.56445 19.5749 4.33517 19.9018 5.61358 20.0736C6.91356 20.2484 8.62177 20.25 11 20.25C13.3782 20.25 15.0864 20.2484 16.3864 20.0736C17.6648 19.9018 18.4355 19.5749 19.0052 19.0052C19.5749 18.4355 19.9018 17.6648 20.0736 16.3864C20.2484 15.0864 20.25 13.3782 20.25 11C20.25 10.6468 20.2494 10.5132 20.2377 10.3794C20.1804 9.72355 19.9125 9.07681 19.4892 8.57254C19.403 8.46978 19.3063 8.37221 19.0502 8.11611L13.8839 2.94977C13.6278 2.69368 13.5302 2.59701 13.4275 2.51076C12.9232 2.08746 12.2765 1.81957 11.6206 1.76232ZM11.0315 0.250001C11.3431 0.249982 11.5445 0.249969 11.751 0.267999C12.7138 0.352044 13.6517 0.740538 14.3919 1.36187C14.5507 1.49517 14.696 1.64055 14.9213 1.86587L14.9446 1.88911L20.1341 7.07862C20.3594 7.30396 20.5048 7.44933 20.6381 7.60814C21.2595 8.34833 21.648 9.28624 21.732 10.249C21.75 10.4555 21.75 10.6569 21.75 10.9684V11.0574C21.75 13.3658 21.75 15.1748 21.5603 16.5863C21.366 18.031 20.9607 19.1711 20.0659 20.0659C19.1711 20.9607 18.031 21.366 16.5863 21.5603C15.1748 21.75 13.3658 21.75 11.0574 21.75H10.9426C8.63423 21.75 6.82519 21.75 5.41371 21.5603C3.96897 21.366 2.82895 20.9607 1.93414 20.0659C1.03933 19.1711 0.633986 18.031 0.439747 16.5863C0.249977 15.1748 0.249987 13.3658 0.25 11.0574V10.9426C0.249987 8.63423 0.249977 6.82519 0.439747 5.41371C0.633986 3.96897 1.03933 2.82895 1.93414 1.93414C2.82895 1.03933 3.96897 0.633988 5.41371 0.439749C6.82519 0.249979 8.63423 0.249989 10.9426 0.250002L11.0315 0.250001ZM10.4616 10.25H11.5384C12.2079 10.25 12.7667 10.25 13.219 10.296C13.6925 10.3442 14.1318 10.4489 14.5278 10.7135C14.8281 10.9141 15.0859 11.1719 15.2865 11.4722C15.5511 11.8682 15.6559 12.3076 15.704 12.781C15.75 13.2334 15.75 13.7921 15.75 14.4616V14.5384C15.75 15.2079 15.75 15.7667 15.704 16.219C15.6559 16.6925 15.5511 17.1318 15.2865 17.5278C15.0859 17.8281 14.8281 18.0859 14.5278 18.2865C14.1318 18.5511 13.6925 18.6559 13.219 18.704C12.7666 18.75 12.2079 18.75 11.5383 18.75H10.4617C9.79209 18.75 9.23336 18.75 8.78102 18.704C8.30755 18.6559 7.86818 18.5511 7.47218 18.2865C7.17191 18.0859 6.9141 17.8281 6.71346 17.5278C6.44886 17.1318 6.34415 16.6925 6.29598 16.219C6.24997 15.7667 6.24998 15.2079 6.25 14.5383V14.4617C6.24998 13.7921 6.24997 13.2334 6.29598 12.781C6.34415 12.3076 6.44886 11.8682 6.71346 11.4722C6.91409 11.1719 7.17191 10.9141 7.47218 10.7135C7.86818 10.4489 8.30755 10.3442 8.78102 10.296C9.23335 10.25 9.79207 10.25 10.4616 10.25ZM8.93283 11.7883C8.57796 11.8244 8.41399 11.8882 8.30554 11.9607C8.16905 12.0519 8.05186 12.1691 7.96066 12.3055C7.8882 12.414 7.82438 12.578 7.78828 12.9328C7.75091 13.3002 7.75 13.7822 7.75 14.5C7.75 15.2178 7.75091 15.6998 7.78828 16.0672C7.82438 16.422 7.8882 16.586 7.96066 16.6945C8.05186 16.831 8.16905 16.9481 8.30554 17.0393C8.41399 17.1118 8.57796 17.1756 8.93283 17.2117C9.25586 17.2446 9.66741 17.2493 10.25 17.2499V11.7501C9.66741 11.7508 9.25586 11.7554 8.93283 11.7883ZM11.75 11.7501V13.75H14.2474C14.2436 13.4181 14.2343 13.1546 14.2117 12.9328C14.1756 12.578 14.1118 12.414 14.0393 12.3055C13.9481 12.1691 13.831 12.0519 13.6945 11.9607C13.586 11.8882 13.422 11.8244 13.0672 11.7883C12.7441 11.7554 12.3326 11.7508 11.75 11.7501ZM14.2474 15.25H11.75V17.2499C12.3326 17.2493 12.7441 17.2446 13.0672 17.2117C13.422 17.1756 13.586 17.1118 13.6945 17.0393C13.831 16.9481 13.9481 16.831 14.0393 16.6945C14.1118 16.586 14.1756 16.422 14.2117 16.0672C14.2343 15.8454 14.2436 15.5819 14.2474 15.25Z" fill="currentColor" />
  </svg>
  return SVG
}


export const RightArrowSvg = () => {
  return (
    <svg
      width="18"
      height="14"
      viewBox="0 0 18 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 7H17M17 7L11 1M17 7L11 13"
        stroke="cuRrenTColor"
        strokeWidth="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const UserGuideSvg = () => {
  return (
    <svg
      width="18"
      height="22"
      viewBox="0 0 18 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.94531 0.250001H11.0551C12.4227 0.24998 13.525 0.249963 14.3919 0.366524C15.292 0.48754 16.0499 0.746434 16.6518 1.34835C17.2538 1.95027 17.5126 2.70814 17.6337 3.60825C17.7502 4.47522 17.7502 5.57754 17.7502 6.94513V15.0549C17.7502 16.4225 17.7502 17.5248 17.6337 18.3918C17.5126 19.2919 17.2538 20.0497 16.6518 20.6517C16.0499 21.2536 15.292 21.5125 14.3919 21.6335C13.525 21.75 12.4226 21.75 11.0551 21.75H6.94532C5.57773 21.75 4.4754 21.75 3.60844 21.6335C2.70833 21.5125 1.95045 21.2536 1.34854 20.6517C0.746619 20.0497 0.487726 19.2919 0.366709 18.3918C0.328013 18.1039 0.302165 17.7902 0.2849 17.4494C0.24582 17.326 0.238209 17.1912 0.268946 17.0568C0.250164 16.4649 0.250174 15.7991 0.250186 15.0549V6.94513C0.250165 5.57754 0.250148 4.47522 0.366709 3.60825C0.487726 2.70814 0.746619 1.95027 1.34854 1.34835C1.95045 0.746434 2.70833 0.48754 3.60843 0.366524C4.4754 0.249963 5.57772 0.24998 6.94531 0.250001ZM1.77694 17.2491C1.79214 17.6029 1.81597 17.914 1.85333 18.1919C1.95199 18.9257 2.13243 19.3142 2.4092 19.591C2.68596 19.8678 3.07453 20.0482 3.80831 20.1469C4.56366 20.2484 5.56477 20.25 7.00019 20.25H11.0002C12.4356 20.25 13.4367 20.2484 14.1921 20.1469C14.9258 20.0482 15.3144 19.8678 15.5912 19.591C15.8679 19.3142 16.0484 18.9257 16.147 18.1919C16.2299 17.5756 16.2462 16.7958 16.2494 15.75H10.7502V18.5309C10.7502 18.5396 10.7502 18.5485 10.7502 18.5578C10.7504 18.6691 10.7506 18.8276 10.7293 18.9638C10.7033 19.1302 10.6177 19.4514 10.2851 19.6468C9.9647 19.8349 9.65135 19.765 9.50241 19.7187C9.37256 19.6783 9.23018 19.6105 9.12402 19.56C9.11561 19.556 9.10743 19.5521 9.0995 19.5483L8.00019 19.0261L6.90087 19.5483C6.89294 19.5521 6.88477 19.5559 6.87636 19.56C6.7702 19.6105 6.62782 19.6783 6.49796 19.7187C6.34903 19.765 6.03567 19.8349 5.7153 19.6468C5.38263 19.4514 5.29705 19.1302 5.27104 18.9638C5.24976 18.8276 5.25 18.6691 5.25016 18.5578C5.25017 18.5485 5.25019 18.5396 5.25019 18.5309V15.75H4.89796C3.91971 15.75 3.5777 15.7564 3.31562 15.8267C2.5963 16.0194 2.02286 16.5541 1.77694 17.2491ZM6.75019 15.75V17.9592L7.4995 17.6033C7.50134 17.6024 7.50429 17.6009 7.50831 17.5989C7.55733 17.5738 7.76384 17.4682 8.00019 17.4682C8.23653 17.4682 8.44304 17.5738 8.49206 17.5989C8.49608 17.6009 8.49904 17.6024 8.50087 17.6033L9.25019 17.9592V15.75H6.75019ZM4.89796 14.25C4.85879 14.25 4.8202 14.25 4.78217 14.25C3.9642 14.2497 3.40605 14.2495 2.92739 14.3778C2.49941 14.4925 2.10242 14.6798 1.75019 14.9259V7C1.75019 5.56458 1.75178 4.56347 1.85333 3.80812C1.95199 3.07435 2.13243 2.68577 2.4092 2.40901C2.68596 2.13225 3.07453 1.9518 3.80831 1.85315C4.56366 1.75159 5.56477 1.75 7.00019 1.75H11.0002C12.4356 1.75 13.4367 1.75159 14.1921 1.85315C14.9258 1.9518 15.3144 2.13225 15.5912 2.40901C15.8679 2.68577 16.0484 3.07435 16.147 3.80812C16.2486 4.56347 16.2502 5.56458 16.2502 7V14.25H4.89796ZM4.25019 6C4.25019 5.58579 4.58597 5.25 5.00019 5.25H13.0002C13.4144 5.25 13.7502 5.58579 13.7502 6C13.7502 6.41421 13.4144 6.75 13.0002 6.75H5.00019C4.58597 6.75 4.25019 6.41421 4.25019 6ZM4.25019 9.5C4.25019 9.08579 4.58597 8.75 5.00019 8.75H10.0002C10.4144 8.75 10.7502 9.08579 10.7502 9.5C10.7502 9.91421 10.4144 10.25 10.0002 10.25H5.00019C4.58597 10.25 4.25019 9.91421 4.25019 9.5Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const GuideInteractiveSvg = () => {
  return (
    <svg
      width="18"
      height="22"
      viewBox="0 0 18 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.6111 0.583698C14.2678 0.347027 15.75 1.63255 15.75 3.30606V4.68256C16.9395 5.31131 17.75 6.56102 17.75 8.00004V18C17.75 20.0711 16.0711 21.75 14 21.75H4C1.92893 21.75 0.25 20.0711 0.25 18V4.00004C0.25 3.99074 0.250169 3.98148 0.250505 3.97227C0.250169 3.95788 0.25 3.94344 0.25 3.92897C0.25 3.02272 0.916381 2.25437 1.81353 2.12621L12.6111 0.583698ZM1.75 5.75004V18C1.75 19.2427 2.75736 20.25 4 20.25H14C15.2426 20.25 16.25 19.2427 16.25 18V8.00004C16.25 6.7574 15.2426 5.75004 14 5.75004H1.75ZM2.07107 4.25004H14.25V3.30606C14.25 2.54537 13.5763 1.96104 12.8232 2.06862L2.02566 3.61113C1.86749 3.63373 1.75 3.76919 1.75 3.92897C1.75 4.10629 1.89375 4.25004 2.07107 4.25004ZM4.25 11C4.25 10.5858 4.58579 10.25 5 10.25H13C13.4142 10.25 13.75 10.5858 13.75 11C13.75 11.4143 13.4142 11.75 13 11.75H5C4.58579 11.75 4.25 11.4143 4.25 11ZM4.25 14.5C4.25 14.0858 4.58579 13.75 5 13.75H10.5C10.9142 13.75 11.25 14.0858 11.25 14.5C11.25 14.9143 10.9142 15.25 10.5 15.25H5C4.58579 15.25 4.25 14.9143 4.25 14.5Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const MemberUserGuideSvg = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.94513 0.250001H12.0549C13.4225 0.24998 14.5248 0.249963 15.3918 0.366524C16.2919 0.48754 17.0497 0.746434 17.6517 1.34835C17.9501 1.64682 18.1642 1.98363 18.319 2.35712C19.2511 2.47388 20.0336 2.73034 20.6517 3.3484C21.2536 3.95032 21.5125 4.70819 21.6335 5.6083C21.75 6.47527 21.75 7.57759 21.75 8.94518V13.0549C21.75 14.4225 21.75 15.5248 21.6335 16.3918C21.5125 17.2919 21.2536 18.0498 20.6517 18.6517C20.0336 19.2698 19.2511 19.5262 18.319 19.643C18.1642 20.0164 17.9501 20.3532 17.6517 20.6517C17.0497 21.2536 16.2919 21.5125 15.3918 21.6335C14.5248 21.75 13.4225 21.75 12.0549 21.75H9.94513C8.57754 21.75 7.47522 21.75 6.60825 21.6335C5.70814 21.5125 4.95027 21.2536 4.34835 20.6517C4.04991 20.3532 3.8358 20.0164 3.68101 19.643C2.74894 19.5262 1.96643 19.2698 1.34835 18.6517C0.746434 18.0498 0.48754 17.2919 0.366524 16.3918C0.249963 15.5248 0.24998 14.4225 0.250001 13.0549V8.94518C0.24998 7.57759 0.249963 6.47527 0.366524 5.6083C0.48754 4.70819 0.746434 3.95032 1.34835 3.3484C1.96642 2.73034 2.74892 2.47388 3.68096 2.35712C3.83576 1.98363 4.04988 1.64682 4.34835 1.34835C4.95027 0.746434 5.70814 0.48754 6.60825 0.366524C7.47522 0.249963 8.57754 0.24998 9.94513 0.250001ZM3.32844 3.94047C2.89082 4.04593 2.618 4.20007 2.40901 4.40906C2.13225 4.68583 1.9518 5.0744 1.85315 5.80817C1.75159 6.56352 1.75 7.56464 1.75 9.00005V13.0001C1.75 14.4355 1.75159 15.4366 1.85315 16.1919C1.9518 16.9257 2.13225 17.3143 2.40901 17.591C2.61801 17.8 2.89083 17.9542 3.32845 18.0596C3.24997 17.2484 3.24998 16.2535 3.25 15.0549V6.94512C3.24998 5.74652 3.24997 4.75169 3.32844 3.94047ZM18.6716 18.0596C19.1092 17.9542 19.382 17.8 19.591 17.591C19.8678 17.3143 20.0482 16.9257 20.1469 16.1919C20.2484 15.4366 20.25 14.4355 20.25 13.0001V9.00005C20.25 7.56464 20.2484 6.56352 20.1469 5.80817C20.0482 5.0744 19.8678 4.68583 19.591 4.40906C19.382 4.20007 19.1092 4.04593 18.6716 3.94047C18.75 4.75169 18.75 5.74653 18.75 6.94513V15.0549C18.75 16.2535 18.75 17.2484 18.6716 18.0596ZM6.80812 1.85315C6.07435 1.9518 5.68577 2.13225 5.40901 2.40901C5.13225 2.68577 4.9518 3.07435 4.85315 3.80812C4.75159 4.56347 4.75 5.56458 4.75 7V15C4.75 16.4354 4.75159 17.4365 4.85315 18.1919C4.9518 18.9257 5.13225 19.3142 5.40901 19.591C5.68577 19.8678 6.07435 20.0482 6.80812 20.1469C7.56347 20.2484 8.56458 20.25 10 20.25H12C13.4354 20.25 14.4365 20.2484 15.1919 20.1469C15.9257 20.0482 16.3142 19.8678 16.591 19.591C16.8678 19.3142 17.0482 18.9257 17.1469 18.1919C17.2484 17.4365 17.25 16.4354 17.25 15V7C17.25 5.56459 17.2484 4.56347 17.1469 3.80812C17.0482 3.07435 16.8678 2.68577 16.591 2.40901C16.3142 2.13225 15.9257 1.9518 15.1919 1.85315C14.4365 1.75159 13.4354 1.75 12 1.75H10C8.56458 1.75 7.56347 1.75159 6.80812 1.85315ZM7.25 8C7.25 7.58579 7.58579 7.25 8 7.25H14C14.4142 7.25 14.75 7.58579 14.75 8C14.75 8.41422 14.4142 8.75 14 8.75H8C7.58579 8.75 7.25 8.41422 7.25 8ZM7.25 12C7.25 11.5858 7.58579 11.25 8 11.25H14C14.4142 11.25 14.75 11.5858 14.75 12C14.75 12.4142 14.4142 12.75 14 12.75H8C7.58579 12.75 7.25 12.4142 7.25 12ZM7.25 16C7.25 15.5858 7.58579 15.25 8 15.25H11C11.4142 15.25 11.75 15.5858 11.75 16C11.75 16.4142 11.4142 16.75 11 16.75H8C7.58579 16.75 7.25 16.4142 7.25 16Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const SearchSvg = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M27.6 25.8L22 20.2C23.3 18.5 24.1 16.4 24.1 14.1C24.1 8.59998 19.6 4.09998 14.1 4.09998C8.6 4.09998 4 8.59998 4 14.1C4 19.6 8.5 24.1 14 24.1C16.3 24.1 18.5 23.3 20.2 21.9L25.8 27.5C26 27.7 26.4 27.9 26.7 27.9C27 27.9 27.3 27.8 27.6 27.5C28.1 27.1 28.1 26.3 27.6 25.8ZM6.5 14.1C6.5 9.99998 9.9 6.59998 14 6.59998C18.1 6.59998 21.5 9.99998 21.5 14.1C21.5 18.2 18.1 21.6 14 21.6C9.9 21.6 6.5 18.3 6.5 14.1Z" />
    </svg>
  );
};

export const CheckRoundSvg = () => {
  return (
    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M20.5 10C20.5 15.5228 16.0228 20 10.5 20C4.97715 20 0.5 15.5228 0.5 10C0.5 4.47715 4.97715 0 10.5 0C16.0228 0 20.5 4.47715 20.5 10ZM16 6C16.2929 6.29289 16.2929 6.76777 16 7.06066L8.46967 14.5C8.17678 14.7929 7.7019 14.7929 7.40901 14.5L4.43934 11.0607C4.14645 10.7678 4.14645 10.2929 4.43934 10C4.73223 9.70711 5.20711 9.70711 5.5 10L7.93934 12.909L10.1742 10.6742L14.9393 6C15.2322 5.70711 15.7071 5.70711 16 6Z" fill="currentColor" /></svg>
  );
};
export const CloseRoundSvg = () => {
  return (<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M12 2c5.53 0 10 4.47 10 10s-4.47 10-10 10S2 17.53 2 12S6.47 2 12 2m3.59 5L12 10.59L8.41 7L7 8.41L10.59 12L7 15.59L8.41 17L12 13.41L15.59 17L17 15.59L13.41 12L17 8.41z"/></svg>)
}
export const HistoryIconSvg = () => {
  return (<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M13 3a9 9 0 0 0-9 9H1l3.89 3.89l.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7s-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42A8.95 8.95 0 0 0 13 21a9 9 0 0 0 0-18m-1 5v5l4.25 2.52l.77-1.28l-3.52-2.09V8z"/></svg>)
};

export const AddSvg = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 1L10 19"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M19 10L1 10"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const EditSvg = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1123_13264)">
        <path
          d="M14.1667 2.50005C14.3856 2.28118 14.6454 2.10756 14.9314 1.98911C15.2173 1.87066 15.5238 1.80969 15.8334 1.80969C16.1429 1.80969 16.4494 1.87066 16.7353 1.98911C17.0213 2.10756 17.2812 2.28118 17.5 2.50005C17.7189 2.71892 17.8925 2.97875 18.011 3.26472C18.1294 3.55069 18.1904 3.85719 18.1904 4.16671C18.1904 4.47624 18.1294 4.78274 18.011 5.06871C17.8925 5.35468 17.7189 5.61451 17.5 5.83338L6.25002 17.0834L1.66669 18.3334L2.91669 13.75L14.1667 2.50005Z"
          stroke="CurrentColor"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1123_13264">
          <rect width="20" height="20" fill="CurrentColor" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const LogoutSvg = () => {
  return (
    <svg
      width="22"
      height="20"
      viewBox="0 0 22 20"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M5 9H13V11H5V14L0 10L5 6V9ZM4 16H6.708C7.86269 17.0183 9.28669 17.6819 10.8091 17.9109C12.3316 18.14 13.8878 17.9249 15.291 17.2915C16.6942 16.6581 17.8849 15.6332 18.7201 14.3398C19.5553 13.0465 19.9995 11.5396 19.9995 10C19.9995 8.46042 19.5553 6.95354 18.7201 5.66019C17.8849 4.36683 16.6942 3.34194 15.291 2.7085C13.8878 2.07506 12.3316 1.85998 10.8091 2.08906C9.28669 2.31815 7.86269 2.98167 6.708 4H4C4.93066 2.75718 6.13833 1.74851 7.52707 1.05414C8.91581 0.359775 10.4473 -0.00116364 12 2.81829e-06C17.523 2.81829e-06 22 4.477 22 10C22 15.523 17.523 20 12 20C10.4473 20.0012 8.91581 19.6402 7.52707 18.9459C6.13833 18.2515 4.93066 17.2428 4 16Z" />
    </svg>
  );
};
export const LogoiconSvg = () => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.84229 10.9474V14.3684H8.21071"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <circle cx="10.6051" cy="12.6579" r="1.21053" stroke="currentColor" />
      <circle cx="18.816" cy="12.6579" r="1.21053" stroke="currentColor" />
      <path
        d="M15.8189 11.3551C15.5204 11.1008 15.1334 10.9474 14.7105 10.9474C13.7658 10.9474 13 11.7132 13 12.6579C13 13.6026 13.7658 14.3684 14.7105 14.3684C15.6552 14.3684 16.4211 13.6026 16.4211 12.6579C16.4211 12.5982 16.418 12.5392 16.412 12.481L14.866 12.5024"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <circle cx="13.6843" cy="13" r="8.39474" stroke="currentColor" />
      <path
        d="M2.14646 11.5165C2.08461 12.0023 2.05273 12.4974 2.05273 13C2.05273 18.8153 6.32029 23.6339 11.8945 24.4948M4.63789 5.68808C6.41848 3.48786 8.98549 1.95021 11.9113 1.50274M15.0211 1.44446C20.8155 2.10749 25.3159 7.0282 25.3159 13C25.3159 18.9982 20.7758 23.9359 14.9446 24.5641"
        stroke="currentColor"
      />
      <path
        d="M2.73682 1.71057H12.129M23.2631 1.71057H14.5367"
        stroke="currentColor"
      />
      <circle cx="1.71053" cy="1.71053" r="1.21053" stroke="currentColor" />
      <circle cx="24.2896" cy="1.71053" r="1.21053" stroke="currentColor" />
      <rect
        x="12.1313"
        y="0.5"
        width="2.42105"
        height="2.42105"
        rx="0.5"
        stroke="currentColor"
      />
      <path
        d="M2.73682 24.2894H12.129M23.2631 24.2894H14.5367"
        stroke="currentColor"
      />
      <circle cx="1.71053" cy="24.2895" r="1.21053" stroke="currentColor" />
      <circle cx="24.2896" cy="24.2895" r="1.21053" stroke="currentColor" />
      <rect
        x="12.1313"
        y="23.079"
        width="2.42105"
        height="2.42105"
        rx="0.5"
        stroke="currentColor"
      />
    </svg>
  );
};

export const AddimageSvg = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 5H17V12H19V5C19 3.897 18.103 3 17 3H4C2.897 3 2 3.897 2 5V17C2 18.103 2.897 19 4 19H12V17H4V5Z"
        fill="currentColor"
      />
      <path d="M8 11L5 15H16L12 9L9 13L8 11Z" fill="currentColor" />
      <path
        d="M19 14H17V17H14V19H17V22H19V19H22V17H19V14Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const SettingSvg = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 7.25C8.92894 7.25 7.25 8.92893 7.25 11C7.25 13.0711 8.92894 14.75 11 14.75C13.0711 14.75 14.75 13.0711 14.75 11C14.75 8.92893 13.0711 7.25 11 7.25ZM8.75 11C8.75 9.75736 9.75736 8.75 11 8.75C12.2426 8.75 13.25 9.75736 13.25 11C13.25 12.2426 12.2426 13.25 11 13.25C9.75736 13.25 8.75 12.2426 8.75 11Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.9747 0.25C10.5303 0.249993 10.1592 0.249987 9.85463 0.27077C9.53753 0.292406 9.238 0.339049 8.94761 0.459332C8.27379 0.73844 7.73843 1.27379 7.45932 1.94762C7.31402 2.29842 7.27467 2.66812 7.25964 3.06996C7.24756 3.39299 7.08454 3.66251 6.84395 3.80141C6.60337 3.94031 6.28845 3.94673 6.00266 3.79568C5.64714 3.60777 5.30729 3.45699 4.93083 3.40743C4.20773 3.31223 3.47642 3.50819 2.89779 3.95219C2.64843 4.14353 2.45827 4.3796 2.28099 4.6434C2.11068 4.89681 1.92517 5.21815 1.70294 5.60307L1.67769 5.64681C1.45545 6.03172 1.26993 6.35304 1.13562 6.62723C0.995808 6.91267 0.886439 7.19539 0.845413 7.50701C0.750214 8.23012 0.946167 8.96142 1.39016 9.54005C1.62128 9.84125 1.92173 10.0602 2.26217 10.2741C2.53595 10.4461 2.68788 10.7221 2.68786 11C2.68785 11.2778 2.53592 11.5538 2.26217 11.7258C1.92169 11.9397 1.62121 12.1587 1.39007 12.4599C0.946069 13.0385 0.750116 13.7698 0.845315 14.4929C0.886341 14.8045 0.99571 15.0873 1.13552 15.3727C1.26983 15.6469 1.45535 15.9682 1.67758 16.3531L1.70284 16.3969C1.92507 16.7818 2.11058 17.1031 2.28089 17.3565C2.45817 17.6203 2.64833 17.8564 2.89769 18.0477C3.47632 18.4917 4.20763 18.6877 4.93073 18.5925C5.30717 18.5429 5.647 18.3922 6.0025 18.2043C6.28833 18.0532 6.60329 18.0596 6.8439 18.1986C7.08452 18.3375 7.24756 18.607 7.25964 18.9301C7.27467 19.3319 7.31403 19.7016 7.45932 20.0524C7.73843 20.7262 8.27379 21.2616 8.94761 21.5407C9.238 21.661 9.53753 21.7076 9.85463 21.7292C10.1592 21.75 10.5303 21.75 10.9747 21.75H11.0252C11.4697 21.75 11.8407 21.75 12.1454 21.7292C12.4625 21.7076 12.762 21.661 13.0524 21.5407C13.7262 21.2616 14.2616 20.7262 14.5407 20.0524C14.686 19.7016 14.7253 19.3319 14.7403 18.93C14.7524 18.607 14.9154 18.3375 15.156 18.1985C15.3966 18.0596 15.7116 18.0532 15.9974 18.2042C16.3529 18.3921 16.6927 18.5429 17.0692 18.5924C17.7923 18.6876 18.5236 18.4917 19.1022 18.0477C19.3516 17.8563 19.5417 17.6203 19.719 17.3565C19.8893 17.1031 20.0748 16.7818 20.297 16.3969L20.3223 16.3531C20.5445 15.9682 20.7301 15.6468 20.8644 15.3726C21.0042 15.0872 21.1135 14.8045 21.1546 14.4929C21.2498 13.7697 21.0538 13.0384 20.6098 12.4598C20.3787 12.1586 20.0782 11.9397 19.7378 11.7258C19.464 11.5538 19.3121 11.2778 19.3121 10.9999C19.3121 10.7221 19.464 10.4462 19.7377 10.2742C20.0783 10.0603 20.3788 9.84136 20.6099 9.54012C21.0539 8.96149 21.2499 8.23019 21.1547 7.50708C21.1136 7.19546 21.0043 6.91274 20.8645 6.6273C20.7302 6.35313 20.5447 6.03183 20.3224 5.64695L20.2972 5.60318C20.0749 5.21825 19.8894 4.89688 19.7191 4.64347C19.5418 4.37967 19.3517 4.1436 19.1023 3.95225C18.5237 3.50826 17.7924 3.3123 17.0692 3.4075C16.6928 3.45706 16.353 3.60782 15.9975 3.79572C15.7117 3.94679 15.3967 3.94036 15.1561 3.80144C14.9155 3.66253 14.7524 3.39297 14.7403 3.06991C14.7253 2.66808 14.686 2.2984 14.5407 1.94762C14.2616 1.27379 13.7262 0.73844 13.0524 0.459332C12.762 0.339049 12.4625 0.292406 12.1454 0.27077C11.8407 0.249987 11.4697 0.249993 11.0252 0.25H10.9747ZM9.52164 1.84515C9.59879 1.81319 9.71601 1.78372 9.95673 1.76729C10.2042 1.75041 10.5238 1.75 11 1.75C11.4762 1.75 11.7958 1.75041 12.0432 1.76729C12.284 1.78372 12.4012 1.81319 12.4783 1.84515C12.7846 1.97202 13.028 2.21536 13.1548 2.52165C13.1949 2.61826 13.228 2.76887 13.2414 3.12597C13.271 3.91835 13.68 4.68129 14.4061 5.10048C15.1321 5.51968 15.9974 5.4924 16.6984 5.12188C17.0143 4.9549 17.1614 4.90832 17.265 4.89467C17.5937 4.8514 17.9261 4.94047 18.1891 5.14228C18.2554 5.19312 18.3395 5.27989 18.4741 5.48016C18.6125 5.68603 18.7726 5.9626 19.0107 6.375C19.2488 6.78741 19.4083 7.06438 19.5174 7.28713C19.6235 7.50382 19.6566 7.62007 19.6675 7.70287C19.7108 8.03155 19.6217 8.36397 19.4199 8.62698C19.3562 8.70995 19.2424 8.81399 18.9397 9.00414C18.2684 9.42595 17.8122 10.1616 17.8121 10.9999C17.8121 11.8383 18.2683 12.574 18.9397 12.9959C19.2423 13.186 19.3561 13.29 19.4198 13.373C19.6216 13.636 19.7107 13.9684 19.6674 14.2971C19.6565 14.3799 19.6234 14.4961 19.5173 14.7128C19.4082 14.9355 19.2487 15.2125 19.0106 15.6249C18.7725 16.0373 18.6124 16.3139 18.474 16.5198C18.3394 16.72 18.2553 16.8068 18.189 16.8576C17.926 17.0595 17.5936 17.1485 17.2649 17.1053C17.1613 17.0916 17.0142 17.045 16.6983 16.8781C15.9973 16.5075 15.132 16.4803 14.4059 16.8995C13.68 17.3187 13.271 18.0816 13.2414 18.874C13.228 19.2311 13.1949 19.3817 13.1548 19.4784C13.028 19.7846 12.7846 20.028 12.4783 20.1549C12.4012 20.1868 12.284 20.2163 12.0432 20.2327C11.7958 20.2496 11.4762 20.25 11 20.25C10.5238 20.25 10.2042 20.2496 9.95673 20.2327C9.71601 20.2163 9.59879 20.1868 9.52164 20.1549C9.21535 20.028 8.97201 19.7846 8.84514 19.4784C8.80512 19.3817 8.77195 19.2311 8.75859 18.874C8.72896 18.0817 8.31997 17.3187 7.5939 16.8995C6.86784 16.4803 6.00262 16.5076 5.30158 16.8781C4.98565 17.0451 4.83863 17.0917 4.73495 17.1053C4.40626 17.1486 4.07385 17.0595 3.81084 16.8577C3.74458 16.8069 3.66045 16.7201 3.52586 16.5198C3.38751 16.314 3.22736 16.0374 2.98926 15.625C2.75115 15.2126 2.59171 14.9356 2.4826 14.7129C2.37646 14.4962 2.34338 14.3799 2.33248 14.2971C2.28921 13.9684 2.37828 13.636 2.5801 13.373C2.64376 13.2901 2.75761 13.186 3.0602 12.9959C3.73158 12.5741 4.18782 11.8384 4.18786 11.0001C4.18791 10.1616 3.73165 9.42587 3.06021 9.00398C2.75769 8.81389 2.64385 8.70987 2.58019 8.62691C2.37838 8.3639 2.28931 8.03149 2.33258 7.7028C2.34348 7.62001 2.37656 7.50375 2.4827 7.28707C2.59181 7.06431 2.75125 6.78734 2.98935 6.37493C3.22746 5.96253 3.3876 5.68596 3.52596 5.48009C3.66055 5.27983 3.74468 5.19305 3.81093 5.14222C4.07395 4.9404 4.40636 4.85133 4.73504 4.8946C4.83873 4.90825 4.98576 4.95483 5.30173 5.12184C6.00273 5.49235 6.86791 5.51962 7.59394 5.10045C8.31998 4.68128 8.72896 3.91837 8.75859 3.12602C8.77195 2.76889 8.80512 2.61827 8.84514 2.52165C8.97201 2.21536 9.21535 1.97202 9.52164 1.84515Z"
        fill="currentColor"
      />
      <path
        d="M15.9974 18.2042C15.7116 18.0532 15.3966 18.0596 15.156 18.1985C14.9154 18.3375 14.7524 18.607 14.7403 18.93C14.7253 19.3319 14.686 19.7016 14.5407 20.0524C14.2616 20.7262 13.7262 21.2616 13.0524 21.5407C12.762 21.661 12.4625 21.7076 12.1454 21.7292C11.8407 21.75 11.4697 21.75 11.0252 21.75H10.9747C10.5303 21.75 10.1592 21.75 9.85463 21.7292C9.53753 21.7076 9.238 21.661 8.94761 21.5407C8.27379 21.2616 7.73843 20.7262 7.45932 20.0524C7.31403 19.7016 7.27467 19.3319 7.25964 18.9301C7.24756 18.607 7.08452 18.3375 6.8439 18.1986C6.60329 18.0596 6.28833 18.0532 6.0025 18.2043C5.647 18.3922 5.30717 18.5429 4.93073 18.5925C4.20763 18.6877 3.47632 18.4917 2.89769 18.0477C2.64833 17.8564 2.45817 17.6203 2.28089 17.3565C2.11058 17.1031 1.92507 16.7818 1.70284 16.3969L1.67758 16.3531C1.45535 15.9682 1.26983 15.6469 1.13552 15.3727C0.99571 15.0873 0.886341 14.8045 0.845315 14.4929C0.750116 13.7698 0.946069 13.0385 1.39007 12.4599C1.62121 12.1587 1.92169 11.9397 2.26217 11.7258C2.53592 11.5538 2.68785 11.2778 2.68786 11C2.68788 10.7221 2.53595 10.4461 2.26217 10.2741C1.92173 10.0602 1.62128 9.84125 1.39016 9.54005C0.946167 8.96142 0.750214 8.23012 0.845413 7.50701C0.886439 7.19539 0.995808 6.91267 1.13562 6.62723C1.26993 6.35304 1.45545 6.03172 1.67769 5.64681L1.70294 5.60307C1.92517 5.21815 2.11068 4.89681 2.28099 4.6434C2.45827 4.3796 2.64843 4.14353 2.89779 3.95219C3.47642 3.50819 4.20773 3.31223 4.93083 3.40743C5.30729 3.45699 5.64714 3.60777 6.00266 3.79568C6.28845 3.94673 6.60337 3.94031 6.84395 3.80141C7.08454 3.66251 7.24756 3.39299 7.25964 3.06996C7.27467 2.66812 7.31402 2.29842 7.45932 1.94762C7.73843 1.27379 8.27379 0.73844 8.94761 0.459332C9.238 0.339049 9.53753 0.292406 9.85463 0.27077C10.1592 0.249987 10.5303 0.249993 10.9747 0.25H11.0252C11.4697 0.249993 11.8407 0.249987 12.1454 0.27077C12.4625 0.292406 12.762 0.339049 13.0524 0.459332M15.9974 18.2042L16.3479 17.5412M15.9974 18.2042C16.3529 18.3921 16.6927 18.5429 17.0692 18.5924C17.7923 18.6876 18.5236 18.4917 19.1022 18.0477C19.3516 17.8563 19.5417 17.6203 19.719 17.3565C19.8893 17.1031 20.0748 16.7818 20.297 16.3969L20.3223 16.3531C20.5445 15.9682 20.7301 15.6468 20.8644 15.3726C21.0042 15.0872 21.1135 14.8045 21.1546 14.4929C21.2498 13.7697 21.0538 13.0384 20.6098 12.4598M20.6098 12.4598L20.0148 12.9164M20.6098 12.4598C20.3787 12.1586 20.0782 11.9397 19.7378 11.7258C19.464 11.5538 19.3121 11.2778 19.3121 10.9999C19.3121 10.7221 19.464 10.4462 19.7377 10.2742C20.0783 10.0603 20.3788 9.84136 20.6099 9.54012C21.0539 8.96149 21.2499 8.23019 21.1547 7.50708C21.1136 7.19546 21.0043 6.91274 20.8645 6.6273C20.7302 6.35313 20.5447 6.03183 20.3224 5.64695L20.2972 5.60318C20.0749 5.21825 19.8894 4.89688 19.7191 4.64347C19.5418 4.37967 19.3517 4.1436 19.1023 3.95225C18.5237 3.50826 17.7924 3.3123 17.0692 3.4075C16.6928 3.45706 16.353 3.60782 15.9975 3.79572C15.7117 3.94679 15.3967 3.94036 15.1561 3.80144C14.9155 3.66253 14.7524 3.39297 14.7403 3.06991C14.7253 2.66808 14.686 2.2984 14.5407 1.94762C14.2616 1.27379 13.7262 0.73844 13.0524 0.459332M13.0524 0.459332L12.7654 1.15224M3.06021 9.00398C3.73165 9.42587 4.18791 10.1616 4.18786 11.0001C4.18782 11.8384 3.73158 12.5741 3.0602 12.9959C2.75761 13.186 2.64376 13.2901 2.5801 13.373C2.37828 13.636 2.28921 13.9684 2.33248 14.2971C2.34338 14.3799 2.37646 14.4962 2.4826 14.7129C2.59171 14.9356 2.75115 15.2126 2.98926 15.625C3.22736 16.0374 3.38751 16.314 3.52586 16.5198C3.66045 16.7201 3.74458 16.8069 3.81084 16.8577C4.07385 17.0595 4.40626 17.1486 4.73495 17.1053C4.83863 17.0917 4.98565 17.0451 5.30158 16.8781C6.00262 16.5076 6.86784 16.4803 7.5939 16.8995C8.31997 17.3187 8.72896 18.0817 8.75859 18.874C8.77195 19.2311 8.80512 19.3817 8.84514 19.4784C8.97201 19.7846 9.21535 20.028 9.52164 20.1549C9.59879 20.1868 9.71601 20.2163 9.95673 20.2327C10.2042 20.2496 10.5238 20.25 11 20.25C11.4762 20.25 11.7958 20.2496 12.0432 20.2327C12.284 20.2163 12.4012 20.1868 12.4783 20.1549C12.7846 20.028 13.028 19.7846 13.1548 19.4784C13.1949 19.3817 13.228 19.2311 13.2414 18.874C13.271 18.0816 13.68 17.3187 14.4059 16.8995C15.132 16.4803 15.9973 16.5075 16.6983 16.8781C17.0142 17.045 17.1613 17.0916 17.2649 17.1053C17.5936 17.1485 17.926 17.0595 18.189 16.8576C18.2553 16.8068 18.3394 16.72 18.474 16.5198C18.6124 16.3139 18.7725 16.0373 19.0106 15.6249C19.2487 15.2125 19.4082 14.9355 19.5173 14.7128C19.6234 14.4961 19.6565 14.3799 19.6674 14.2971C19.7107 13.9684 19.6216 13.636 19.4198 13.373C19.3561 13.29 19.2423 13.186 18.9397 12.9959C18.2683 12.574 17.8121 11.8383 17.8121 10.9999C17.8122 10.1616 18.2684 9.42595 18.9397 9.00414C19.2424 8.81399 19.3562 8.70995 19.4199 8.62698C19.6217 8.36397 19.7108 8.03155 19.6675 7.70287C19.6566 7.62007 19.6235 7.50382 19.5174 7.28713C19.4083 7.06438 19.2488 6.78741 19.0107 6.375C18.7726 5.9626 18.6125 5.68603 18.4741 5.48016C18.3395 5.27989 18.2554 5.19312 18.1891 5.14228C17.9261 4.94047 17.5937 4.8514 17.265 4.89467C17.1614 4.90832 17.0143 4.9549 16.6984 5.12188C15.9974 5.4924 15.1321 5.51968 14.4061 5.10048C13.68 4.68129 13.271 3.91835 13.2414 3.12597C13.228 2.76887 13.1949 2.61826 13.1548 2.52165C13.028 2.21536 12.7846 1.97202 12.4783 1.84515C12.4012 1.81319 12.284 1.78372 12.0432 1.76729C11.7958 1.75041 11.4762 1.75 11 1.75C10.5238 1.75 10.2042 1.75041 9.95673 1.76729C9.71601 1.78372 9.59879 1.81319 9.52164 1.84515C9.21535 1.97202 8.97201 2.21536 8.84514 2.52165M3.06021 9.00398L2.66119 9.63902M3.06021 9.00398C2.75769 8.81389 2.64385 8.70987 2.58019 8.62691C2.37838 8.3639 2.28931 8.03149 2.33258 7.7028C2.34348 7.62001 2.37656 7.50375 2.4827 7.28707C2.59181 7.06431 2.75125 6.78734 2.98935 6.37493C3.22746 5.96253 3.3876 5.68596 3.52596 5.48009C3.66055 5.27983 3.74468 5.19305 3.81093 5.14222C4.07395 4.9404 4.40636 4.85133 4.73504 4.8946C4.83873 4.90825 4.98576 4.95483 5.30173 5.12184C6.00273 5.49235 6.86791 5.51962 7.59394 5.10045C8.31998 4.68128 8.72896 3.91837 8.75859 3.12602C8.77195 2.76889 8.80512 2.61827 8.84514 2.52165M8.84514 2.52165L8.15223 2.23463M11 8.75C9.75736 8.75 8.75 9.75736 8.75 11C8.75 12.2426 9.75736 13.25 11 13.25C12.2426 13.25 13.25 12.2426 13.25 11C13.25 9.75736 12.2426 8.75 11 8.75ZM7.25 11C7.25 8.92893 8.92894 7.25 11 7.25C13.0711 7.25 14.75 8.92893 14.75 11C14.75 13.0711 13.0711 14.75 11 14.75C8.92894 14.75 7.25 13.0711 7.25 11Z"
        stroke="currentColor"
        strokeWidth="0.3"
      />
    </svg>
  );
};
export const SyncSvg = () => {
  return (
    <svg
      width="22"
      height="20"
      viewBox="0 0 22 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.67981 9.33333L1.72981 9.33333L1.72981 9.33333L2.67981 9.33333ZM2.67981 11L2.0107 11.6744C2.38109 12.0419 2.97853 12.0419 3.34892 11.6744L2.67981 11ZM5.02873 10.0077C5.40118 9.63818 5.40355 9.03668 5.03401 8.66423C4.66447 8.29177 4.06297 8.28941 3.69052 8.65895L5.02873 10.0077ZM1.66911 8.65895C1.29666 8.28941 0.695153 8.29177 0.325615 8.66423C-0.0439229 9.03668 -0.0415601 9.63818 0.330892 10.0077L1.66911 8.65895ZM17.4452 5.49753C17.72 5.9445 18.3051 6.08408 18.752 5.8093C19.199 5.53452 19.3386 4.94943 19.0638 4.50247L17.4452 5.49753ZM11.0789 0.05C5.92258 0.05 1.72981 4.19927 1.72981 9.33333H3.62981C3.62981 5.26265 6.95782 1.95 11.0789 1.95V0.05ZM1.72981 9.33333L1.72981 11L3.62981 11L3.62981 9.33333L1.72981 9.33333ZM3.34892 11.6744L5.02873 10.0077L3.69052 8.65895L2.0107 10.3256L3.34892 11.6744ZM3.34892 10.3256L1.66911 8.65895L0.330892 10.0077L2.0107 11.6744L3.34892 10.3256ZM19.0638 4.50247C17.4223 1.83238 14.4591 0.05 11.0789 0.05V1.95C13.7765 1.95 16.1374 3.37034 17.4452 5.49753L19.0638 4.50247Z"
        fill="currentColor"
      />
      <path
        d="M19.3139 9L19.9817 8.32434C19.6116 7.95855 19.0162 7.95855 18.6461 8.32434L19.3139 9ZM16.9598 9.99101C16.5867 10.3598 16.5832 10.9613 16.952 11.3345C17.3208 11.7076 17.9223 11.7112 18.2955 11.3423L16.9598 9.99101ZM20.3323 11.3423C20.7055 11.7112 21.307 11.7076 21.6758 11.3345C22.0446 10.9613 22.0411 10.3598 21.668 9.99101L20.3323 11.3423ZM4.48813 14.5011C4.21259 14.0546 3.62727 13.916 3.18078 14.1916C2.73428 14.4671 2.5957 15.0524 2.87124 15.4989L4.48813 14.5011ZM10.8827 19.95C16.0533 19.95 20.2639 15.8041 20.2639 10.6667H18.3639C18.3639 14.7339 15.0249 18.05 10.8827 18.05V19.95ZM20.2639 10.6667V9H18.3639V10.6667H20.2639ZM18.6461 8.32434L16.9598 9.99101L18.2955 11.3423L19.9817 9.67566L18.6461 8.32434ZM18.6461 9.67566L20.3323 11.3423L21.668 9.99101L19.9817 8.32434L18.6461 9.67566ZM2.87124 15.4989C4.51915 18.1692 7.49254 19.95 10.8827 19.95V18.05C8.17173 18.05 5.80075 16.6281 4.48813 14.5011L2.87124 15.4989Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const SyncVendor = () => {
  return (
    <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" width="22"
      height="20" fill="#ffffff">
      <path d="M269.441 32.892l47.581-.219 23.577-.108 20.018-.077 10.184-.047 11.008-.024 3.247-.05c7.212.061 7.212.061 11.038 3.05L398 38l1.694 1.922 1.505 1.828 1.709 2.073L404.687 46l1.875 2.285c4.404 5.391 8.669 10.87 12.883 16.41 2.921 3.81 5.955 7.525 8.992 11.242l18.896 23.771 4.041 5.166 1.353 1.728c4.095 5.211 8.28 10.347 12.506 15.453l3.067 3.823c1.234 1.54 2.525 3.035 3.847 4.5 5.988 7.131 7.004 13.281 6.675 22.353-.073 2.068-.082 4.129-.081 6.199-.195 18.515-6.53 35.069-19.648 48.271C451.074 214.755 439.259 223 428 223l1 20 4.375-1.25c6.698-1.914 12.435 1.55 18.259 4.654l8.366 4.909 6.297 3.734 3.295 1.955 10.611 6.076 3.566 2.018 6.852 3.84 3.145 1.786 2.774 1.555c3.339 2.338 5.638 5.078 7.46 8.722.123 2.239.18 4.483.209 6.725l.03 2.095.07 6.879.02 2.375.077 12.454.103 10.292.101 12.437.057 4.73c.245 13.878.245 13.878-3.337 18.305-2.81 2.543-5.875 4.571-9.195 6.399l-3.4 1.904-3.607 1.967-3.725 2.077-5.716 3.186c-6.454 3.583-12.821 7.308-19.184 11.049l-5.844 3.43-2.443 1.437c-3.745 2.13-6.346 3.538-10.713 3.508l-2.281.016C433 392 433 392 429 390l-1 23 6.25-.25c11.3.057 19.449 2.793 27.617 10.738 6.72 7.914 8.512 15.993 8.41 26.125-.671 8.193-4.577 15.523-10.277 21.387-6.851 5.535-13.121 8.247-22.02 8.257l-2.079.011h-6.893l-4.993.014-13.72.01-14.798.02-28.992.023-23.566.011-66.811.025h-3.639-3.643c-19.483-.001-38.966.018-58.449.047l-60.011.041c-11.231-.001-22.462.005-33.693.026l-28.688.009c-4.878-.007-9.756-.007-14.634.011-4.469.016-8.937.013-13.405-.005a549.25 549.25 0 0 0-4.841.012c-11.561.075-22.42-1.126-31.125-9.511-6.493-7.856-9.623-16.036-9.281-26.234.934-9.185 4.307-16.307 11.203-22.488C37.934 411.803 48.003 413 64 413V225l-14-3c-17.161-6.155-29.991-19.689-37.715-35.961C8.69 177.537 7.35 169.183 7 160l-.083-2.076-.167-6.737-.065-2.137c-.052-8.369 3.391-13.671 8.753-19.613l3.234-3.68 1.67-1.882 7.846-9.063 1.523-1.774 8.727-10.476c5.154-6.345 10.536-12.488 15.903-18.653l18.097-21.347c5.183-6.384 10.586-12.576 16.005-18.76l3.181-3.777 1.583-1.916 1.409-1.735c2.749-2.73 5.915-2.507 9.559-2.532l3.265-.03 3.599-.017 3.811-.03 10.482-.068 8.967-.06 29.451-.184 7.653-.044 60.73-.317 37.307-.199zM205.5 50.5l-2.044.036L179 51l-.499 2.035-2.298 9.301-.785 3.199c-5.692 22.936-14.118 44.846-26.801 64.86-1.705 2.236-1.705 2.236-1.617 3.605h189c-1.456-3.641-2.942-6.72-4.919-10.06-11.48-19.47-18.88-40.65-24.257-62.514l-.829-3.343L304 50l-28.187-.062-2.145-.003a3626.02 3626.02 0 0 0-68.167.565zM321 50c3.105 14.704 3.105 14.704 7.5 29.063l1.014 2.867C336.055 99.819 344.277 120.277 358 134a120.36 120.36 0 0 0 8.764.227l2.75.001 9.025-.033 6.247-.009 16.463-.049 16.79-.04L451 134c-1.289-2.638-2.578-4.901-4.434-7.18l-1.449-1.793-1.555-1.903-3.281-4.059-1.672-2.066-7.047-8.938-12.125-15.125L408 78.5c-5.827-7.639-11.889-15.087-18-22.5l-1.781-3.19c-1.981-2.347-3.067-2.783-6.139-3.332-3.865-.174-7.703-.153-11.569-.064l-4.283.026-11.24.148-11.483.119L321 50zM96 61l-4.25 5.188-2.242 2.77c-3.448 4.183-7.007 8.264-10.567 12.352L67.099 95.151l-10.224 11.974a683.12 683.12 0 0 0-12.828 15.391c-2.535 3.077-5.165 6.06-7.832 9.023-1.321 1.272-1.321 1.272-1.215 2.461l35.128.674 16.313.307 15.756.253 5.998.141c10.236.751 10.236.751 19.52-2.646 3.276-3.461 5.281-7.418 7.285-11.729l2.566-4.137 1.996-3.551 1.113-2.014c6.501-11.982 11.503-24.269 15.699-37.236l1.012-3.121c2.064-6.594 3.44-13.137 4.613-19.942l-21.829-.518-10.139-.236-11.684-.222-3.637-.156C105.07 49.861 101.478 53.39 96 61zm-72 90c0 17.502 2.926 31.827 15.484 44.813 11.808 10.268 24.39 13.191 39.574 12.356C91.372 207.1 101.765 199.793 110 191c9.853-12.829 11-23.71 11-40H24zm114 0c0 17.703 1.2 30.145 13.031 43.25 11.189 10.703 24.38 14.397 39.445 14.063 11.078-.555 20.113-5.405 28.211-12.75L221 193l1.457-1.48C233.392 179.865 234 166.463 234 151h-96zm113 0c0 18.043 1.945 30.826 14.375 43.813 10.363 9.794 21.766 13.827 35.97 13.66 10.725-.416 19.173-4.009 27.655-10.472l3.125-2.25c8.029-7.68 12.711-16.932 14.875-27.75v-17h-96zm113 0c0 19.146 2.722 31.145 15.91 45.008 10.15 9.629 23.182 12.631 36.797 12.301 12.492-.663 24.255-7.31 32.734-16.359C459.94 178.82 461 168.13 461 151h-97zm-235 42l-3.388 4.521C113.85 213.341 99.831 219.864 81 225v188h68l2-18c5.358-19.288 14.794-34.53 32.211-45.002 13.553-7.559 27.429-9.31 42.777-9.298l3.944-.013 8.211-.002 10.386-.034 10.084-.013 3.695-.028c20.748.109 39.245 6.506 54.567 20.766C330.499 376.01 334.39 393.674 336 413h75v-34c-8.661-7.113-8.661-7.113-17.805-11.57-4.996-1.931-9.483-4.079-14.008-6.93l-2.895-1.656c-3.719-2.991-5.125-6.402-5.674-11.106l-.007-3.565-.016-1.983.006-6.439-.009-4.505.016-9.421-.011-12.044v-9.296l-.007-4.44.021-6.216.007-3.565c.566-4.849 2.167-8.139 5.743-11.449 2.559-1.76 5.122-3.338 7.841-4.837l2.973-1.656 3.074-1.695 8.934-5.034C402 260 402 260 404.72 258.772c2.699-1.368 4.383-2.404 6.28-4.772 1.088-4.979.852-9.822.563-14.875l-.123-4.109L411 225l-2.81-.361c-17-2.284-33.886-8.011-44.964-21.971l-2.602-3.48-1.363-1.811L356 193l-1.687 2.137C342.51 209.75 329.318 221.212 310 224c-20.633 1.356-38.767-1.833-54.875-15.812-4.808-4.583-8.617-9.561-12.125-15.187-2.676 2.572-4.912 5.169-7.062 8.188-7.443 9.608-16.699 15.468-27.937 19.813l-2.496 1.031c-15.234 5.265-33.501 2.867-47.891-3.539-11.261-5.624-19.063-13.055-26.117-23.402L130 193h-1zm302.082 68.746l-3.033 1.777-3.236 1.915-3.271 1.922L397 282c3.267 2.748 6.417 4.889 10.246 6.77l3.014 1.498 6.466 3.115c9.327 4.485 9.327 4.485 13.156 7.414 3.646 2.598 5.629 3.838 10.117 4.203 7.386-2.477 13.867-6.956 20.31-11.241 3.587-2.345 7.302-4.401 11.065-6.446 4.018-1.977 4.018-1.977 6.625-5.312l-15.721-9.073-1.79-1.031-3.554-2.048-9.709-5.626-3.727-2.16-3.156-1.84c-4.023-2.099-5.534-.67-9.262 1.523zM387 297v49l12.063 6.938L428 370c2.437-2.437 2.295-3.198 2.446-6.554l.138-2.863.111-3.103.116-3.184.206-6.68.428-10.212.188-6.486.172-3.084c.042-2.825-.008-5.121-.805-7.834-2.359-2.414-4.924-3.678-8-5l-2.49-1.359-2.104-1.036-2.437-1.209-2.469-1.209-4.844-2.395L403 305l-16-8zm94.555 3.309l-2.743 1.5-5.917 3.295c-4.572 2.551-9.117 5.05-13.874 7.24l-2.236 1.084c-1.355.653-2.73 1.268-4.122 1.837-2.19.974-2.19.974-4.662 3.735-1.051 4.306-.974 8.585-1 13l-.15 4.524-.412 14.789-.131 5.17L446 369c3.703-1.396 7.087-3.072 10.535-5.012l3.205-1.799 3.322-1.877 3.24-1.818 6.447-3.732C476 353 476 353 479.458 351.841c3.914-1.505 5.903-2.547 8.542-5.841 2.033-7.89 1.118-16.385.75-24.437l-.164-6.842L488 298c-2.681 0-4.095 1.015-6.445 2.309zm-304.332 76.66C168.508 387.791 166 399.412 166 413h20l3-8c3.489-2.326 4.897-2.419 9-2 2.313 1.063 2.313 1.063 4 3l1 7h79l2-8c3.489-2.326 4.905-2.251 9-2l4 1 2 9h20c0-15.792-3.877-29.373-15-41-13.78-11.891-27.66-15.314-45.461-15.301l-3.839-.013-8.003-.002a1184.66 1184.66 0 0 1-10.152-.034l-9.819-.013-3.628-.028c-18.578.101-33.399 6.54-45.876 20.36zM37 434c-4.163 5.23-5.556 9.329-5 16 2.126 5.534 5.664 9.332 11 12a145.28 145.28 0 0 0 6.461.134l2.043.007 6.844.006 4.93.011 13.599.016 14.647.022 35.397.039 16.656.015 55.346.039 14.37.006 3.608.001 57.886.066 59.387.054 33.361.036 28.406.02 14.499.017 13.268.001 4.805.014 6.524-.01 3.663.003c5.127-.773 8.2-3.278 11.614-7.06 2.914-4.209 3.454-8.439 2.688-13.437-2.113-5.461-4.968-8.561-10.311-11.141-5.959-1.903-12.394-1.405-18.593-1.367l-4.891-.019c-4.47-.017-8.94-.008-13.41.004-4.825.009-9.65-.005-14.475-.016l-28.344-.002-23.036.006-3.312-.002-6.66-.004c-20.818-.011-41.636.002-62.454.023-17.863.018-35.725.015-53.588-.004l-62.231-.018-6.636.004-3.298.002c-7.669.003-15.338-.002-23.008-.012a8057.36 8057.36 0 0 0-28.039.013l-14.306.001a1722.68 1722.68 0 0 0-13.098.016c-1.579.004-3.157.002-4.736-.008C47.19 429.38 47.19 429.38 37 434zm246.688-195.75c10.853 11.287 16.192 25.701 16.348 41.27-.752 16.638-7.291 31.34-19.539 42.672-11.374 9.689-26.562 14.409-41.34 13.598-15.806-1.428-29.165-7.809-40.207-19.367-11.739-14.586-14.499-30.11-12.95-48.423 2.39-13.926 10.085-26.152 21-35 7.646-5.399 15.736-9.331 25-11l2.34-.461c18.368-2.751 36.093 4.164 49.348 16.711zm-69.871 11.805c-9.132 9.78-11.602 19.808-11.164 32.848.335 5.27 1.738 9.514 4.348 14.098l1.25 2.32c5.88 9.856 14.721 15.879 25.75 18.68 10.292 2.387 20.934.217 29.938-5.187 9.443-6.628 15.708-15.406 18.438-26.687 1.717-10.536-.178-20.497-5.879-29.5-7.207-9.899-16.053-15.646-28.031-18.156-13.049-1.82-25.11 2.684-34.648 11.586z" />
    </svg>

  );
};
export const EmailSvg = () => {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width="256.000000pt"
      height="256.000000pt"
      viewBox="0 0 256.000000 256.000000"
      preserveAspectRatio="xMidYMid meet"
    >
      <g
        transform="translate(0.000000,256.000000) scale(0.100000,-0.100000)"
        fill="CurrentColor"
        stroke="none"
      >
        <path d="M45 2289 c-46 -26 -45 -4 -45 -746 l0 -704 25 -24 24 -25 695 0 c498 0 702 3 720 11 35 16 47 57 30 97 -7 18 -14 33 -16 34 -2 2 -300 5 -664 8 l-661 5 285 235 c156 129 288 236 293 238 4 2 81 -53 170 -122 120 -94 168 -126 189 -126 28 0 86 40 278 192 40 32 76 58 80 58 4 0 59 -43 122 -96 63 -52 125 -99 138 -104 49 -20 109 33 96 85 -4 17 -43 57 -116 117 -60 50 -108 94 -106 99 2 5 102 86 223 180 l220 171 5 -257 c5 -255 5 -257 29 -276 30 -25 76 -24 101 1 19 19 20 33 20 468 0 444 0 449 -21 468 -20 18 -54 19 -1058 21 -739 2 -1042 -1 -1056 -8z m1985 -181 l-1 -43 -406 -315 c-223 -173 -434 -337 -469 -363 l-63 -49 -470 366 -471 367 0 39 0 40 940 0 940 0 0 -42z m-1423 -589 c-1 -4 -96 -84 -212 -179 -116 -95 -218 -180 -227 -188 -17 -14 -18 3 -18 356 l0 372 229 -178 c127 -97 229 -180 228 -183z" />
        <path d="M2014 1156 c-161 -37 -287 -152 -335 -307 -13 -42 -19 -91 -19 -157 l0 -96 -32 31 c-37 35 -69 53 -93 53 -28 0 -65 -46 -65 -81 0 -28 16 -48 113 -146 151 -151 143 -151 294 0 102 102 113 116 113 149 0 28 -7 42 -26 57 -38 30 -59 26 -110 -21 l-46 -43 4 105 c3 93 7 111 33 158 94 173 328 209 468 74 66 -63 91 -124 91 -217 0 -92 -20 -143 -83 -208 -48 -51 -99 -76 -184 -91 -57 -9 -74 -16 -90 -39 -25 -33 -16 -69 24 -99 24 -18 32 -19 100 -9 342 54 501 439 295 718 -100 136 -287 206 -452 169z" />
      </g>
    </svg>
  );
};
export const ImageSvg = () => {
  return (
    <>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <mask
          id="mask0_445_8"
          maskUnits="userSpaceOnUse"
          x="1"
          y="1"
          width="18"
          height="18"
        >
          <path
            d="M1 9C1 5.22876 1 3.34315 2.17157 2.17157C3.34315 1 5.22876 1 9 1H11C14.7712 1 16.6569 1 17.8284 2.17157C19 3.34315 19 5.22876 19 9V11C19 14.7712 19 16.6569 17.8284 17.8284C16.6569 19 14.7712 19 11 19H9C5.22876 19 3.34315 19 2.17157 17.8284C1 16.6569 1 14.7712 1 11V9Z"
            fill="currentColor"
          ></path>
        </mask>
        <g mask="url(#mask0_445_8)">
          <path
            d="M3.40989 10.5901L3.25713 10.7429C2.27646 11.7235 1.78613 12.2139 1.49264 12.8158C1.39066 13.025 1.30712 13.2427 1.24299 13.4664C1.05843 14.1102 1.09488 14.8027 1.16777 16.1877L1.5 22.5H19V17.7573C19 16.3059 19 15.5802 18.7614 14.9207C18.6962 14.7404 18.6181 14.565 18.5277 14.3959C18.1971 13.7774 17.6577 13.2919 16.5789 12.321L16.3643 12.1279C15.4682 11.3214 15.0202 10.9182 14.5078 10.8039C14.1864 10.7322 13.8523 10.741 13.5352 10.8295C13.0295 10.9705 12.6033 11.3967 11.7508 12.2492C11.1184 12.8816 10.8023 13.1977 10.4625 13.2406C10.2519 13.2672 10.0383 13.226 9.8526 13.1231C9.55307 12.9572 9.37424 12.5399 9.01657 11.7053C8.25588 9.9304 7.87554 9.04293 7.22167 8.71514C6.89249 8.55011 6.52413 8.47917 6.1572 8.51014C5.42836 8.57164 4.75554 9.24446 3.40989 10.5901L3.40989 10.5901Z"
            fill="currentColor"
            fillOpacity="0.25"
            stroke="currentColor"
          ></path>
        </g>
        <path
          d="M1 9C1 5.22876 1 3.34315 2.17157 2.17157C3.34315 1 5.22876 1 9 1H11C14.7712 1 16.6569 1 17.8284 2.17157C19 3.34315 19 5.22876 19 9V11C19 14.7712 19 16.6569 17.8284 17.8284C16.6569 19 14.7712 19 11 19H9C5.22876 19 3.34315 19 2.17157 17.8284C1 16.6569 1 14.7712 1 11V9Z"
          stroke="currentColor"
          strokeWidth="1.2"
        ></path>
        <circle cx="14.5" cy="5.5" r="1.5" fill="currentColor"></circle>
      </svg>
    </>
  );
};
export const FileImageSvg = () => {
  return (
    <>
      <svg
        width="34"
        height="35"
        viewBox="0 0 34 35"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.75 19.25C3.75 18.8358 4.08579 18.5 4.5 18.5H10.75C11.1642 18.5 11.5 18.8358 11.5 19.25C11.5 19.6642 11.1642 20 10.75 20H4.5C4.08579 20 3.75 19.6642 3.75 19.25Z"
          fill="#002E70"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.15317 27.25C4.15317 26.8358 4.48896 26.5 4.90317 26.5H8.84676C9.26097 26.5 9.59676 26.8358 9.59676 27.25C9.59676 27.6642 9.26097 28 8.84676 28H4.90317C4.48896 28 4.15317 27.6642 4.15317 27.25Z"
          fill="#002E70"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.86402 23.25C3.86402 22.8358 4.1998 22.5 4.61402 22.5H10.1362C10.5504 22.5 10.8862 22.8358 10.8862 23.25C10.8862 23.6642 10.5504 24 10.1362 24H7.68201H4.61402C4.1998 24 3.86402 23.6642 3.86402 23.25Z"
          fill="#002E70"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.77977 1.50005C9.91196 1.50005 10.5396 1.50598 11 1.58422V3.80374C11 4.93657 10.9999 5.8623 11.0982 6.59317C11.2009 7.35712 11.4232 8.01945 11.9519 8.54815C12.4806 9.07684 13.1429 9.29912 13.9069 9.40183C14.6377 9.5001 15.5635 9.50008 16.6963 9.50005H19.8262C19.9892 10.0488 20 10.7769 20 12.3129H21.5L21.5 12.1449C21.5005 10.5529 21.5008 9.52345 21.0891 8.59902C20.6774 7.67458 19.912 6.98614 18.7283 5.92149L18.6034 5.80912L14.6447 2.24623L14.5373 2.14955C13.5131 1.22735 12.8512 0.631288 12.0279 0.315354C11.2046 -0.000584334 10.31 -0.000345265 8.92544 2.48795e-05L8.77977 5.06883e-05L8.7235 5.03307e-05C6.87568 3.47143e-05 5.41281 2.23219e-05 4.26885 0.153125C3.09229 0.310591 2.14016 0.642346 1.39121 1.39129C0.642851 2.13966 0.310733 3.08861 0.153105 4.26103C-5.86659e-05 5.40024 -4.60508e-05 6.85587 -3.0196e-05 8.69363V12.8065C-4.60508e-05 14.6442 0.153141 26.5998 0.306305 27.739C0.463933 28.9114 0.796049 29.8604 1.54441 30.6088C2.29278 31.3571 3.24172 31.6892 4.41415 31.8469C5.55336 32 7.009 32 8.84676 32H11.5V31.25V30.5H8.90317C6.99635 30.5 5.64168 30.4984 4.61402 30.3602C3.60793 30.225 3.02828 29.9713 2.60507 29.5481C2.18186 29.1249 1.92819 28.5452 1.79293 27.5392C1.65476 26.5115 1.49997 14.6569 1.49997 12.7501V8.75005C1.49997 6.84323 1.50156 5.48856 1.63973 4.4609C1.775 3.45481 2.02867 2.87516 2.45188 2.45195C2.8745 2.02933 3.45594 1.7753 4.46783 1.63987C5.50072 1.50163 6.86309 1.50005 8.77977 1.50005ZM12.5 2.3595V3.75005C12.5 4.94976 12.5016 5.7741 12.5848 6.39329C12.6652 6.99091 12.809 7.28395 13.0125 7.48749C13.2161 7.69103 13.5091 7.83486 14.1067 7.91521C14.7259 7.99846 15.5503 8.00005 16.75 8.00005H18.7695C18.473 7.7125 18.0932 7.36797 17.6 6.92407L13.6412 3.36117C13.1558 2.92433 12.7946 2.60187 12.5 2.3595Z"
          fill="#002E70"
        />
        <path
          d="M22.6926 13H22.8074C25.1158 13 26.9248 13 28.3363 13.1897C29.781 13.384 30.9211 13.7893 31.8159 14.6841C32.7107 15.5789 33.116 16.719 33.3103 18.1637C33.5 19.5752 33.5 21.3842 33.5 23.6926V23.7809C33.5 25.6897 33.5 27.2523 33.3963 28.5245C33.2922 29.8031 33.0787 30.8714 32.6009 31.7587C32.3901 32.1501 32.1312 32.5006 31.8159 32.8159C30.9211 33.7107 29.781 34.116 28.3363 34.3103C26.9248 34.5 25.1158 34.5 22.8074 34.5H22.6926C20.3842 34.5 18.5752 34.5 17.1637 34.3103C15.719 34.116 14.5789 33.7107 13.6841 32.8159C12.8909 32.0226 12.4812 31.0352 12.2634 29.8104C12.0493 28.6073 12.0102 27.1103 12.0021 25.2515C12 24.7787 12 24.2786 12 23.751V23.6926C12 21.3842 12 19.5752 12.1897 18.1637C12.384 16.719 12.7893 15.5789 13.6841 14.6841C14.5789 13.7893 15.719 13.384 17.1637 13.1897C18.5752 13 20.3842 13 22.6926 13ZM17.3636 14.6764C16.0852 14.8482 15.3145 15.1751 14.7448 15.7448C14.1751 16.3145 13.8482 17.0852 13.6764 18.3636C13.5016 19.6636 13.5 21.3718 13.5 23.75C13.5 24.0405 13.5 24.3215 13.5003 24.5935L14.5015 23.7175C15.4127 22.9202 16.7862 22.9659 17.6424 23.8221L21.9321 28.1118C22.6193 28.7991 23.7011 28.8928 24.4963 28.3339L24.7945 28.1244C25.9387 27.3202 27.4868 27.4134 28.5264 28.349L31.3568 30.8963C31.6417 30.298 31.8109 29.5118 31.9013 28.4027C31.9994 27.1982 32 25.6959 32 23.75C32 21.3718 31.9984 19.6636 31.8236 18.3636C31.6518 17.0852 31.3249 16.3145 30.7552 15.7448C30.1855 15.1751 29.4148 14.8482 28.1364 14.6764C26.8364 14.5016 25.1282 14.5 22.75 14.5C20.3718 14.5 18.6636 14.5016 17.3636 14.6764ZM28.75 19.75C28.75 20.8546 27.8546 21.75 26.75 21.75C25.6454 21.75 24.75 20.8546 24.75 19.75C24.75 18.6454 25.6454 17.75 26.75 17.75C27.8546 17.75 28.75 18.6454 28.75 19.75Z"
          fill="#9bd732"
        />
        <path d="M22.6926 13H22.8074C25.1158 13 26.9248 13 28.3363 13.1897C29.781 13.384 30.9211 13.7893 31.8159 14.6841C32.7107 15.5789 33.116 16.719 33.3103 18.1637C33.5 19.5752 33.5 21.3842 33.5 23.6926V23.7809C33.5 25.6897 33.5 27.2523 33.3963 28.5245C33.2922 29.8031 33.0787 30.8714 32.6009 31.7587C32.3901 32.1501 32.1312 32.5006 31.8159 32.8159C30.9211 33.7107 29.781 34.116 28.3363 34.3103C26.9248 34.5 25.1158 34.5 22.8074 34.5H22.6926C20.3842 34.5 18.5752 34.5 17.1637 34.3103C15.719 34.116 14.5789 33.7107 13.6841 32.8159C12.8909 32.0226 12.4812 31.0352 12.2634 29.8104C12.0493 28.6073 12.0102 27.1103 12.0021 25.2515C12 24.7787 12 24.2786 12 23.751V23.6926C12 21.3842 12 19.5752 12.1897 18.1637C12.384 16.719 12.7893 15.5789 13.6841 14.6841C14.5789 13.7893 15.719 13.384 17.1637 13.1897C18.5752 13 20.3842 13 22.6926 13ZM17.3636 14.6764C16.0852 14.8482 15.3145 15.1751 14.7448 15.7448C14.1751 16.3145 13.8482 17.0852 13.6764 18.3636C13.5016 19.6636 13.5 21.3718 13.5 23.75C13.5 24.0405 13.5 24.3215 13.5003 24.5935L14.5015 23.7175C15.4127 22.9202 16.7862 22.9659 17.6424 23.8221L21.9321 28.1118C22.6193 28.7991 23.7011 28.8928 24.4963 28.3339L24.7945 28.1244C25.9387 27.3202 27.4868 27.4134 28.5264 28.349L31.3568 30.8963C31.6417 30.298 31.8109 29.5118 31.9013 28.4027C31.9994 27.1982 32 25.6959 32 23.75C32 21.3718 31.9984 19.6636 31.8236 18.3636C31.6518 17.0852 31.3249 16.3145 30.7552 15.7448C30.1855 15.1751 29.4148 14.8482 28.1364 14.6764C26.8364 14.5016 25.1282 14.5 22.75 14.5C20.3718 14.5 18.6636 14.5016 17.3636 14.6764ZM28.75 19.75C28.75 20.8546 27.8546 21.75 26.75 21.75C25.6454 21.75 24.75 20.8546 24.75 19.75C24.75 18.6454 25.6454 17.75 26.75 17.75C27.8546 17.75 28.75 18.6454 28.75 19.75Z" />
      </svg>
    </>
  );
};

export const ThumbnailSvg = () => {
  return (
    <>
      <svg
        width="42"
        height="42"
        viewBox="0 0 42 42"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.81786 0.839774C1.38772 1.03196 0.85692 1.54446 0.673884 1.94714C0.518304 2.2766 0.5 2.59692 0.5 5.10451C0.5 8.21612 0.518304 8.32594 1.14978 8.9208C1.62567 9.36924 2.07411 9.51567 3.18147 9.57058L4.16071 9.61634V11.1996C4.16071 12.673 4.17902 12.8103 4.34375 12.975C4.46272 13.094 4.64576 13.1581 4.89286 13.1581C5.13995 13.1581 5.32299 13.094 5.44196 12.975C5.6067 12.8103 5.625 12.673 5.625 11.1996V9.61634L6.61339 9.57058C7.71161 9.51567 8.16004 9.36924 8.63594 8.9208C9.16674 8.4083 9.28571 8.04223 9.28571 6.77013V5.65361H10.933C12.4614 5.65361 12.5895 5.64446 12.7634 5.47058C13.0105 5.22348 13.0105 4.61946 12.7634 4.37236C12.5895 4.19848 12.4614 4.18933 10.9422 4.18933H9.30402L9.26741 3.14602C9.23995 2.14848 9.22165 2.07527 8.9654 1.70919C8.80982 1.48955 8.50781 1.18754 8.28817 1.03196L7.89464 0.757408L5.00268 0.739104C2.71473 0.720801 2.0375 0.739104 1.81786 0.839774ZM7.54687 2.45049C7.72076 2.62437 7.72991 2.7525 7.72991 5.0679C7.72991 6.47728 7.6933 7.56634 7.63839 7.66701C7.59263 7.75853 7.41875 7.8775 7.26317 7.93241C6.88795 8.06053 2.80625 8.06969 2.46763 7.94156C2.02835 7.77683 1.96429 7.42906 1.96429 5.11366C1.96429 2.9996 2.01004 2.60607 2.3029 2.37727C2.42187 2.29491 3.08996 2.26745 4.91116 2.26745C7.24487 2.26745 7.37299 2.2766 7.54687 2.45049Z"
          fill="#7697C6"
        />
        <path
          d="M33.9314 0.903753C33.4921 1.1234 33.0254 1.60844 32.8424 2.04773C32.76 2.23991 32.7142 2.6975 32.7142 3.27407V4.18924H31.4696C30.7924 4.18924 30.1517 4.22585 30.0602 4.28076C29.8131 4.40889 29.685 4.86648 29.804 5.19594C29.8497 5.35152 29.9687 5.51625 30.0602 5.56201C30.1517 5.61692 30.7924 5.65353 31.4696 5.65353H32.7142V6.77005C32.7142 8.04215 32.8332 8.40822 33.364 8.92072C33.8399 9.36916 34.2883 9.51559 35.3957 9.5705L36.375 9.61626V11.1629C36.375 12.014 36.4116 12.7919 36.4665 12.8834C36.677 13.277 37.5372 13.277 37.7477 12.8834C37.8026 12.7919 37.8392 12.014 37.8392 11.1629V9.61626L38.8276 9.5705C39.9258 9.51559 40.3743 9.36916 40.8502 8.92072C41.4817 8.32585 41.5 8.21603 41.5 5.10442C41.5 1.95621 41.4817 1.85554 40.8136 1.26982C40.1821 0.720717 40.1272 0.711565 37.0888 0.711565C34.4622 0.711565 34.2975 0.720717 33.9314 0.903753ZM39.6696 2.35889C39.7611 2.40465 39.8801 2.57853 39.935 2.73411C40.0723 3.13679 40.0723 7.08121 39.935 7.48389C39.7611 7.97809 39.4957 8.033 37.1254 8.033C34.9656 8.033 34.5263 7.97809 34.3616 7.66692C34.3067 7.56625 34.27 6.47719 34.27 5.06782C34.27 2.75241 34.2792 2.62429 34.4531 2.4504C34.627 2.27652 34.7551 2.26737 37.0705 2.26737C38.4799 2.26737 39.5689 2.30398 39.6696 2.35889Z"
          fill="#7697C6"
        />
        <path
          d="M15.3261 4.37231C15.2071 4.49129 15.1431 4.67432 15.1431 4.92142C15.1431 5.16852 15.2071 5.35156 15.3261 5.47053C15.5 5.64441 15.6281 5.65356 17.6873 5.65356C19.8471 5.65356 19.8745 5.65356 20.0667 5.44307C20.3413 5.15022 20.3321 4.64687 20.0576 4.39062C19.8471 4.19843 19.7739 4.18928 17.6781 4.18928C15.6281 4.18928 15.5 4.19843 15.3261 4.37231Z"
          fill="#7697C6"
        />
        <path
          d="M22.6476 4.37231C22.5287 4.49129 22.4646 4.67432 22.4646 4.92142C22.4646 5.16852 22.5287 5.35156 22.6476 5.47053C22.8215 5.64441 22.9496 5.65356 25.0088 5.65356C27.1686 5.65356 27.1961 5.65356 27.3883 5.44307C27.6628 5.15022 27.6537 4.64687 27.3791 4.39062C27.1686 4.19843 27.0954 4.18928 24.9996 4.18928C22.9496 4.18928 22.8215 4.19843 22.6476 4.37231Z"
          fill="#7697C6"
        />
        <path
          d="M10.9331 9.33265C10.2559 9.59805 9.56037 10.2936 9.30412 10.9891L9.10278 11.5199V21.0286V30.5373L9.30412 31.0682C9.56952 31.7728 10.2559 32.4592 10.9606 32.7246L11.4914 32.926H21.0001H30.5088L31.0396 32.7246C31.7443 32.4592 32.4307 31.7728 32.6961 31.0682L32.8974 30.5373V21.0286V11.5199L32.6961 10.9891C32.4307 10.2844 31.7443 9.59805 31.0396 9.33265L30.5088 9.13131L20.9726 9.14046C11.5097 9.14046 11.4365 9.14046 10.9331 9.33265ZM30.7193 10.9159C30.8566 11.0166 31.0488 11.2454 31.1494 11.4284C31.3416 11.7579 31.3416 11.8585 31.3416 18.4295L31.3325 25.1012L29.6668 23.399C27.6626 21.349 27.507 21.2574 26.2166 21.2574C24.9811 21.2574 24.7249 21.3947 23.2331 22.9139L22.0343 24.1219L20.2771 21.9896C19.3162 20.8181 18.3644 19.7565 18.1722 19.6284C17.1289 18.942 15.8019 18.942 14.7586 19.6376C14.5664 19.7657 13.5689 20.8731 12.553 22.1085L10.7043 24.3507L10.6769 18.0543C10.6586 11.8036 10.6586 11.767 10.8508 11.4193C10.9606 11.2362 11.1985 10.9891 11.3816 10.8793L11.711 10.6871L21.0916 10.7146C30.3166 10.7329 30.4722 10.7329 30.7193 10.9159ZM17.1655 20.8731C17.3394 20.9829 18.9684 22.8956 20.7896 25.1012C22.6108 27.3159 24.2307 29.2378 24.3863 29.3751C25.155 30.0706 26.0976 29.1188 25.4662 28.2952C25.3472 28.1487 24.7706 27.444 24.1849 26.7302C23.5901 26.0164 23.105 25.394 23.105 25.3574C23.105 25.2476 25.4113 22.9871 25.6401 22.8681C25.8963 22.74 26.5369 22.74 26.7932 22.8681C26.903 22.9231 27.9738 23.9389 29.1726 25.1286L31.3416 27.2976V28.7985C31.3416 30.5099 31.2501 30.8211 30.6095 31.178L30.2617 31.3702H21.0001C11.8026 31.3702 11.7293 31.3702 11.3999 31.178C10.7318 30.8027 10.7043 30.7112 10.6769 28.707L10.6494 26.9041L13.0564 23.9938C14.3834 22.3923 15.6006 20.9829 15.7744 20.8731C16.1863 20.5894 16.7537 20.5894 17.1655 20.8731Z"
          fill="#9BD732"
        />
        <path
          d="M16 20.5L10.5 27L10 28L10.5 30L11 31.5L12.5 32H14.5H17.5H20H23L26 31.5H29.5C30.5 31.5 30.5 31 32 30V28C32 27.5 31 26 30.5 25.5C30.1 25.1 29 24.6667 28.5 24.5L27.5 23H26L23 25L27.5 30.5C27 30.6667 25 29.7 21 24.5C17 19.3 16 19.6667 16 20.5Z"
          fill="#9BD732"
          stroke="#9BD732"
        />
        <path
          d="M26.3444 11.6847C25.8044 11.9318 25.3194 12.3894 25.0448 12.9202C24.6971 13.6066 24.6971 14.5584 25.054 15.2814C25.5207 16.2332 26.3444 16.7274 27.4426 16.7274C29.3736 16.7274 30.5725 14.6682 29.6848 12.8836C29.3828 12.2979 28.8978 11.8586 28.2937 11.6298C27.827 11.4651 26.7745 11.4925 26.3444 11.6847ZM28.0466 13.3137C28.5683 13.7896 28.5591 14.4943 28.0375 14.9336C27.525 15.3637 26.7379 15.1899 26.4451 14.5675C25.96 13.5425 27.2138 12.5633 28.0466 13.3137Z"
          fill="#9BD732"
        />
        <path
          d="M4.36174 15.5651C4.16955 15.7756 4.1604 15.8488 4.1604 17.9446C4.1604 19.9946 4.16955 20.1227 4.34344 20.2966C4.46241 20.4156 4.64544 20.4796 4.89254 20.4796C5.13964 20.4796 5.32268 20.4156 5.44165 20.2966C5.61553 20.1227 5.62469 19.9946 5.62469 17.9354C5.62469 15.7756 5.62469 15.7481 5.41419 15.556C5.12134 15.2814 4.61799 15.2906 4.36174 15.5651Z"
          fill="#7697C6"
        />
        <path
          d="M36.558 15.5376C36.3842 15.7115 36.375 15.8396 36.375 17.8804C36.375 19.1068 36.4116 20.1043 36.4665 20.205C36.5946 20.4521 37.0522 20.5802 37.3817 20.4613C37.5373 20.4155 37.702 20.2965 37.7478 20.205C37.8027 20.1043 37.8393 19.1068 37.8393 17.8804C37.8393 15.8396 37.8301 15.7115 37.6562 15.5376C37.5373 15.4186 37.3542 15.3546 37.1071 15.3546C36.86 15.3546 36.677 15.4186 36.558 15.5376Z"
          fill="#7697C6"
        />
        <path
          d="M4.34344 22.8589C4.16955 23.0328 4.1604 23.1609 4.1604 25.2018C4.1604 26.4281 4.19701 27.4257 4.25192 27.5263C4.46241 27.9199 5.32268 27.9199 5.53317 27.5263C5.58808 27.4257 5.62469 26.4281 5.62469 25.2018C5.62469 23.1609 5.61553 23.0328 5.44165 22.8589C5.32268 22.7399 5.13964 22.6759 4.89254 22.6759C4.64544 22.6759 4.46241 22.7399 4.34344 22.8589Z"
          fill="#7697C6"
        />
        <path
          d="M36.5763 22.8865C36.3842 23.0969 36.375 23.1702 36.375 25.2659C36.375 27.3159 36.3842 27.444 36.558 27.6179C36.677 27.7369 36.86 27.801 37.1071 27.801C37.3542 27.801 37.5373 27.7369 37.6562 27.6179C37.8301 27.444 37.8393 27.3159 37.8393 25.2568C37.8393 23.0969 37.8393 23.0695 37.6288 22.8773C37.3359 22.6027 36.8326 22.6119 36.5763 22.8865Z"
          fill="#7697C6"
        />
        <path
          d="M4.36205 30.2079C4.17902 30.4001 4.16071 30.519 4.16071 31.4342V32.4409L3.18147 32.4867C2.07411 32.5416 1.62567 32.688 1.14978 33.1364C0.518304 33.7313 0.5 33.8411 0.5 36.9527C0.5 39.4695 0.518304 39.7806 0.673884 40.1193C0.875223 40.5585 1.51585 41.1351 1.96429 41.2632C2.16563 41.3181 3.3279 41.3456 5.0942 41.3273L7.89464 41.2998L8.28817 41.0253C8.50781 40.8697 8.80982 40.5677 8.9654 40.3481C9.22165 39.982 9.23996 39.9088 9.26741 38.9112L9.30402 37.8679H10.5761C11.7292 37.8679 11.8665 37.8496 12.0313 37.6849C12.2784 37.4378 12.2784 36.8338 12.0313 36.5867C11.8665 36.4219 11.7292 36.4036 10.567 36.4036H9.28572V35.278C9.28572 34.015 9.16674 33.6489 8.63594 33.1364C8.16005 32.688 7.71161 32.5416 6.61339 32.4867L5.625 32.4409V31.4159C5.625 30.4641 5.6067 30.3818 5.41451 30.1987C5.12165 29.9242 4.6183 29.9333 4.36205 30.2079ZM7.35469 34.1614C7.50112 34.2347 7.63839 34.3628 7.675 34.436C7.70246 34.5184 7.72991 35.6806 7.72991 37.0077C7.72991 39.3048 7.72076 39.4329 7.54688 39.6068C7.37299 39.7806 7.24487 39.7898 4.92947 39.7898C3.52009 39.7898 2.43103 39.7532 2.33036 39.6983C2.0192 39.5335 1.96429 39.0943 1.96429 36.9344C1.96429 34.674 2.02835 34.2896 2.44018 34.1157C2.55915 34.0699 3.64821 34.0333 4.87455 34.0333C6.65915 34.0242 7.15335 34.0516 7.35469 34.1614Z"
          fill="#7697C6"
        />
        <path
          d="M36.558 30.1804C36.3933 30.3452 36.375 30.4824 36.375 31.4068V32.4409L35.3957 32.4867C34.2883 32.5416 33.8399 32.688 33.364 33.1364C32.8332 33.6489 32.7142 34.015 32.7142 35.278V36.4036H31.0852C29.4928 36.4036 29.4471 36.4128 29.2549 36.6141C28.9803 36.907 28.9895 37.4103 29.264 37.6666C29.4654 37.8588 29.5569 37.8679 31.0852 37.8679H32.6959L32.7325 38.9112C32.76 39.9088 32.7783 39.982 33.0346 40.3481C33.1901 40.5677 33.4921 40.8697 33.7118 41.0253L34.1053 41.2998L36.9058 41.3273C38.672 41.3456 39.8343 41.3181 40.0357 41.2632C40.4841 41.1351 41.1247 40.5585 41.3261 40.1193C41.4816 39.7806 41.5 39.4695 41.5 36.9527C41.5 33.8411 41.4816 33.7313 40.8502 33.1364C40.3743 32.688 39.9258 32.5416 38.8276 32.4867L37.8392 32.4409V31.4068C37.8392 30.1804 37.7386 29.9974 37.1071 29.9974C36.86 29.9974 36.677 30.0614 36.558 30.1804ZM39.5323 34.1157C39.9716 34.2804 40.0357 34.6282 40.0357 36.9344C40.0357 39.0943 39.9808 39.5335 39.6696 39.6983C39.5689 39.7532 38.4799 39.7898 37.0705 39.7898C34.7551 39.7898 34.627 39.7806 34.4531 39.6068C34.2792 39.4329 34.27 39.3048 34.27 36.971C34.27 34.4085 34.2792 34.3536 34.6819 34.134C34.9198 33.9967 39.1937 33.9876 39.5323 34.1157Z"
          fill="#7697C6"
        />
        <path
          d="M14.6118 36.6142C14.3372 36.907 14.3464 37.4104 14.6209 37.6666C14.8314 37.8588 14.9047 37.868 17.0004 37.868C19.0504 37.868 19.1785 37.8588 19.3524 37.6849C19.4714 37.566 19.5355 37.3829 19.5355 37.1358C19.5355 36.8887 19.4714 36.7057 19.3524 36.5867C19.1785 36.4128 19.0504 36.4037 16.9913 36.4037C14.8314 36.4037 14.804 36.4037 14.6118 36.6142Z"
          fill="#7697C6"
        />
        <path
          d="M21.9333 36.6142C21.6588 36.907 21.6679 37.4104 21.9425 37.6666C22.153 37.8588 22.2262 37.868 24.3219 37.868C26.3719 37.868 26.5001 37.8588 26.674 37.6849C26.7929 37.566 26.857 37.3829 26.857 37.1358C26.857 36.8887 26.7929 36.7057 26.674 36.5867C26.5001 36.4128 26.3719 36.4037 24.3128 36.4037C22.153 36.4037 22.1255 36.4037 21.9333 36.6142Z"
          fill="#7697C6"
        />
      </svg>
    </>
  );
};

export const FileIconSvg = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.2594 7.90347C11.0936 7.90347 10.9347 7.83762 10.8174 7.7204C10.7002 7.60319 10.6344 7.44422 10.6344 7.27847V1.95972H5C4.50272 1.95972 4.02581 2.15726 3.67419 2.50889C3.32253 2.86052 3.125 3.33744 3.125 3.83472V16.3597C3.125 16.857 3.32253 17.3339 3.67419 17.6855C4.02581 18.0372 4.50272 18.2347 5 18.2347H14.7063C15.2033 18.2338 15.6796 18.036 16.0311 17.6845C16.3825 17.3331 16.5803 16.8567 16.5813 16.3597V7.90347H11.2594Z"
        fill="currentColor"
      ></path>
      <path
        d="M16.2124 6.65335L11.8843 2.3252V2.58458V6.65335H15.9562H16.2124Z"
        fill="currentColor"
      ></path>
    </svg>
  );
};
export const DeleteSvg = () => {
  return (
    <>
      <svg
        width="19"
        height="19"
        viewBox="0 0 19 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7 13L7 10"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
        ></path>
        <path
          d="M11 13L11 10"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
        ></path>
        <path
          d="M0 5H18V5C17.0681 5 16.6022 5 16.2346 5.15224C15.7446 5.35523 15.3552 5.74458 15.1522 6.23463C15 6.60218 15 7.06812 15 8V14C15 15.8856 15 16.8284 14.4142 17.4142C13.8284 18 12.8856 18 11 18H7C5.11438 18 4.17157 18 3.58579 17.4142C3 16.8284 3 15.8856 3 14V8C3 7.06812 3 6.60218 2.84776 6.23463C2.64477 5.74458 2.25542 5.35523 1.76537 5.15224C1.39782 5 0.931883 5 0 5V5Z"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
        ></path>
        <path
          d="M7.06815 1.37059C7.1821 1.26427 7.43319 1.17033 7.78248 1.10332C8.13177 1.03632 8.55973 1 9 1C9.44027 1 9.86823 1.03632 10.2175 1.10332C10.5668 1.17033 10.8179 1.26427 10.9319 1.37059"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
        ></path>
      </svg>
    </>
  );
};
export const Email_Svg = () => {
  return (
    <>
      <svg
        width="20"
        height="16"
        viewBox="0 0 20 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17 0H3C2.20435 0 1.44129 0.316071 0.87868 0.87868C0.316071 1.44129 0 2.20435 0 3V13C0 13.7956 0.316071 14.5587 0.87868 15.1213C1.44129 15.6839 2.20435 16 3 16H17C17.7956 16 18.5587 15.6839 19.1213 15.1213C19.6839 14.5587 20 13.7956 20 13V3C20 2.20435 19.6839 1.44129 19.1213 0.87868C18.5587 0.316071 17.7956 0 17 0ZM16.59 2L10.71 7.88C10.617 7.97373 10.5064 8.04812 10.3846 8.09889C10.2627 8.14966 10.132 8.1758 10 8.1758C9.86799 8.1758 9.73728 8.14966 9.61542 8.09889C9.49356 8.04812 9.38296 7.97373 9.29 7.88L3.41 2H16.59ZM18 13C18 13.2652 17.8946 13.5196 17.7071 13.7071C17.5196 13.8946 17.2652 14 17 14H3C2.73478 14 2.48043 13.8946 2.29289 13.7071C2.10536 13.5196 2 13.2652 2 13V3.41L7.88 9.29C8.4425 9.8518 9.205 10.1674 10 10.1674C10.795 10.1674 11.5575 9.8518 12.12 9.29L18 3.41V13Z"
          fill="currentColor"
        />
      </svg>
    </>
  );
};
export const ResetSvg = () => {
  return (
    <>
      <svg
        width="20"
        height="22"
        viewBox="0 0 20 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.8901 4.08C12.0201 3.82 11.0601 3.65 10.0001 3.65C5.21008 3.65 1.33008 7.53 1.33008 12.32C1.33008 17.12 5.21008 21 10.0001 21C14.7901 21 18.6701 17.12 18.6701 12.33C18.6701 10.55 18.1301 8.89 17.2101 7.51"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.1302 4.32L11.2402 1"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.1298 4.32L10.7598 6.78"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
export const Phone_Svg = () => {
  return (
    <>
      <svg
        width="21"
        height="21"
        viewBox="0 0 21 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.67962 1.76482L3.73734 1.70711C4.12786 1.31658 4.76103 1.31658 5.15155 1.70711L8.18178 4.73734C8.57231 5.12786 8.57231 5.76103 8.18178 6.15155L6.96861 7.36473C6.78829 7.54504 6.74359 7.82051 6.85763 8.04859C8.17614 10.6856 10.3144 12.8239 12.9514 14.1424C13.1795 14.2564 13.455 14.2117 13.6353 14.0314L14.8484 12.8182C15.239 12.4277 15.8721 12.4277 16.2627 12.8182L19.2929 15.8484C19.6834 16.239 19.6834 16.8721 19.2929 17.2627L19.2352 17.3204C17.1238 19.4317 13.7813 19.6693 11.3925 17.8777L9.29524 16.3048C7.55171 14.9971 6.00289 13.4483 4.69524 11.7048L3.12226 9.60746C1.33072 7.21874 1.56827 3.87617 3.67962 1.76482Z"
          stroke="currentColor"
          strokeWidth="2"
        />
      </svg>
    </>
  );
};
export const Date_Svg = () => {
  return (
    <>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="1"
          y="4"
          width="18"
          height="15"
          rx="2"
          stroke="currentColor"
          strokeWidth="2"
        />
        <path
          d="M1 8C1 6.11438 1 5.17157 1.58579 4.58579C2.17157 4 3.11438 4 5 4H15C16.8856 4 17.8284 4 18.4142 4.58579C19 5.17157 19 6.11438 19 8H1Z"
          fill="currentColor"
        />
        <path
          d="M5 1L5 4"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M15 1L15 4"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <rect x="5" y="10" width="4" height="2" rx="0.5" fill="currentColor" />
        <rect x="5" y="14" width="4" height="2" rx="0.5" fill="currentColor" />
        <rect x="11" y="10" width="4" height="2" rx="0.5" fill="currentColor" />
        <rect x="11" y="14" width="4" height="2" rx="0.5" fill="currentColor" />
      </svg>
    </>
  );
};
export const Add_Svg = () => {
  return (
    <>
      <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7 1L7 13"
          stroke="CurrentColor"
          strokeWidth="2"
          strokeLinecap="square"
          strokeLinejoin="round"
        />
        <path
          d="M13 7L1 7"
          stroke="CurrentColor"
          strokeWidth="2"
          strokeLinecap="square"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
export const FilterSvg = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="2.66669"
        y="4"
        width="26.6667"
        height="12"
        rx="2"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M21.3334 24V24C21.3334 24.62 21.3334 24.93 21.2652 25.1843C21.0803 25.8745 20.5412 26.4136 19.851 26.5985C19.5967 26.6667 19.2867 26.6667 18.6667 26.6667H13.3334C12.7134 26.6667 12.4034 26.6667 12.1491 26.5985C11.4589 26.4136 10.9198 25.8745 10.7348 25.1843C10.6667 24.93 10.6667 24.62 10.6667 24V24"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M25.3334 18.6666V18.6666C25.3334 19.2866 25.3334 19.5966 25.2652 19.8509C25.0803 20.5411 24.5412 21.0802 23.851 21.2652C23.5967 21.3333 23.2867 21.3333 22.6667 21.3333H9.33335C8.71337 21.3333 8.40338 21.3333 8.14905 21.2652C7.45887 21.0802 6.91977 20.5411 6.73483 19.8509C6.66669 19.5966 6.66669 19.2866 6.66669 18.6666V18.6666"
        stroke="currentColor"
        strokeWidth="2"
      />
    </svg>
  );
};
export const FiltericonSvg = () => {
  return (
    <svg
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17 2.6C17 2.04 17 1.76 16.89 1.546C16.7945 1.35792 16.6419 1.20493 16.454 1.109C16.24 1 15.96 1 15.4 1H2.6C2.04 1 1.76 1 1.546 1.109C1.35785 1.20487 1.20487 1.35785 1.109 1.546C1 1.76 1 2.04 1 2.6V3.337C1 3.582 1 3.704 1.028 3.819C1.05249 3.92138 1.09299 4.01925 1.148 4.109C1.209 4.209 1.296 4.296 1.468 4.469L6.531 9.531C6.704 9.704 6.791 9.791 6.852 9.891C6.907 9.981 6.948 10.079 6.972 10.181C7 10.295 7 10.416 7 10.655V15.411C7 16.268 7 16.697 7.18 16.955C7.25809 17.0666 7.35816 17.161 7.47406 17.2326C7.58996 17.3041 7.71925 17.3512 7.854 17.371C8.165 17.417 8.549 17.226 9.315 16.842L10.115 16.442C10.437 16.282 10.597 16.202 10.714 16.082C10.8178 15.976 10.8967 15.8483 10.945 15.708C11 15.55 11 15.37 11 15.011V10.663C11 10.418 11 10.296 11.028 10.181C11.0525 10.0786 11.093 9.98073 11.148 9.891C11.208 9.791 11.295 9.705 11.465 9.535L11.469 9.531L16.532 4.469C16.704 4.296 16.79 4.209 16.852 4.109C16.9071 4.0193 16.9476 3.92141 16.972 3.819C17 3.706 17 3.584 17 3.345V2.6Z"
        stroke="currentColor"
        strokeWidth="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const PluesSvg = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 1L7 13"
        stroke="CurrentColor"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M13 7L1 7"
        stroke="CurrentColor"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const EditbtnSvg = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.1208 7.42339L15.9168 5.62738C16.462 5.08213 16.7346 4.80951 16.8804 4.51541C17.1577 3.95586 17.1577 3.29891 16.8804 2.73935C16.7346 2.44526 16.462 2.17263 15.9168 1.62738C15.3715 1.08213 15.0989 0.809509 14.8048 0.663773C14.2452 0.38649 13.5883 0.38649 13.0287 0.663773C12.7346 0.809509 12.462 1.08213 11.9168 1.62738L10.0981 3.44604C11.062 5.09664 12.4481 6.4722 14.1208 7.42339ZM8.64365 4.9005L1.77314 11.771C1.34808 12.1961 1.13555 12.4086 0.995818 12.6697C0.856084 12.9308 0.797138 13.2255 0.679248 13.815L0.0638519 16.8919C-0.00267025 17.2246 -0.0359313 17.3909 0.0586767 17.4855C0.153285 17.5801 0.31959 17.5468 0.6522 17.4803L3.72918 16.8649C4.31863 16.747 4.61336 16.6881 4.87446 16.5483C5.13555 16.4086 5.34808 16.1961 5.77315 15.771L12.6625 8.8816C11.0409 7.86595 9.66919 6.50366 8.64365 4.9005Z"
        fill="CurrentColor"
      />
    </svg>
  );
};

export const PdfSvg = () => {
  return (
    <svg
      width="29"
      height="33"
      viewBox="0 0 29 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25.4375 8.1875H18.875C18.759 8.1875 18.6477 8.14141 18.5656 8.05936C18.4836 7.97732 18.4375 7.86604 18.4375 7.75V1.1875C18.4375 1.07147 18.4836 0.960188 18.5656 0.878141C18.6477 0.796094 18.759 0.75 18.875 0.75C18.991 0.75 19.1023 0.796094 19.1844 0.878141C19.2664 0.960188 19.3125 1.07147 19.3125 1.1875V7.3125H25.4375C25.5535 7.3125 25.6648 7.3586 25.7469 7.44064C25.8289 7.52269 25.875 7.63397 25.875 7.75C25.875 7.86604 25.8289 7.97732 25.7469 8.05936C25.6648 8.14141 25.5535 8.1875 25.4375 8.1875Z"
        fill="red"
      />
      <path
        d="M25.4375 12.5476C25.3215 12.5476 25.2102 12.5015 25.1281 12.4195C25.0461 12.3374 25 12.2262 25 12.1101V7.93113L18.6939 1.625H5.75C5.28587 1.625 4.84075 1.80938 4.51256 2.13756C4.18437 2.46575 4 2.91087 4 3.375V11.9649C4 12.0809 3.95391 12.1922 3.87186 12.2742C3.78981 12.3563 3.67853 12.4024 3.5625 12.4024C3.44647 12.4024 3.33519 12.3563 3.25314 12.2742C3.17109 12.1922 3.125 12.0809 3.125 11.9649V3.375C3.125 2.67881 3.40156 2.01113 3.89384 1.51885C4.38613 1.02656 5.05381 0.750001 5.75 0.750001H18.875C18.9325 0.749898 18.9894 0.761128 19.0426 0.783048C19.0957 0.804968 19.144 0.837149 19.1847 0.877751L25.7472 7.44025C25.7878 7.48096 25.82 7.52927 25.8419 7.58242C25.8639 7.63556 25.8751 7.69251 25.875 7.75V12.1101C25.875 12.1676 25.8637 12.2245 25.8417 12.2776C25.8197 12.3306 25.7875 12.3789 25.7468 12.4195C25.7062 12.4601 25.658 12.4923 25.6049 12.5143C25.5518 12.5363 25.4949 12.5476 25.4375 12.5476Z"
        fill="red"
      />
      <path
        d="M23.25 32.25H5.75C5.05381 32.25 4.38613 31.9734 3.89384 31.4812C3.40156 30.9889 3.125 30.3212 3.125 29.625V23.0625C3.125 22.9465 3.17109 22.8352 3.25314 22.7531C3.33519 22.6711 3.44647 22.625 3.5625 22.625C3.67853 22.625 3.78981 22.6711 3.87186 22.7531C3.95391 22.8352 4 22.9465 4 23.0625V29.625C4 30.0891 4.18437 30.5343 4.51256 30.8624C4.84075 31.1906 5.28587 31.375 5.75 31.375H23.25C23.7141 31.375 24.1592 31.1906 24.4874 30.8624C24.8156 30.5343 25 30.0891 25 29.625V23.0625C25 22.9465 25.0461 22.8352 25.1281 22.7531C25.2102 22.6711 25.3215 22.625 25.4375 22.625C25.5535 22.625 25.6648 22.6711 25.7468 22.7531C25.8289 22.8352 25.875 22.9465 25.875 23.0625V29.625C25.875 30.3212 25.5984 30.9889 25.1061 31.4812C24.6139 31.9734 23.9462 32.25 23.25 32.25Z"
        fill="red"
      />
      <path
        d="M21.0625 23.5H7.9375C7.82147 23.5 7.71019 23.4539 7.62814 23.3719C7.54609 23.2898 7.5 23.1785 7.5 23.0625C7.5 22.9465 7.54609 22.8352 7.62814 22.7531C7.71019 22.6711 7.82147 22.625 7.9375 22.625H21.0625C21.1785 22.625 21.2898 22.6711 21.3719 22.7531C21.4539 22.8352 21.5 22.9465 21.5 23.0625C21.5 23.1785 21.4539 23.2898 21.3719 23.3719C21.2898 23.4539 21.1785 23.5 21.0625 23.5Z"
        fill="red"
      />
      <path
        d="M14.5 27.875H7.9375C7.82147 27.875 7.71019 27.8289 7.62814 27.7469C7.54609 27.6648 7.5 27.5535 7.5 27.4375C7.5 27.3215 7.54609 27.2102 7.62814 27.1281C7.71019 27.0461 7.82147 27 7.9375 27H14.5C14.616 27 14.7273 27.0461 14.8094 27.1281C14.8914 27.2102 14.9375 27.3215 14.9375 27.4375C14.9375 27.5535 14.8914 27.6648 14.8094 27.7469C14.7273 27.8289 14.616 27.875 14.5 27.875Z"
        fill="red"
      />
      <path
        d="M25.4375 23.5H3.5625C2.86631 23.5 2.19863 23.2234 1.70634 22.7311C1.21406 22.2388 0.9375 21.5712 0.9375 20.875V14.1523C0.9375 13.4561 1.21406 12.7885 1.70634 12.2962C2.19863 11.8039 2.86631 11.5273 3.5625 11.5273H3.58L25.455 11.6726C26.1477 11.679 26.8099 11.9582 27.2981 12.4496C27.7864 12.9409 28.0613 13.6049 28.0634 14.2976V20.875C28.0634 21.2198 27.9955 21.5612 27.8635 21.8797C27.7315 22.1982 27.5381 22.4877 27.2942 22.7314C27.0504 22.9752 26.7609 23.1685 26.4423 23.3004C26.1237 23.4323 25.7823 23.5001 25.4375 23.5ZM3.5625 12.4023C3.09837 12.4023 2.65325 12.5867 2.32506 12.9149C1.99687 13.2431 1.8125 13.6882 1.8125 14.1523V20.875C1.8125 21.3391 1.99687 21.7842 2.32506 22.1124C2.65325 22.4406 3.09837 22.625 3.5625 22.625H25.4375C25.9016 22.625 26.3468 22.4406 26.6749 22.1124C27.0031 21.7842 27.1875 21.3391 27.1875 20.875V14.2976C27.1861 13.8357 27.0028 13.393 26.6771 13.0654C26.3515 12.7378 25.9099 12.5517 25.448 12.5476L3.573 12.4023H3.5625Z"
        fill="red"
      />
      <path
        d="M9.68749 19.65H8.84662V14.9845H10.7576C11.3025 14.9845 11.7064 15.1219 11.9695 15.3966C12.2285 15.6687 12.3703 16.0317 12.3642 16.4073C12.3582 16.7829 12.2048 17.1411 11.9371 17.4047C11.6416 17.6731 11.2528 17.8153 10.8539 17.8011H9.68749V19.65ZM9.68749 17.0801H10.6824C10.942 17.0801 11.1403 17.0162 11.2774 16.8885C11.3459 16.8231 11.3996 16.7439 11.4349 16.656C11.4702 16.5682 11.4863 16.4738 11.4821 16.3792C11.4853 16.1969 11.4172 16.0204 11.2922 15.8875C11.1657 15.751 10.9373 15.6827 10.6071 15.6827H9.68749V17.0801Z"
        fill="red"
      />
      <path
        d="M13.0125 19.65V14.9845H14.7363C15.3721 14.9845 15.8825 15.2094 16.2675 15.6591C16.6525 16.1089 16.845 16.663 16.845 17.3216C16.845 17.9825 16.6467 18.5352 16.25 18.9797C15.8533 19.4242 15.2861 19.6477 14.5481 19.65H13.0125ZM13.877 18.9631H14.577C14.7576 18.9655 14.9366 18.9289 15.1018 18.8558C15.267 18.7827 15.4145 18.6749 15.5343 18.5396C15.7962 18.2573 15.9271 17.837 15.9271 17.2787C15.94 16.8662 15.8194 16.4605 15.5833 16.122C15.4837 15.9735 15.3484 15.8524 15.1899 15.7697C15.0314 15.687 14.8546 15.6454 14.6759 15.6486H13.8761L13.877 18.9631Z"
        fill="red"
      />
      <path
        d="M18.4891 19.65H17.6237V14.9845H20.5734V15.7055H18.4891V16.9804H20.1297V17.6804H18.4891V19.65Z"
        fill="red"
      />
    </svg>
  );
};
export const ActionbtnSvg = () => {
  return (
    <svg
      width="5"
      height="19"
      viewBox="0 0 5 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="2.5" cy="2.5" r="2.5" fill="currentColor" />
      <circle cx="2.5" cy="9.5" r="2.5" fill="currentColor" />
      <circle cx="2.5" cy="16.5" r="2.5" fill="currentColor" />
    </svg>
  );
};
export const LoactionSvg = () => {
  return (
    <svg
      width="35"
      height="37"
      viewBox="0 0 35 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.5 35C26.6127 35 34 27.6127 34 18.5C34 9.3873 26.6127 2 17.5 2C8.3873 2 1 9.3873 1 18.5C1 27.6127 8.3873 35 17.5 35Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
      <path
        d="M17.5 35C21.9 31 24.1 25.5 24.1 18.5C24.1 11.5 21.9 6 17.5 2C13.1 6 10.9 11.5 10.9 18.5C10.9 25.5 13.1 31 17.5 35Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M1.82495 13.55H33.175M1.82495 23.45H33.175"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};
export const ViewSvg = () => {
  return (
    <svg
      width="20"
      height="12"
      viewBox="0 0 20 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 0C3.439 0 0 4.832 0 5.6C0 6.366 3.439 11.2 10 11.2C16.56 11.2 20 6.366 20 5.6C20 4.832 16.56 0 10 0ZM10 9.907C7.545 9.907 5.555 7.979 5.555 5.6C5.555 3.221 7.545 1.291 10 1.291C12.455 1.291 14.444 3.221 14.444 5.6C14.444 7.979 12.455 9.907 10 9.907ZM10 5.6C9.593 5.153 10.663 3.446 10 3.446C8.772 3.446 7.777 4.411 7.777 5.6C7.777 6.789 8.772 7.754 10 7.754C11.227 7.754 12.223 6.789 12.223 5.6C12.223 5.053 10.346 5.979 10 5.6Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const BackSvg = () => {
  return (
    <svg
      width="23"
      height="18"
      viewBox="0 0 23 18"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M2 9L1.29289 8.29289L0.585786 9L1.29289 9.70711L2 9ZM22 10C22.5523 10 23 9.55229 23 9C23 8.44772 22.5523 8 22 8V10ZM9.29289 0.292893L1.29289 8.29289L2.70711 9.70711L10.7071 1.70711L9.29289 0.292893ZM1.29289 9.70711L9.29289 17.7071L10.7071 16.2929L2.70711 8.29289L1.29289 9.70711ZM2 10H22V8H2V10Z" />
    </svg>
  );
};

export const ClockSvg = () => {
  return (
    <svg
      width="20"
      height="22"
      viewBox="0 0 20 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="10" cy="12" r="9" stroke="currentColor" strokeWidth="1.5" />
      <path
        d="M10 8V12L12.5 14.5"
        stroke="currentColor"
        strokeWidth="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M1.5 3.5L5.50002 1"
        stroke="currentColor"
        strokeWidth="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.5 3.5L14.5 1"
        stroke="currentColor"
        strokeWidth="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const CloseSvg = () => {
  return (
    <svg
      width="33"
      height="33"
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.8807 4.13589C32.2693 3.73354 32.4843 3.19466 32.4794 2.6353C32.4746 2.07595 32.2502 1.54088 31.8547 1.14535C31.4591 0.74981 30.9241 0.525449 30.3647 0.520588C29.8054 0.515728 29.2665 0.730757 28.8641 1.11936L16.5057 13.4778L4.14734 1.11936C3.74499 0.730757 3.2061 0.515728 2.64675 0.520588C2.08739 0.525449 1.55233 0.74981 1.15679 1.14535C0.761254 1.54088 0.536893 2.07595 0.532032 2.6353C0.527172 3.19466 0.742201 3.73354 1.1308 4.13589L13.4892 16.4943L1.1308 28.8527C0.92705 29.0495 0.764527 29.2849 0.652721 29.5452C0.540915 29.8054 0.482065 30.0854 0.479603 30.3686C0.477142 30.6519 0.531118 30.9328 0.638384 31.195C0.74565 31.4572 0.904057 31.6954 1.10436 31.8957C1.30467 32.096 1.54286 32.2544 1.80504 32.3616C2.06721 32.4689 2.34813 32.5229 2.63139 32.5204C2.91466 32.518 3.19459 32.4591 3.45487 32.3473C3.71514 32.2355 3.95054 32.073 4.14734 31.8692L16.5057 19.5108L28.8641 31.8692C29.2665 32.2578 29.8054 32.4729 30.3647 32.468C30.9241 32.4631 31.4591 32.2388 31.8547 31.8432C32.2502 31.4477 32.4746 30.9126 32.4794 30.3533C32.4843 29.7939 32.2693 29.255 31.8807 28.8527L19.5223 16.4943L31.8807 4.13589Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const BackToLoginSvg = () => {
  return (
    <svg
      className="me-1"
      width="18"
      height="14"
      viewBox="0 0 18 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 7L1.29289 6.29289L0.585786 7L1.29289 7.70711L2 7ZM17 8C17.5523 8 18 7.55228 18 7C18 6.44772 17.5523 6 17 6V8ZM7.29289 0.292893L1.29289 6.29289L2.70711 7.70711L8.70711 1.70711L7.29289 0.292893ZM1.29289 7.70711L7.29289 13.7071L8.70711 12.2929L2.70711 6.29289L1.29289 7.70711ZM2 8H17V6H2V8Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const EyeSvg = () => {
  return (
    <svg
      width="20"
      height="14"
      viewBox="0 0 20 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="10" cy="7" r="3" stroke="currentColor" strokeWidth="2" />
      <path
        d="M18.188 5.93429C18.5762 6.40556 18.7703 6.64119 18.7703 7C18.7703 7.35881 18.5762 7.59444 18.188 8.06571C16.7679 9.78986 13.6357 13 10 13C6.36427 13 3.23206 9.78986 1.81197 8.06571C1.42381 7.59444 1.22973 7.35881 1.22973 7C1.22973 6.64119 1.42381 6.40556 1.81197 5.93429C3.23206 4.21014 6.36427 1 10 1C13.6357 1 16.7679 4.21014 18.188 5.93429Z"
        stroke="currentColor"
        strokeWidth="2"
      />
    </svg>
  );
};

export const UserSvg = () => {
  return (
    <svg
      width="23"
      height="24"
      viewBox="0 0 23 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.2147 12.8906C14.6372 12.8906 17.4121 10.0047 17.4121 6.44531C17.4121 2.88594 14.6372 0 11.2147 0C7.79222 0 5.01728 2.88594 5.01728 6.44531C5.02103 10.0031 7.79447 12.8867 11.2147 12.8906ZM11.2147 1.95312C13.6005 1.95312 15.5341 3.96406 15.5341 6.44531C15.5341 8.92656 13.6005 10.9375 11.2147 10.9375C8.82888 10.9375 6.89528 8.92656 6.89528 6.44531C6.89829 3.96563 8.83038 1.95625 11.2147 1.95312ZM22.4061 22.6437C21.2387 17.25 16.6722 13.2812 11.2139 13.2812C5.75571 13.2812 1.18915 17.25 0.0360577 22.5641L0.0217849 22.6437C0.00826325 22.7062 0 22.7781 0 22.8516C0 23.3906 0.420673 23.8281 0.939003 23.8281C1.38672 23.8281 1.76157 23.5016 1.85547 23.0656L1.85697 23.0594C2.83429 18.5516 6.65189 15.2344 11.2147 15.2344C15.7775 15.2344 19.5944 18.5508 20.5596 22.9922L20.5717 23.0586C20.6663 23.5008 21.0397 23.8273 21.4874 23.8273C21.5587 23.8273 21.6279 23.8188 21.6947 23.8031L21.6887 23.8047C22.1146 23.707 22.4279 23.318 22.4279 22.8523C22.4279 22.7781 22.4196 22.7062 22.4046 22.6367L22.4061 22.6437Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const BellSvg = () => {
  return (
    <svg
      width="31"
      height="31"
      viewBox="0 0 31 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.32846 11.5856C8.73449 7.93133 11.8233 5.16675 15.5 5.16675V5.16675C19.1767 5.16675 22.2655 7.93133 22.6715 11.5856L22.9968 14.5128C23.0569 15.0537 23.0869 15.3241 23.1346 15.5893C23.2742 16.3652 23.5277 17.1163 23.887 17.8182C24.0097 18.0579 24.1497 18.2913 24.4297 18.758L25.3076 20.2211C26.1134 21.564 26.5162 22.2355 26.229 22.7428C25.9418 23.2501 25.1587 23.2501 23.5926 23.2501H7.40738C5.84127 23.2501 5.05822 23.2501 4.77099 22.7428C4.48376 22.2355 4.88664 21.564 5.69239 20.2211L6.57026 18.758C6.85027 18.2913 6.99028 18.0579 7.11302 17.8182C7.47227 17.1163 7.7258 16.3652 7.86538 15.5893C7.91307 15.3241 7.94312 15.0537 8.00322 14.5128L8.32846 11.5856Z"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M11.757 23.7742C11.9778 24.7355 12.4643 25.585 13.141 26.1908C13.8178 26.7966 14.647 27.125 15.5 27.125C16.353 27.125 17.1822 26.7966 17.8589 26.1908C18.5357 25.585 19.0222 24.7355 19.243 23.7742"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const MenuSvg = () => {
  return (
    <svg
      width="37"
      height="31"
      viewBox="0 0 37 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.648438 2.74995C0.648438 2.07365 0.917097 1.42505 1.39532 0.946829C1.87353 0.468612 2.52214 0.199951 3.19844 0.199951H33.7984C34.4747 0.199951 35.1233 0.468612 35.6016 0.946829C36.0798 1.42505 36.3484 2.07365 36.3484 2.74995C36.3484 3.42625 36.0798 4.07486 35.6016 4.55307C35.1233 5.03129 34.4747 5.29995 33.7984 5.29995H3.19844C2.52214 5.29995 1.87353 5.03129 1.39532 4.55307C0.917097 4.07486 0.648438 3.42625 0.648438 2.74995ZM0.648438 15.5C0.648438 14.8236 0.917097 14.175 1.39532 13.6968C1.87353 13.2186 2.52214 12.95 3.19844 12.95H18.4984C19.1747 12.95 19.8233 13.2186 20.3016 13.6968C20.7798 14.175 21.0484 14.8236 21.0484 15.5C21.0484 16.1763 20.7798 16.8249 20.3016 17.3031C19.8233 17.7813 19.1747 18.05 18.4984 18.05H3.19844C2.52214 18.05 1.87353 17.7813 1.39532 17.3031C0.917097 16.8249 0.648438 16.1763 0.648438 15.5ZM0.648438 28.25C0.648438 27.5736 0.917097 26.925 1.39532 26.4468C1.87353 25.9686 2.52214 25.7 3.19844 25.7H33.7984C34.4747 25.7 35.1233 25.9686 35.6016 26.4468C36.0798 26.925 36.3484 27.5736 36.3484 28.25C36.3484 28.9263 36.0798 29.5749 35.6016 30.0531C35.1233 30.5313 34.4747 30.7999 33.7984 30.7999H3.19844C2.52214 30.7999 1.87353 30.5313 1.39532 30.0531C0.917097 29.5749 0.648438 28.9263 0.648438 28.25Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const PromotionSvg = () => {
  return (
    <svg
      width="26"
      height="22"
      viewBox="0 0 26 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.6 1C3.955 1 1 3.86955 1 7.40914C1 13.8183 8.8 19.6448 13 21C17.2 19.6448 25 13.8183 25 7.40914C25 3.86955 22.045 1 18.4 1C16.168 1 14.194 2.07615 13 3.7233C12.3914 2.88149 11.5829 2.19448 10.6429 1.72044C9.70294 1.24639 8.65918 0.999274 7.6 1Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const PhoneiconSvg = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.00745 1.40686C3.68752 -0.27321 6.52266 -0.145492 7.69248 1.95063L8.34149 3.11356C9.10541 4.48238 8.77987 6.20946 7.66157 7.34143C7.64668 7.36184 7.56774 7.47677 7.55791 7.67758C7.54536 7.93391 7.63639 8.52668 8.55482 9.44511C9.47295 10.3632 10.0656 10.4545 10.3221 10.442C10.5231 10.4322 10.6381 10.3533 10.6585 10.3383C11.7905 9.22006 13.5176 8.89452 14.8864 9.65844L16.0493 10.3075C18.1454 11.4773 18.2731 14.3124 16.5931 15.9925C15.6944 16.8911 14.4995 17.6896 13.0953 17.7429C11.0144 17.8218 7.55913 17.2844 4.13735 13.8626C0.715564 10.4408 0.178177 6.98556 0.257065 4.90463C0.310297 3.50044 1.10879 2.30552 2.00745 1.40686ZM6.38265 2.68163C5.78363 1.60828 4.17394 1.36169 3.06811 2.46752C2.29276 3.24287 1.7887 4.09868 1.75599 4.96146C1.6902 6.6968 2.11864 9.72256 5.19801 12.8019C8.27737 15.8813 11.3031 16.3097 13.0385 16.2439C13.9013 16.2112 14.7571 15.7072 15.5324 14.9318C16.6382 13.826 16.3916 12.2163 15.3183 11.6173L14.1554 10.9683C13.432 10.5645 12.4158 10.7023 11.7025 11.4156L11.7023 11.4158C11.6322 11.4858 11.1864 11.9018 10.395 11.9403C9.58474 11.9797 8.604 11.6156 7.49416 10.5058C6.38395 9.39556 6.02003 8.41456 6.0597 7.60423C6.09846 6.81271 6.51468 6.36711 6.58432 6.29746L6.58436 6.29743C7.29767 5.58411 7.43539 4.56797 7.03166 3.84456L6.38265 2.68163Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const SupportSvg = () => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25 13H22.3333C20.8606 13 19.6667 14.1939 19.6667 15.6667V18.3333C19.6667 19.8061 20.8606 21 22.3333 21C23.8061 21 25 19.8061 25 18.3333V13ZM25 13C25 6.37258 19.6274 1 13 1C6.37258 1 1 6.37258 1 13M1 13V18.3333C1 19.8061 2.19391 21 3.66667 21C5.13943 21 6.33333 19.8061 6.33333 18.3333V15.6667C6.33333 14.1939 5.13943 13 3.66667 13H1Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25 15V20.7143C25 23.5714 24.1429 25 22.4286 25C20.7143 25 18.5714 25 16 25"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const LinkSvg = () => {
  return (<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26"><path fill="currentColor" d="M17.077 19v-2.923h-2.923v-1h2.923v-2.923h1v2.923H21v1h-2.923V19zm-6.462-2.923H7.078q-1.692 0-2.884-1.192T3 12t1.193-2.885t2.884-1.193h3.539v1H7.077q-1.27 0-2.173.904Q4 10.731 4 12t.904 2.173t2.173.904h3.539zM8.5 12.5v-1h7v1zM21 12h-1q0-1.27-.904-2.173q-.904-.904-2.173-.904h-3.538v-1h3.538q1.692 0 2.885 1.193T21 12" /></svg>)
}
export const MoneySvg = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="11" cy="11" r="10" stroke="currentColor" strokeWidth="1.5" />
      <path
        d="M11 16V16.5V17"
        stroke="currentColor"
        strokeWidth="1.5"
        stroke-linecap="round"
      />
      <path
        d="M11 5V5.5V6"
        stroke="currentColor"
        strokeWidth="1.5"
        stroke-linecap="round"
      />
      <path
        d="M14 8.5C14 7.11929 12.6569 6 11 6C9.34315 6 8 7.11929 8 8.5C8 9.88071 9.34315 11 11 11C12.6569 11 14 12.1193 14 13.5C14 14.8807 12.6569 16 11 16C9.34315 16 8 14.8807 8 13.5"
        stroke="currentColor"
        strokeWidth="1.5"
        stroke-linecap="round"
      />
    </svg>
  );
};

export const NewsletterSvg = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.94631 0.250001H12.0537C13.1865 0.249976 14.1123 0.249957 14.8431 0.348219C15.6071 0.450929 16.2694 0.673211 16.7981 1.2019C17.3268 1.7306 17.5491 2.39294 17.6518 3.15689C17.7023 3.53259 17.7268 3.95979 17.7388 4.44015C18.797 4.61086 19.6642 4.94692 20.3588 5.64144C21.1071 6.3898 21.4392 7.33875 21.5969 8.51117C21.75 9.65039 21.75 11.106 21.75 12.9438V13.0566C21.75 14.8944 21.75 16.35 21.5969 17.4892C21.4392 18.6616 21.1071 19.6106 20.3588 20.359C19.6104 21.1073 18.6614 21.4394 17.489 21.5971C16.3498 21.7502 14.8942 21.7502 13.0564 21.7502H8.94359C7.10583 21.7502 5.65019 21.7502 4.51098 21.5971C3.33856 21.4394 2.38961 21.1073 1.64124 20.359C0.89288 19.6106 0.560763 18.6616 0.403135 17.4892C0.249972 16.35 0.249984 14.8944 0.25 13.0566V12.9438C0.249984 11.106 0.249972 9.65038 0.403135 8.51117C0.560763 7.33875 0.89288 6.3898 1.64124 5.64144C2.33576 4.94692 3.20302 4.61086 4.26124 4.44015C4.27316 3.95979 4.29771 3.53259 4.34822 3.15689C4.45093 2.39294 4.67321 1.7306 5.2019 1.2019C5.7306 0.673211 6.39293 0.450929 7.15689 0.348219C7.88775 0.249957 8.81348 0.249976 9.94631 0.250001ZM4.25 5.96613C3.51901 6.11288 3.05575 6.34825 2.7019 6.7021C2.27869 7.12531 2.02502 7.70495 1.88976 8.71104C1.75159 9.73871 1.75 11.0934 1.75 13.0002C1.75 14.907 1.75159 16.2617 1.88976 17.2893C2.02502 18.2954 2.27869 18.8751 2.7019 19.2983C3.12511 19.7215 3.70476 19.9752 4.71085 20.1104C5.73851 20.2486 7.09318 20.2502 9 20.2502H13C14.9068 20.2502 16.2615 20.2486 17.2892 20.1104C18.2952 19.9752 18.8749 19.7215 19.2981 19.2983C19.7213 18.8751 19.975 18.2954 20.1102 17.2893C20.2484 16.2617 20.25 14.907 20.25 13.0002C20.25 11.0934 20.2484 9.73871 20.1102 8.71104C19.975 7.70495 19.7213 7.12531 19.2981 6.7021C18.9443 6.34825 18.481 6.11288 17.75 5.96613V7.1265C17.75 7.17264 17.75 7.21822 17.7501 7.26327C17.7509 8.04932 17.7516 8.67194 17.4904 9.22968C17.2291 9.78742 16.7504 10.1855 16.146 10.6881C16.1114 10.7169 16.0763 10.746 16.0409 10.7756L15.2837 11.4066C14.3973 12.1452 13.6789 12.7439 13.0448 13.1517C12.3843 13.5765 11.7411 13.8449 11 13.8449C10.2589 13.8449 9.61567 13.5765 8.95518 13.1517C8.32112 12.7439 7.60272 12.1452 6.71637 11.4066L5.95912 10.7756C5.92368 10.746 5.88864 10.7169 5.85401 10.6881C5.2496 10.1855 4.77086 9.78742 4.50963 9.22968C4.2484 8.67194 4.24906 8.04932 4.2499 7.26326C4.24995 7.21822 4.25 7.17264 4.25 7.1265L4.25 5.96613ZM7.35676 1.83484C6.75914 1.91519 6.4661 2.05902 6.26256 2.26256C6.05902 2.4661 5.91519 2.75914 5.83484 3.35676C5.75159 3.97595 5.75 4.80029 5.75 6V7.1265C5.75 8.11781 5.76657 8.37686 5.86801 8.59345C5.96946 8.81003 6.15786 8.9886 6.9194 9.62322L7.63903 10.2229C8.57199 11.0004 9.21973 11.5384 9.76658 11.8901C10.2959 12.2306 10.6549 12.3449 11 12.3449C11.3451 12.3449 11.7041 12.2306 12.2334 11.8901C12.7803 11.5384 13.428 11.0004 14.361 10.2229L15.0806 9.62322C15.8421 8.9886 16.0305 8.81003 16.132 8.59345C16.2334 8.37686 16.25 8.11781 16.25 7.1265V6C16.25 4.80029 16.2484 3.97595 16.1652 3.35676C16.0848 2.75914 15.941 2.4661 15.7374 2.26256C15.5339 2.05902 15.2409 1.91519 14.6432 1.83484C14.0241 1.75159 13.1997 1.75 12 1.75H10C8.80029 1.75 7.97595 1.75159 7.35676 1.83484ZM8.25 5C8.25 4.58579 8.58579 4.25 9 4.25H13C13.4142 4.25 13.75 4.58579 13.75 5C13.75 5.41422 13.4142 5.75 13 5.75H9C8.58579 5.75 8.25 5.41422 8.25 5ZM9.25 8C9.25 7.58579 9.58579 7.25 10 7.25H12C12.4142 7.25 12.75 7.58579 12.75 8C12.75 8.41422 12.4142 8.75 12 8.75H10C9.58579 8.75 9.25 8.41422 9.25 8Z"
        fill="cuRrenTColor"
      />
    </svg>
  );
};

export const LikeSvg = () => {
  return (
    <svg
      width="22"
      height="20"
      viewBox="0 0 22 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.62 18.71C11.28 18.83 10.72 18.83 10.38 18.71C7.48 17.72 1 13.59 1 6.59C1 3.5 3.49 1 6.56 1C8.38 1 9.99 1.88 11 3.24C12.01 1.88 13.63 1 15.44 1C18.51 1 21 3.5 21 6.59C21 13.59 14.52 17.72 11.62 18.71Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const InterestSvg = () => {
  return (
    <svg
      width="800px"
      height="800px"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.9752 12.1852L20.2361 12.0574L20.9752 12.1852ZM20.2696 16.265L19.5306 16.1371L20.2696 16.265ZM6.93777 20.4771L6.19056 20.5417L6.93777 20.4771ZM6.12561 11.0844L6.87282 11.0198L6.12561 11.0844ZM13.995 5.22142L14.7351 5.34269V5.34269L13.995 5.22142ZM13.3323 9.26598L14.0724 9.38725V9.38725L13.3323 9.26598ZM6.69814 9.67749L6.20855 9.10933H6.20855L6.69814 9.67749ZM8.13688 8.43769L8.62647 9.00585H8.62647L8.13688 8.43769ZM10.5181 4.78374L9.79208 4.59542L10.5181 4.78374ZM10.9938 2.94989L11.7197 3.13821V3.13821L10.9938 2.94989ZM12.6676 2.06435L12.4382 2.77841L12.4382 2.77841L12.6676 2.06435ZM12.8126 2.11093L13.042 1.39687L13.042 1.39687L12.8126 2.11093ZM9.86195 6.46262L10.5235 6.81599V6.81599L9.86195 6.46262ZM13.9047 3.24752L13.1787 3.43584V3.43584L13.9047 3.24752ZM11.6742 2.13239L11.3486 1.45675V1.45675L11.6742 2.13239ZM3.9716 21.4707L3.22439 21.5353L3.9716 21.4707ZM3 10.2342L3.74721 10.1696C3.71261 9.76945 3.36893 9.46758 2.96767 9.4849C2.5664 9.50221 2.25 9.83256 2.25 10.2342H3ZM20.2361 12.0574L19.5306 16.1371L21.0087 16.3928L21.7142 12.313L20.2361 12.0574ZM13.245 21.25H8.59635V22.75H13.245V21.25ZM7.68498 20.4125L6.87282 11.0198L5.3784 11.149L6.19056 20.5417L7.68498 20.4125ZM19.5306 16.1371C19.0238 19.0677 16.3813 21.25 13.245 21.25V22.75C17.0712 22.75 20.3708 20.081 21.0087 16.3928L19.5306 16.1371ZM13.2548 5.10015L12.5921 9.14472L14.0724 9.38725L14.7351 5.34269L13.2548 5.10015ZM7.18773 10.2456L8.62647 9.00585L7.64729 7.86954L6.20855 9.10933L7.18773 10.2456ZM11.244 4.97206L11.7197 3.13821L10.2678 2.76157L9.79208 4.59542L11.244 4.97206ZM12.4382 2.77841L12.5832 2.82498L13.042 1.39687L12.897 1.3503L12.4382 2.77841ZM10.5235 6.81599C10.8354 6.23198 11.0777 5.61339 11.244 4.97206L9.79208 4.59542C9.65573 5.12107 9.45699 5.62893 9.20042 6.10924L10.5235 6.81599ZM12.5832 2.82498C12.8896 2.92342 13.1072 3.16009 13.1787 3.43584L14.6307 3.05921C14.4252 2.26719 13.819 1.64648 13.042 1.39687L12.5832 2.82498ZM11.7197 3.13821C11.7548 3.0032 11.8523 2.87913 11.9998 2.80804L11.3486 1.45675C10.8166 1.71309 10.417 2.18627 10.2678 2.76157L11.7197 3.13821ZM11.9998 2.80804C12.1345 2.74311 12.2931 2.73181 12.4382 2.77841L12.897 1.3503C12.3873 1.18655 11.8312 1.2242 11.3486 1.45675L11.9998 2.80804ZM14.1537 10.9842H19.3348V9.4842H14.1537V10.9842ZM4.71881 21.4061L3.74721 10.1696L2.25279 10.2988L3.22439 21.5353L4.71881 21.4061ZM3.75 21.5127V10.2342H2.25V21.5127H3.75ZM3.22439 21.5353C3.2112 21.3828 3.33146 21.25 3.48671 21.25V22.75C4.21268 22.75 4.78122 22.1279 4.71881 21.4061L3.22439 21.5353ZM14.7351 5.34269C14.8596 4.58256 14.8241 3.80477 14.6307 3.0592L13.1787 3.43584C13.3197 3.97923 13.3456 4.54613 13.2548 5.10016L14.7351 5.34269ZM8.59635 21.25C8.12244 21.25 7.72601 20.887 7.68498 20.4125L6.19056 20.5417C6.29852 21.7902 7.3427 22.75 8.59635 22.75V21.25ZM8.62647 9.00585C9.30632 8.42 10.0392 7.72267 10.5235 6.81599L9.20042 6.10924C8.85404 6.75767 8.3025 7.30493 7.64729 7.86954L8.62647 9.00585ZM21.7142 12.313C21.9695 10.8365 20.8341 9.4842 19.3348 9.4842V10.9842C19.9014 10.9842 20.3332 11.4959 20.2361 12.0574L21.7142 12.313ZM3.48671 21.25C3.63292 21.25 3.75 21.3684 3.75 21.5127H2.25C2.25 22.1953 2.80289 22.75 3.48671 22.75V21.25ZM12.5921 9.14471C12.4344 10.1076 13.1766 10.9842 14.1537 10.9842V9.4842C14.1038 9.4842 14.0639 9.43901 14.0724 9.38725L12.5921 9.14471ZM6.87282 11.0198C6.8474 10.7258 6.96475 10.4378 7.18773 10.2456L6.20855 9.10933C5.62022 9.61631 5.31149 10.3753 5.3784 11.149L6.87282 11.0198Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const InterestfillSvg = () => {
  return (
    <svg
      width="650"
      height="717"
      viewBox="0 0 650 717"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25 299.473L49.907 297.32C48.7537 283.981 37.2977 273.919 23.9223 274.497C10.5467 275.074 0 286.085 0 299.473H25ZM599.537 360.246L576.02 496.237L625.29 504.76L648.807 368.766L599.537 360.246ZM366.5 666.666H211.545V716.666H366.5V666.666ZM181.166 638.75L154.094 325.66L104.28 329.966L131.352 643.056L181.166 638.75ZM576.02 496.237C559.127 593.923 471.043 666.666 366.5 666.666V716.666C494.04 716.666 604.027 627.7 625.29 504.76L576.02 496.237ZM366.827 128.338L344.737 263.157L394.08 271.241L416.17 136.423L366.827 128.338ZM164.591 299.853L212.549 258.528L179.91 220.651L131.952 261.977L164.591 299.853ZM299.8 124.068L315.657 62.9402L267.26 50.3855L251.403 111.514L299.8 124.068ZM339.607 50.9468L344.44 52.4992L359.733 4.89549L354.9 3.34316L339.607 50.9468ZM275.783 185.533C286.18 166.066 294.257 145.446 299.8 124.068L251.403 111.514C246.858 129.035 240.233 145.964 231.681 161.974L275.783 185.533ZM344.44 52.4992C354.653 55.7805 361.907 63.6695 364.29 72.8612L412.69 60.3068C405.84 33.9062 385.633 13.2158 359.733 4.89549L344.44 52.4992ZM315.657 62.9402C316.827 58.4398 320.077 54.3042 324.993 51.9345L303.287 6.8915C285.553 15.4362 272.233 31.2088 267.26 50.3855L315.657 62.9402ZM324.993 51.9345C329.483 49.7702 334.77 49.3935 339.607 50.9468L354.9 3.34316C337.91 -2.11517 319.373 -0.860171 303.287 6.8915L324.993 51.9345ZM396.79 324.473H569.493V274.473H396.79V324.473ZM82.2937 671.87L49.907 297.32L0.0929991 301.627L32.4797 676.176L82.2937 671.87ZM50 675.423V299.473H0V675.423H50ZM32.4797 676.176C32.04 671.093 36.0487 666.666 41.2237 666.666V716.666C65.4227 716.666 84.374 695.93 82.2937 671.87L32.4797 676.176ZM416.17 136.423C420.32 111.085 419.137 85.1592 412.69 60.3068L364.29 72.8612C368.99 90.9742 369.853 109.87 366.827 128.338L416.17 136.423ZM211.545 666.666C195.748 666.666 182.534 654.566 181.166 638.75L131.352 643.056C134.951 684.673 169.757 716.666 211.545 716.666V666.666ZM212.549 258.528C235.211 239 259.64 215.755 275.783 185.533L231.681 161.974C220.135 183.589 201.75 201.831 179.91 220.651L212.549 258.528ZM648.807 368.766C657.317 319.55 619.47 274.473 569.493 274.473V324.473C588.38 324.473 602.773 341.53 599.537 360.246L648.807 368.766ZM41.2237 666.666C46.0973 666.666 50 670.613 50 675.423H0C0 698.176 18.4297 716.666 41.2237 716.666V666.666ZM344.737 263.157C339.48 295.253 364.22 324.473 396.79 324.473V274.473C395.127 274.473 393.797 272.967 394.08 271.241L344.737 263.157ZM154.094 325.66C153.247 315.86 157.158 306.26 164.591 299.853L131.952 261.977C112.341 278.877 102.05 304.176 104.28 329.966L154.094 325.66Z"
        fill="currentColor"
      />
      <path
        d="M576.02 496.237L599.537 360.246C602.773 341.53 588.38 324.473 569.493 324.473H396.79C364.22 324.473 339.48 295.253 344.737 263.157L366.827 128.338C369.853 109.87 368.99 90.9742 364.29 72.8612C361.907 63.6695 354.653 55.7805 344.44 52.4992L339.607 50.9468C334.77 49.3935 329.483 49.7702 324.993 51.9345C320.077 54.3042 316.827 58.4398 315.657 62.9402L299.8 124.068C294.257 145.446 286.18 166.066 275.783 185.533C259.64 215.755 235.211 239 212.549 258.528L164.591 299.853C157.158 306.26 153.247 315.86 154.094 325.66L181.166 638.75C182.534 654.566 195.748 666.666 211.545 666.666H366.5C471.043 666.666 559.127 593.923 576.02 496.237Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const PaperclipSvg = () => {
  return (
    <svg
      width="20"
      height="22"
      viewBox="0 0 20 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.9175 16.8068L13.8084 9.25354C14.7558 8.34668 14.7558 6.87637 13.8084 5.96951C12.861 5.06265 11.325 5.06265 10.3776 5.96951L2.54387 13.4681C0.743819 15.1911 0.74382 17.9847 2.54387 19.7077C4.34391 21.4308 7.26237 21.4308 9.06242 19.7077L17.0105 12.0997C19.6632 9.5605 19.6632 5.44362 17.0105 2.90441C14.3578 0.365197 10.0569 0.365197 7.40419 2.90441L1 9.03461"
        stroke="currentColor"
        strokeWidth="1.5"
        stroke-linecap="round"
      />
    </svg>
  );
};

export const LikeFillSvg = () => {
  return (
    <svg
      width="22"
      height="20"
      viewBox="0 0 22 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.62 18.71C11.28 18.83 10.72 18.83 10.38 18.71C7.48 17.72 1 13.59 1 6.59C1 3.5 3.49 1 6.56 1C8.38 1 9.99 1.88 11 3.24C12.01 1.88 13.63 1 15.44 1C18.51 1 21 3.5 21 6.59C21 13.59 14.52 17.72 11.62 18.71Z"
        fill="currentColor"
        stroke="currentColor"
      />
    </svg>
  );
};

export const VendorSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      data-name="Layer 1"
      viewBox="0 0 53 53"
      id="partnership"
    >
      <path
        d="M8.75 29.17a1 1 0 0 0 .7.32 1 1 0 0 0 .68-.27l.27-.25 2.75 2.93a2.9 2.9 0 0 0 .14 3.92 2.84 2.84 0 0 0 1.86.83 2.9 2.9 0 0 0 .85 1.86 2.86 2.86 0 0 0 1.86.83 2.9 2.9 0 0 0 .83 1.86 2.86 2.86 0 0 0 1.86.83 2.9 2.9 0 0 0 4.94 1.86l.35-.35.33.34a2.93 2.93 0 0 0 4.15 0 2.88 2.88 0 0 0 .85-1.88 2.9 2.9 0 0 0 1.9-.85 2.86 2.86 0 0 0 .84-1.89 2.93 2.93 0 0 0 1.9-.84 3 3 0 0 0 .84-1.9 2.91 2.91 0 0 0 2.75-2.92 2.9 2.9 0 0 0-.51-1.6l2.93-2.84.32.37a1 1 0 0 0 .75.34 1 1 0 0 0 .66-.25l6.61-5.81a1 1 0 0 0 .09-1.41L38.17 8.6a1 1 0 0 0-1.42-.09l-6.6 5.8a1 1 0 0 0-.34.69 1 1 0 0 0 .25.72l.52.6h-.38a11.62 11.62 0 0 0-5.39 2.13L23.35 17l.23-.21a1 1 0 0 0 .06-1.42l-6-6.44a1 1 0 0 0-.64-.34 1 1 0 0 0-.72.26L2.82 21.31a1 1 0 0 0 0 1.41Zm6 4 1.38-1.38a.9.9 0 0 1 1.54.63.9.9 0 0 1-.26.64L16 34.41a.9.9 0 0 1-1.27 0 .91.91 0 0 1 .01-1.28Zm2.42 3.33a.91.91 0 0 1 .27-.64l1.38-1.38a.89.89 0 0 1 1.28 0 .88.88 0 0 1 .26.63.9.9 0 0 1-.26.64l-1.4 1.35a.91.91 0 0 1-1.54-.64Zm2.69 2.69a.91.91 0 0 1 .27-.64l1.38-1.38a.89.89 0 0 1 1.28 0 .88.88 0 0 1 .26.63.9.9 0 0 1-.26.64l-1.39 1.39a.9.9 0 0 1-1.27 0 .91.91 0 0 1-.28-.68Zm3 3.33a.89.89 0 0 1 0-1.28l1.38-1.38a.89.89 0 0 1 1.28 0 .91.91 0 0 1 0 1.27l-.33.33-1.06 1.06a.9.9 0 0 1-1.32-.04Zm14.46-31.85 10.77 12.25L43 27.41 32.22 15.16Zm-6.88 7.68 1.33-.16a.9.9 0 0 0 .28-.08h.08l8.36 9.52-3 2.88-8.12-8.54a1 1 0 0 0-1.25-.16L26 23.16a4.86 4.86 0 0 1-4.42.36l4.19-3.25a9.55 9.55 0 0 1 4.67-1.92ZM23.2 19.7l-3.08 2.39a1.82 1.82 0 0 0-.71 1.65 1.85 1.85 0 0 0 1 1.48 6.9 6.9 0 0 0 6.59-.37l1.51-.94 8.25 8.68.33.33a.9.9 0 0 1 .27.66.91.91 0 0 1-.27.66.94.94 0 0 1-1.32 0 1 1 0 0 0-1.42 1.41.93.93 0 0 1-1.28 1.35 1 1 0 0 0-1.42 1.42.93.93 0 0 1 0 1.32 1 1 0 0 1-1.33 0 1 1 0 0 0-1.41 1.41.94.94 0 0 1-1.32 1.33l-.38-.38a2.89 2.89 0 0 0-.34-3.69 2.91 2.91 0 0 0-1.87-.84 2.87 2.87 0 0 0-2.7-2.69 2.79 2.79 0 0 0-2.68-2.66 2.89 2.89 0 0 0-.84-1.89 3 3 0 0 0-4.1 0l-.14.14-2.64-2.86 10-9.27ZM16.87 11l4.62 5L9.8 26.83l-.25.24-4.63-5Z"
        fill="currentColor"
      ></path>
    </svg>
  );
};

export const ShopSvg = () => {
  return (
    <svg
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.61328 6.89737H10.2269V1H6.37417L5.61328 6.89737Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.37449 1H3.19655C2.98511 1.00006 2.77978 1.07092 2.61332 1.20128C2.44685 1.33164 2.32883 1.51399 2.27809 1.71925L1 6.89737M1 6.89737H5.6136M1 6.89737C1 7.50917 1.24304 8.09591 1.67565 8.52852C2.10826 8.96113 2.695 9.20417 3.3068 9.20417C3.9186 9.20417 4.50535 8.96113 4.93796 8.52852C5.37056 8.09591 5.6136 7.50917 5.6136 6.89737M5.6136 6.89737C5.6136 7.50917 5.85664 8.09591 6.28925 8.52852C6.72186 8.96113 7.3086 9.20417 7.9204 9.20417C8.53221 9.20417 9.11895 8.96113 9.55156 8.52852C9.98417 8.09591 10.2272 7.50917 10.2272 6.89737M10.2272 6.89737H14.8408M10.2272 6.89737V1H14.0799M10.2272 6.89737C10.2272 7.50917 10.4702 8.09591 10.9029 8.52852C11.3355 8.96113 11.9222 9.20417 12.534 9.20417C13.1458 9.20417 13.7326 8.96113 14.1652 8.52852C14.5978 8.09591 14.8408 7.50917 14.8408 6.89737M14.8408 6.89737L14.0799 1M14.8408 6.89737H19.4544M14.8408 6.89737C14.8408 7.50917 15.0838 8.09591 15.5165 8.52852C15.9491 8.96113 16.5358 9.20417 17.1476 9.20417C17.7594 9.20417 18.3462 8.96113 18.7788 8.52852C19.2114 8.09591 19.4544 7.50917 19.4544 6.89737M14.0799 1H17.2579C17.4693 1.00006 17.6746 1.07092 17.8411 1.20128C18.0076 1.33164 18.1256 1.51399 18.1763 1.71925L19.4544 6.89737"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.33594 8.98877V16.0535C2.33594 16.3045 2.43565 16.5452 2.61313 16.7227C2.79061 16.9002 3.03132 16.9999 3.28232 16.9999H17.1704C17.4214 16.9999 17.6622 16.9002 17.8396 16.7227C18.0171 16.5452 18.1168 16.3045 18.1168 16.0535V8.98877"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CallSvg = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.67962 1.76482L2.73734 1.70711C3.12786 1.31658 3.76103 1.31658 4.15155 1.70711L7.18178 4.73734C7.57231 5.12786 7.57231 5.76103 7.18178 6.15155L5.96861 7.36473C5.78829 7.54504 5.74359 7.82051 5.85763 8.04859C7.17614 10.6856 9.31438 12.8239 11.9514 14.1424C12.1795 14.2564 12.455 14.2117 12.6353 14.0314L13.8484 12.8182C14.239 12.4277 14.8721 12.4277 15.2627 12.8182L18.2929 15.8484C18.6834 16.239 18.6834 16.8721 18.2929 17.2627L18.2352 17.3204C16.1238 19.4317 12.7813 19.6693 10.3925 17.8777L8.29524 16.3048C6.55171 14.9971 5.00289 13.4483 3.69524 11.7048L2.12226 9.60746C0.330722 7.21874 0.568269 3.87617 2.67962 1.76482Z"
        stroke="currentColor"
        strokeWidth="1.2"
      />
    </svg>
  );
};

export const WhatsAppSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 50 50"
      width="100px"
      height="100px"
    >
      <path
        stroke="currentColor"
        d="M 25 2 C 12.309534 2 2 12.309534 2 25 C 2 29.079097 3.1186875 32.88588 4.984375 36.208984 L 2.0371094 46.730469 A 1.0001 1.0001 0 0 0 3.2402344 47.970703 L 14.210938 45.251953 C 17.434629 46.972929 21.092591 48 25 48 C 37.690466 48 48 37.690466 48 25 C 48 12.309534 37.690466 2 25 2 z M 25 4 C 36.609534 4 46 13.390466 46 25 C 46 36.609534 36.609534 46 25 46 C 21.278025 46 17.792121 45.029635 14.761719 43.333984 A 1.0001 1.0001 0 0 0 14.033203 43.236328 L 4.4257812 45.617188 L 7.0019531 36.425781 A 1.0001 1.0001 0 0 0 6.9023438 35.646484 C 5.0606869 32.523592 4 28.890107 4 25 C 4 13.390466 13.390466 4 25 4 z M 16.642578 13 C 16.001539 13 15.086045 13.23849 14.333984 14.048828 C 13.882268 14.535548 12 16.369511 12 19.59375 C 12 22.955271 14.331391 25.855848 14.613281 26.228516 L 14.615234 26.228516 L 14.615234 26.230469 C 14.588494 26.195329 14.973031 26.752191 15.486328 27.419922 C 15.999626 28.087653 16.717405 28.96464 17.619141 29.914062 C 19.422612 31.812909 21.958282 34.007419 25.105469 35.349609 C 26.554789 35.966779 27.698179 36.339417 28.564453 36.611328 C 30.169845 37.115426 31.632073 37.038799 32.730469 36.876953 C 33.55263 36.755876 34.456878 36.361114 35.351562 35.794922 C 36.246248 35.22873 37.12309 34.524722 37.509766 33.455078 C 37.786772 32.688244 37.927591 31.979598 37.978516 31.396484 C 38.003976 31.104927 38.007211 30.847602 37.988281 30.609375 C 37.969311 30.371148 37.989581 30.188664 37.767578 29.824219 C 37.302009 29.059804 36.774753 29.039853 36.224609 28.767578 C 35.918939 28.616297 35.048661 28.191329 34.175781 27.775391 C 33.303883 27.35992 32.54892 26.991953 32.083984 26.826172 C 31.790239 26.720488 31.431556 26.568352 30.914062 26.626953 C 30.396569 26.685553 29.88546 27.058933 29.587891 27.5 C 29.305837 27.918069 28.170387 29.258349 27.824219 29.652344 C 27.819619 29.649544 27.849659 29.663383 27.712891 29.595703 C 27.284761 29.383815 26.761157 29.203652 25.986328 28.794922 C 25.2115 28.386192 24.242255 27.782635 23.181641 26.847656 L 23.181641 26.845703 C 21.603029 25.455949 20.497272 23.711106 20.148438 23.125 C 20.171937 23.09704 20.145643 23.130901 20.195312 23.082031 L 20.197266 23.080078 C 20.553781 22.728924 20.869739 22.309521 21.136719 22.001953 C 21.515257 21.565866 21.68231 21.181437 21.863281 20.822266 C 22.223954 20.10644 22.02313 19.318742 21.814453 18.904297 L 21.814453 18.902344 C 21.828863 18.931014 21.701572 18.650157 21.564453 18.326172 C 21.426943 18.001263 21.251663 17.580039 21.064453 17.130859 C 20.690033 16.232501 20.272027 15.224912 20.023438 14.634766 L 20.023438 14.632812 C 19.730591 13.937684 19.334395 13.436908 18.816406 13.195312 C 18.298417 12.953717 17.840778 13.022402 17.822266 13.021484 L 17.820312 13.021484 C 17.450668 13.004432 17.045038 13 16.642578 13 z M 16.642578 15 C 17.028118 15 17.408214 15.004701 17.726562 15.019531 C 18.054056 15.035851 18.033687 15.037192 17.970703 15.007812 C 17.906713 14.977972 17.993533 14.968282 18.179688 15.410156 C 18.423098 15.98801 18.84317 16.999249 19.21875 17.900391 C 19.40654 18.350961 19.582292 18.773816 19.722656 19.105469 C 19.863021 19.437122 19.939077 19.622295 20.027344 19.798828 L 20.027344 19.800781 L 20.029297 19.802734 C 20.115837 19.973483 20.108185 19.864164 20.078125 19.923828 C 19.867096 20.342656 19.838461 20.445493 19.625 20.691406 C 19.29998 21.065838 18.968453 21.483404 18.792969 21.65625 C 18.639439 21.80707 18.36242 22.042032 18.189453 22.501953 C 18.016221 22.962578 18.097073 23.59457 18.375 24.066406 C 18.745032 24.6946 19.964406 26.679307 21.859375 28.347656 C 23.05276 29.399678 24.164563 30.095933 25.052734 30.564453 C 25.940906 31.032973 26.664301 31.306607 26.826172 31.386719 C 27.210549 31.576953 27.630655 31.72467 28.119141 31.666016 C 28.607627 31.607366 29.02878 31.310979 29.296875 31.007812 L 29.298828 31.005859 C 29.655629 30.601347 30.715848 29.390728 31.224609 28.644531 C 31.246169 28.652131 31.239109 28.646231 31.408203 28.707031 L 31.408203 28.708984 L 31.410156 28.708984 C 31.487356 28.736474 32.454286 29.169267 33.316406 29.580078 C 34.178526 29.990889 35.053561 30.417875 35.337891 30.558594 C 35.748225 30.761674 35.942113 30.893881 35.992188 30.894531 C 35.995572 30.982516 35.998992 31.07786 35.986328 31.222656 C 35.951258 31.624292 35.8439 32.180225 35.628906 32.775391 C 35.523582 33.066746 34.975018 33.667661 34.283203 34.105469 C 33.591388 34.543277 32.749338 34.852514 32.4375 34.898438 C 31.499896 35.036591 30.386672 35.087027 29.164062 34.703125 C 28.316336 34.437036 27.259305 34.092596 25.890625 33.509766 C 23.114812 32.325956 20.755591 30.311513 19.070312 28.537109 C 18.227674 27.649908 17.552562 26.824019 17.072266 26.199219 C 16.592866 25.575584 16.383528 25.251054 16.208984 25.021484 L 16.207031 25.019531 C 15.897202 24.609805 14 21.970851 14 19.59375 C 14 17.077989 15.168497 16.091436 15.800781 15.410156 C 16.132721 15.052495 16.495617 15 16.642578 15 z"
      />
    </svg>
  );
};

export const EmailSvg2 = () => {
  return (
    <svg
      width="17"
      height="13"
      viewBox="0 0 17 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.9375 0H1.0625C0.780707 0 0.510456 0.114137 0.311199 0.317301C0.111942 0.520465 0 0.796016 0 1.08333V11.9167C0 12.204 0.111942 12.4795 0.311199 12.6827C0.510456 12.8859 0.780707 13 1.0625 13H15.9375C16.2193 13 16.4895 12.8859 16.6888 12.6827C16.8881 12.4795 17 12.204 17 11.9167V1.08333C17 0.796016 16.8881 0.520465 16.6888 0.317301C16.4895 0.114137 16.2193 0 15.9375 0ZM15.1194 11.9167H1.94437L5.66313 7.995L4.89813 7.24208L1.0625 11.2883V1.90667L7.66594 8.60708C7.86501 8.80886 8.1343 8.92211 8.415 8.92211C8.6957 8.92211 8.96499 8.80886 9.16406 8.60708L15.9375 1.73875V11.2179L12.0275 7.23125L11.2784 7.995L15.1194 11.9167ZM1.75844 1.08333H15.0769L8.415 7.83792L1.75844 1.08333Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const UserSvg2 = () => {
  return (
    <svg
      width="17"
      height="18"
      viewBox="0 0 17 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.50057 9.73771C11.0948 9.73771 13.1981 7.55764 13.1981 4.86885C13.1981 2.18007 11.0948 0 8.50057 0C5.90638 0 3.80302 2.18007 3.80302 4.86885C3.80587 7.55646 5.90809 9.73475 8.50057 9.73771ZM8.50057 1.47541C10.309 1.47541 11.7746 2.99449 11.7746 4.86885C11.7746 6.74321 10.309 8.26229 8.50057 8.26229C6.69216 8.26229 5.22652 6.74321 5.22652 4.86885C5.2288 2.99567 6.69329 1.47777 8.50057 1.47541ZM16.9835 17.1053C16.0986 13.0308 12.6373 10.0328 8.5 10.0328C4.36274 10.0328 0.90136 13.0308 0.0273312 17.0451L0.0165126 17.1053C0.00626342 17.1525 0 17.2068 0 17.2623C0 17.6695 0.318864 18 0.71175 18C1.05111 18 1.33524 17.7533 1.40642 17.424L1.40756 17.4193C2.14835 14.014 5.04203 11.5082 8.50057 11.5082C11.9591 11.5082 14.8522 14.0134 15.5839 17.3685L15.593 17.4187C15.6648 17.7527 15.9477 17.9994 16.2871 17.9994C16.3412 17.9994 16.3936 17.9929 16.4443 17.9811L16.4397 17.9823C16.7626 17.9085 17 17.6146 17 17.2629C17 17.2068 16.9937 17.1525 16.9823 17.1L16.9835 17.1053Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const LocationSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="20"
      viewBox="0 0 16 20"
      fill="none"
    >
      <path
        d="M8 10C8.55 10 9.021 9.804 9.413 9.412C9.80433 9.02067 10 8.55 10 8C10 7.45 9.80433 6.979 9.413 6.587C9.021 6.19567 8.55 6 8 6C7.45 6 6.97933 6.19567 6.588 6.587C6.196 6.979 6 7.45 6 8C6 8.55 6.196 9.02067 6.588 9.412C6.97933 9.804 7.45 10 8 10ZM8 17.35C10.0333 15.4833 11.5417 13.7873 12.525 12.262C13.5083 10.7373 14 9.38333 14 8.2C14 6.38333 13.4207 4.89567 12.262 3.737C11.104 2.579 9.68333 2 8 2C6.31667 2 4.89567 2.579 3.737 3.737C2.579 4.89567 2 6.38333 2 8.2C2 9.38333 2.49167 10.7373 3.475 12.262C4.45833 13.7873 5.96667 15.4833 8 17.35ZM8 20C5.31667 17.7167 3.31267 15.5957 1.988 13.637C0.662667 11.679 0 9.86667 0 8.2C0 5.7 0.804333 3.70833 2.413 2.225C4.021 0.741667 5.88333 0 8 0C10.1167 0 11.979 0.741667 13.587 2.225C15.1957 3.70833 16 5.7 16 8.2C16 9.86667 15.3377 11.679 14.013 13.637C12.6877 15.5957 10.6833 17.7167 8 20Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const PasseyeSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.9202 12.7988C15.9725 12.5407 16 12.2736 16 12C16 9.79086 14.2091 8 12 8C11.7264 8 11.4593 8.02746 11.2012 8.07977L12.1239 9.00251C13.6822 9.06583 14.9342 10.3178 14.9975 11.8761L15.9202 12.7988ZM9.39311 10.5143C9.14295 10.9523 9 11.4595 9 12C9 13.6569 10.3431 15 12 15C12.5405 15 13.0477 14.857 13.4857 14.6069L14.212 15.3332C13.5784 15.7545 12.8179 16 12 16C9.79086 16 8 14.2091 8 12C8 11.1821 8.24547 10.4216 8.66676 9.78799L9.39311 10.5143Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.1537 17.2751L15.4193 16.5406C14.3553 17.1196 13.1987 17.5 12 17.5C10.3282 17.5 8.73816 16.7599 7.36714 15.7735C6.00006 14.79 4.89306 13.5918 4.19792 12.7478C3.77356 12.2326 3.72974 12.1435 3.72974 12C3.72974 11.8565 3.77356 11.7674 4.19792 11.2522C4.86721 10.4396 5.9183 9.29863 7.21572 8.33704L6.50139 7.62271C5.16991 8.63072 4.10383 9.79349 3.42604 10.6164L3.36723 10.6876C3.03671 11.087 2.72974 11.4579 2.72974 12C2.72974 12.5421 3.0367 12.913 3.36723 13.3124L3.42604 13.3836C4.15099 14.2638 5.32014 15.5327 6.78312 16.5853C8.24216 17.635 10.0361 18.5 12 18.5C13.5101 18.5 14.9196 17.9886 16.1537 17.2751ZM9.18993 6.06861C10.0698 5.71828 11.0135 5.5 12 5.5C13.9639 5.5 15.7579 6.365 17.2169 7.41472C18.6799 8.46727 19.849 9.73623 20.574 10.6164L20.6328 10.6876C20.9633 11.087 21.2703 11.4579 21.2703 12C21.2703 12.5421 20.9633 12.913 20.6328 13.3124L20.574 13.3836C20.0935 13.9669 19.418 14.721 18.5911 15.4697L17.883 14.7617C18.6787 14.0456 19.3338 13.3164 19.8021 12.7478C20.2265 12.2326 20.2703 12.1435 20.2703 12C20.2703 11.8565 20.2265 11.7674 19.8021 11.2522C19.107 10.4082 18 9.21001 16.6329 8.22646C15.2619 7.24007 13.6718 6.5 12 6.5C11.3056 6.5 10.6253 6.62768 9.96897 6.84765L9.18993 6.06861Z"
        fill="currentColor"
      />
      <path d="M5 2L21 18" stroke="currentColor" />
    </svg>
  );
};
export const PasseyeopenSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <circle cx="12" cy="12" r="3.5" stroke="currentColor" />
      <path
        d="M20.188 10.9343C20.5762 11.4056 20.7703 11.6412 20.7703 12C20.7703 12.3588 20.5762 12.5944 20.188 13.0657C18.7679 14.7899 15.6357 18 12 18C8.36427 18 5.23206 14.7899 3.81197 13.0657C3.42381 12.5944 3.22973 12.3588 3.22973 12C3.22973 11.6412 3.42381 11.4056 3.81197 10.9343C5.23206 9.21014 8.36427 6 12 6C15.6357 6 18.7679 9.21014 20.188 10.9343Z"
        stroke="currentColor"
      />
    </svg>
  );
};

export const Pdf_Svg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="36"
      viewBox="0 0 28 36"
      fill="none"
    >
      <path
        d="M7.46741 22.6899C7.14541 22.6899 6.92841 22.7214 6.81641 22.7529V24.8144C6.94941 24.8459 7.11566 24.8547 7.34491 24.8547C8.18316 24.8547 8.69941 24.4312 8.69941 23.7154C8.69941 23.0749 8.25491 22.6899 7.46741 22.6899ZM13.5697 22.7109C13.2197 22.7109 12.9922 22.7424 12.8574 22.7739V27.3414C12.9922 27.3729 13.2092 27.3729 13.4052 27.3729C14.8349 27.3834 15.7659 26.5959 15.7659 24.9299C15.7764 23.4774 14.9277 22.7109 13.5697 22.7109Z"
        fill="currentColor"
      />
      <path
        d="M17.5 0.5H3.5C2.57174 0.5 1.6815 0.868749 1.02513 1.52513C0.368749 2.1815 0 3.07174 0 4V32C0 32.9283 0.368749 33.8185 1.02513 34.4749C1.6815 35.1312 2.57174 35.5 3.5 35.5H24.5C25.4283 35.5 26.3185 35.1312 26.9749 34.4749C27.6313 33.8185 28 32.9283 28 32V11L17.5 0.5ZM9.6215 25.3325C9.08075 25.84 8.28275 26.0675 7.3535 26.0675C7.17332 26.0695 6.99322 26.0589 6.8145 26.036V28.5315H5.25V21.6435C5.95605 21.5382 6.66946 21.4902 7.38325 21.5C8.358 21.5 9.051 21.6855 9.51825 22.0583C9.96275 22.4118 10.2638 22.991 10.2638 23.6735C10.262 24.3595 10.0345 24.9388 9.6215 25.3325ZM16.2838 27.7038C15.5488 28.3145 14.4305 28.605 13.0638 28.605C12.2448 28.605 11.6655 28.5525 11.2718 28.5V21.6453C11.9781 21.5422 12.6912 21.4936 13.405 21.5C14.7298 21.5 15.5908 21.738 16.2628 22.2455C16.989 22.7845 17.444 23.6438 17.444 24.8775C17.444 26.2128 16.9558 27.135 16.2838 27.7038ZM22.75 22.8475H20.069V24.4417H22.575V25.7263H20.069V28.5332H18.4835V21.5525H22.75V22.8475ZM17.5 12.75H15.75V4L24.5 12.75H17.5Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const ApprovedSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
    >
      <path
        d="M3.07222 3.06668L0 6.1389V16.0056C0 24.85 0.0111111 25.9 0.0888889 26.1722C0.322222 26.9667 0.977778 27.5611 1.80556 27.7222C2.05 27.7667 4.51111 27.7778 10.9444 27.7667L19.75 27.75L20.1222 27.5722C20.9 27.2056 21.3667 26.5445 21.4278 25.7445C21.4611 25.35 21.4667 25.3278 21.5778 25.3611C21.8389 25.4333 22.0611 25.4556 22.25 25.4222C22.5056 25.3722 22.8611 25.05 22.95 24.7945L23.0111 24.6L23.2833 24.6333C23.8111 24.7056 24.3 24.4389 24.5056 23.9722C24.6167 23.7222 24.6611 23.1556 24.5889 22.9556C24.55 22.8389 24.5611 22.8278 24.6778 22.8445C24.8056 22.8611 24.8056 22.8722 24.8222 23.65C24.8444 24.7389 24.7333 24.6667 26.4278 24.6667H27.7278L27.8611 24.5278L28 24.3945V19.9445V15.4945L27.8611 15.3611L27.7278 15.2222H26.4278C25.1944 15.2222 25.1167 15.2278 24.9778 15.3389C24.8556 15.4333 24.8333 15.4945 24.8333 15.7278C24.8333 15.8778 24.8278 16 24.8167 16C24.7389 16 23.0111 15.4833 22.7722 15.3889C22.6056 15.3222 22.2278 15.1389 21.9333 14.9833L21.3889 14.6945L21.3778 8.1389L21.3611 1.58335L21.1833 1.24446C20.9556 0.80557 20.4389 0.327792 20.0167 0.15557L19.6944 0.0277924L12.9167 0.0111257L6.14444 1.46322e-05L3.07222 3.06668ZM19.7667 0.977793C20.0278 1.08335 20.3056 1.35001 20.4611 1.6389L20.5833 1.86113L20.6 8.13335L20.6111 14.4L20.4889 14.3667C19.4722 14.0611 18.3278 14.0333 17.7778 14.2889C17.5944 14.3722 16.8889 14.9056 16.0333 15.6056C14.8611 16.5667 14.5778 16.7722 14.4778 16.7445C14.4167 16.7222 14.2722 16.6778 14.1667 16.6389L13.9722 16.5722L13.9556 16.0111C13.9333 15.1889 14 15.2222 12.3611 15.2222C11.1389 15.2222 11.0611 15.2278 10.9222 15.3389L10.7778 15.45V19.9445V24.4389L10.9222 24.55C11.0611 24.6611 11.1389 24.6667 12.3611 24.6667C14.0278 24.6667 13.9444 24.7111 13.9444 23.7722C13.9444 23.3222 13.9667 23.1111 14.0056 23.1111C14.0889 23.1111 14.4389 23.3667 15.7222 24.3778C17.8278 26.0278 18.4833 26.3833 19.1389 26.2167C19.3222 26.1722 19.4444 26.0889 19.5778 25.9333C19.7611 25.7222 19.7722 25.7167 19.9833 25.7722C20.1 25.8056 20.2611 25.8333 20.35 25.8333C20.5222 25.8333 20.5333 25.8722 20.4111 26.1556C20.3 26.4278 20.0778 26.6556 19.8056 26.7833C19.5944 26.8833 19.2333 26.8889 10.7778 26.8889C5.03889 26.8889 1.9 26.8667 1.77222 26.8333C1.47222 26.75 1.08333 26.3778 0.961111 26.0667C0.866667 25.8167 0.861111 25.3667 0.861111 16.2778V6.75001L3.67778 6.73335L6.49444 6.72224L6.60556 6.57779C6.72222 6.43335 6.72222 6.37224 6.72222 3.66113V0.888904H13.1389C18.8111 0.888904 19.5833 0.900015 19.7667 0.977793ZM5.83333 3.69446V5.8889H3.66667C2.47778 5.8889 1.5 5.87224 1.5 5.85001C1.5 5.81113 5.78333 1.50001 5.81667 1.50001C5.82778 1.50001 5.83333 2.4889 5.83333 3.69446ZM19.3222 15C19.9056 15.0945 20.5444 15.3222 21.3611 15.7222C22.1278 16.0945 23.0889 16.4445 24.2111 16.75L24.7778 16.9056V19.4667V22.0278L24.5333 22.0333C24.4 22.0389 24.2167 22.0778 24.1222 22.1222L23.9556 22.2111L21.8611 19.7667C20.7056 18.4222 19.7 17.3 19.6278 17.2722C19.2667 17.1389 18.8611 17.2611 18.4056 17.65C17.8333 18.1389 17.3167 18.4445 16.7333 18.6389C16.3222 18.7722 15.7 18.7667 15.3778 18.6222C14.9833 18.45 14.5944 17.9889 14.6778 17.7889C14.6833 17.7611 15.1222 17.3945 15.6389 16.9667C18.2556 14.8389 18.0778 14.9611 18.6667 14.95C18.8333 14.95 19.1278 14.9722 19.3222 15ZM13.1111 19.9445V23.7778H12.3611H11.6111V19.9445V16.1111H12.3611H13.1111V19.9445ZM27.1667 19.9445V23.7778H26.4167H25.6667V19.9445V16.1111H26.4167H27.1667V19.9445ZM21.5278 20.7333C23.9167 23.4833 23.8778 23.4278 23.7111 23.7389C23.6667 23.8278 23.6167 23.8389 23.4278 23.8111C23.0889 23.7556 22.9944 23.6722 22.55 23.05C22.3278 22.7445 22.0944 22.4556 22.0222 22.4056C21.7778 22.2445 21.3889 22.4667 21.3889 22.7611C21.3889 22.8556 21.5389 23.1389 21.7889 23.5167C22.1667 24.0889 22.1833 24.1278 22.1333 24.3222C22.0722 24.5778 21.9333 24.6111 21.6222 24.45C21.3778 24.3278 21.1833 24.1 20.7222 23.4278C20.5556 23.1833 20.3667 22.9667 20.2944 22.9389C20.1389 22.8833 19.85 22.9778 19.7778 23.1111C19.6611 23.3278 19.7278 23.5111 20.1167 24.0945C20.4778 24.6278 20.5056 24.6945 20.45 24.8167C20.3944 24.9445 20.3611 24.9556 20.1611 24.9278C19.8278 24.8833 19.7056 24.7778 19.25 24.1167C19.0222 23.7833 18.7944 23.4945 18.7444 23.4778C18.4611 23.3722 18.1111 23.5778 18.1111 23.8556C18.1111 23.9389 18.2778 24.2389 18.5 24.5722C18.9278 25.2111 18.9833 25.3889 18.7333 25.3889C18.3667 25.3889 16.3111 23.9667 14.9444 22.7611C14.8056 22.6389 14.5111 22.4556 14.2944 22.35L13.8889 22.1556V20.2611C13.8889 18.4833 13.8944 18.3722 13.9778 18.5C14.1722 18.7889 14.5944 19.1833 14.8556 19.3167C15.6444 19.7167 16.6167 19.6667 17.6222 19.1611C18.1111 18.9222 18.5833 18.6056 18.9167 18.3111C19.0389 18.2056 19.1667 18.1167 19.1944 18.1111C19.2278 18.1111 20.2778 19.2889 21.5278 20.7333Z"
        fill="currentColor"
      />
      <path
        d="M9.17776 3.07225C9.01665 3.24447 9.01665 3.50002 9.18332 3.65558L9.3111 3.7778H14.0944C18.5722 3.7778 18.8778 3.77225 18.9611 3.6778C19.1111 3.51113 19.1055 3.21669 18.9444 3.05558C18.8333 2.94447 18.7611 2.94447 14.0667 2.94447H9.29443L9.17776 3.07225Z"
        fill="currentColor"
      />
      <path
        d="M9.16665 6.00001C9.01109 6.15556 9.02221 6.41667 9.19443 6.58334L9.32776 6.72223H14.0722C18.5555 6.72223 18.8278 6.71667 18.9444 6.62223C19.1167 6.48334 19.1167 6.12778 18.9444 5.9889C18.8278 5.89445 18.55 5.8889 14.05 5.8889C9.34998 5.8889 9.27776 5.8889 9.16665 6.00001Z"
        fill="currentColor"
      />
      <path
        d="M2.69446 8.81669C2.36113 8.90002 2.26668 9.33891 2.53335 9.55002L2.68335 9.66669H10.7556C18.7611 9.66669 18.8334 9.66669 18.9445 9.55558C19.1111 9.38891 19.1111 9.09446 18.9389 8.91669C18.8334 8.80558 18.75 8.80558 10.8167 8.80002C6.41113 8.79446 2.75557 8.80002 2.69446 8.81669Z"
        fill="currentColor"
      />
      <path
        d="M2.53332 11.8389C2.32776 12 2.32776 12.3333 2.53332 12.4944L2.68332 12.6111H10.7278H18.7722L18.9111 12.4833C19.1389 12.2778 19.1111 11.9 18.8611 11.7889C18.7555 11.7389 16.7111 11.7222 10.7 11.7222H2.68332L2.53332 11.8389Z"
        fill="currentColor"
      />
      <path
        d="M2.50002 14.7778C2.35558 14.9222 2.35002 15.2778 2.48891 15.4056C2.58335 15.4889 2.91669 15.5 6.15558 15.5C9.65002 15.5 9.72224 15.5 9.83335 15.3889C9.98891 15.2333 9.9778 14.9722 9.80558 14.8056L9.67224 14.6667H6.13891C2.68335 14.6667 2.61113 14.6667 2.50002 14.7778Z"
        fill="currentColor"
      />
      <path
        d="M2.51111 17.7C2.35 17.8111 2.33889 18.1722 2.5 18.3333C2.61111 18.4445 2.68334 18.4445 6.15556 18.4445H9.70556L9.82223 18.3167C9.98334 18.1445 9.97778 17.9167 9.80556 17.75L9.67223 17.6111H6.15556C3.06111 17.6111 2.62223 17.6222 2.51111 17.7Z"
        fill="currentColor"
      />
      <path
        d="M2.69445 20.5389C2.38333 20.6167 2.27222 21.05 2.5 21.2778C2.61111 21.3889 2.68333 21.3889 6.13889 21.3889H9.67222L9.80556 21.25C9.98333 21.0778 9.98333 20.8834 9.81111 20.6834L9.67778 20.5278L6.23889 20.5222C4.35 20.5167 2.75556 20.5222 2.69445 20.5389Z"
        fill="currentColor"
      />
      <path
        d="M2.53336 23.5611C2.32781 23.7223 2.32781 24.0556 2.53892 24.2167C2.68336 24.3334 2.70558 24.3334 6.21114 24.3223L9.73336 24.3056L9.83892 24.1723C10 23.9778 9.97225 23.7556 9.77225 23.5889L9.60003 23.4445H6.14447C2.72781 23.4445 2.67781 23.4445 2.53336 23.5611Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const AssignsSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="22"
      viewBox="0 0 25 22"
      fill="none"
    >
      <path
        d="M12 1H6C5.44772 1 5 1.44772 5 2V4C5 4.55228 5.44772 5 6 5H12C12.5523 5 13 4.55228 13 4V2C13 1.44772 12.5523 1 12 1Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 3H3C2.46957 3 1.96086 3.21071 1.58579 3.58579C1.21071 3.96086 1 4.46957 1 5V19C1 19.5304 1.21071 20.0391 1.58579 20.4142C1.96086 20.7893 2.46957 21 3 21H15C15.5304 21 16.0391 20.7893 16.4142 20.4142C16.7893 20.0391 17 19.5304 17 19V18.5M13 3H15C15.3507 3.00036 15.6952 3.09294 15.9988 3.26846C16.3025 3.44398 16.5546 3.69626 16.73 4"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.453 6.10391C19.6193 5.88386 19.8272 5.6987 20.065 5.55901C20.3028 5.41932 20.5658 5.32784 20.839 5.28979C21.1121 5.25173 21.3901 5.26785 21.657 5.33723C21.9239 5.4066 22.1746 5.52787 22.3946 5.69411C22.6147 5.86035 22.7998 6.0683 22.9395 6.3061C23.0792 6.5439 23.1707 6.80688 23.2087 7.08003C23.2468 7.35318 23.2307 7.63115 23.1613 7.89808C23.0919 8.165 22.9707 8.41564 22.8044 8.6357L19.0168 13.6261L15.2425 15.1615L15.678 11.1127L19.453 6.10391Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.1275 13.44C10.4479 13.0489 9.61528 12.8369 8.75868 12.8369C7.90207 12.8369 7.06941 13.0489 6.38982 13.44C5.71024 13.8311 5.2217 14.3795 5 15"
        stroke="currentColor"
        strokeLinecap="round"
      />
      <circle
        cx="8.75868"
        cy="8.94563"
        r="1.94563"
        stroke="currentColor"
        strokeLinecap="round"
      />
      <path
        d="M13.5743 13.0255L12.1711 14.5928L10.768 16.1602L9.51769 15.0751L9.13802 15.4929L10.8179 16.9472L14.001 13.3949"
        fill="currentColor"
      />
    </svg>
  );
};

export const PromotionsSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="81"
      height="82"
      viewBox="0 0 81 82"
      fill="none"
    >
      <path
        d="M60.2782 21.6243C60.5429 21.3286 60.867 21.0921 61.2294 20.9302C61.5917 20.7683 61.9841 20.6846 62.381 20.6846C62.7778 20.6846 63.1702 20.7683 63.5326 20.9302C63.8949 21.0921 64.219 21.3286 64.4837 21.6243L65.4716 22.7279C65.7539 23.0433 66.1036 23.2911 66.4947 23.4531C66.8858 23.6151 67.3083 23.687 67.731 23.6635L69.2128 23.5817C69.6091 23.5598 70.0056 23.6218 70.3764 23.7636C70.7471 23.9054 71.0838 24.1238 71.3644 24.4046C71.6451 24.6853 71.8633 25.0221 72.0049 25.3929C72.1465 25.7637 72.2083 26.1603 72.1863 26.5566L72.1044 28.037C72.0812 28.4594 72.1532 28.8817 72.3152 29.2725C72.4771 29.6634 72.7249 30.0128 73.0401 30.295L74.1437 31.2828C74.4396 31.5476 74.6763 31.8718 74.8384 32.2342C75.0004 32.5967 75.0842 32.9893 75.0842 33.3863C75.0842 33.7833 75.0004 34.1759 74.8384 34.5384C74.6763 34.9008 74.4396 35.225 74.1437 35.4898L73.0401 36.4776C72.7247 36.76 72.4768 37.1096 72.3149 37.5007C72.1529 37.8919 72.081 38.3144 72.1044 38.737L72.1863 40.2189C72.2082 40.6152 72.1462 41.0117 72.0044 41.3824C71.8626 41.7532 71.6442 42.0899 71.3634 42.3705C71.0827 42.6511 70.7459 42.8693 70.3751 43.011C70.0042 43.1526 69.6077 43.2144 69.2114 43.1924L67.731 43.1105C67.3086 43.0873 66.8863 43.1593 66.4955 43.3212C66.1046 43.4832 65.7552 43.7309 65.473 44.0462L64.4851 45.1497C64.2204 45.4456 63.8962 45.6824 63.5337 45.8444C63.1713 46.0065 62.7787 46.0902 62.3817 46.0902C61.9846 46.0902 61.5921 46.0065 61.2296 45.8444C60.8671 45.6824 60.5429 45.4456 60.2782 45.1497L59.2903 44.0462C59.008 43.7307 58.6583 43.4829 58.2672 43.3209C57.8761 43.159 57.4536 43.087 57.0309 43.1105L55.5491 43.1924C55.1528 43.2142 54.7563 43.1522 54.3855 43.0104C54.0148 42.8686 53.6781 42.6502 53.3975 42.3695C53.1169 42.0887 52.8986 41.7519 52.757 41.3811C52.6154 41.0103 52.5536 40.6138 52.5756 40.2174L52.6575 38.737C52.6807 38.3146 52.6087 37.8924 52.4467 37.5015C52.2848 37.1107 52.037 36.7612 51.7218 36.4791L50.6182 35.4912C50.3223 35.2264 50.0856 34.9023 49.9236 34.5398C49.7615 34.1773 49.6777 33.7848 49.6777 33.3877C49.6777 32.9907 49.7615 32.5981 49.9236 32.2356C50.0856 31.8732 50.3223 31.549 50.6182 31.2843L51.7218 30.2964C52.0372 30.014 52.2851 29.6644 52.4471 29.2733C52.609 28.8822 52.6809 28.4596 52.6575 28.037L52.5756 26.5552C52.554 26.1589 52.6161 25.7626 52.758 25.392C52.8999 25.0214 53.1183 24.6849 53.3991 24.4045C53.6798 24.124 54.0165 23.9059 54.3872 23.7644C54.7579 23.6228 55.1543 23.5611 55.5505 23.5831L57.0309 23.6649C57.4534 23.6882 57.8756 23.6162 58.2665 23.4542C58.6573 23.2922 59.0067 23.0445 59.2889 22.7293L60.2768 21.6257L60.2782 21.6243Z"
        stroke="currentColor"
        strokeWidth="2.5"
      />
      <path
        d="M58.8535 29.8591H58.8676V29.8732H58.8535V29.8591ZM65.9097 36.9154H65.9239V36.9295H65.9097V36.9154Z"
        stroke="currentColor"
        strokeWidth="5.25"
        strokeLinejoin="round"
      />
      <path
        d="M66.6159 29.1536L58.1484 37.621"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38.6465 5.3374L41.1291 9.41406M42.2713 11.0197C42.9285 12.0988 43.664 14.1164 42.3171 17.9775C41.2396 21.0664 39.806 22.9859 39.2239 23.5595"
        stroke="currentColor"
        strokeWidth="2.3"
      />
      <path
        d="M70.2207 59.9807L67.6718 55.9451M66.741 54.2085C66.0663 53.1402 64.5857 51.5847 60.5282 51.0756C57.2822 50.6684 54.9256 51.0997 54.1531 51.3662"
        stroke="currentColor"
        strokeWidth="2.3"
      />
      <path
        d="M14.0506 61.5734C11.8256 62.9942 9.52773 62.1088 8.65689 61.4886C7.60691 60.4843 5.27114 57.7645 4.32787 54.9201C3.14879 51.3645 5.4765 50.1935 9.00053 47.8831C10.4121 46.9576 12.1281 45.9259 14.0915 44.5901M14.0506 61.5734C15.1768 60.8543 17.2742 59.5168 19.7017 58.0768M14.0506 61.5734C16.9657 64.2909 22.9993 69.898 23.8128 70.586C24.6263 71.274 25.2311 71.4755 25.4318 71.4902C25.6551 71.2721 26.4327 70.6506 27.7568 69.91C29.081 69.1693 28.6211 68.3152 28.2257 67.9808L19.7017 58.0768M14.0915 44.5901C17.03 42.5911 20.5227 39.9113 24.3787 35.888C29.5246 30.5188 29.6591 22.4266 29.0831 19.0517L37.6816 33.2739M14.0915 44.5901L21.724 56.9002M21.724 56.9002C24.7946 55.1509 28.0919 53.4542 30.5086 52.7012C35.4823 51.1517 40.2738 51.1924 44.8804 52.414C48.5657 53.3913 50.8952 55.408 51.5992 56.2942L42.6217 41.4451M21.724 56.9002C21.0343 57.2931 20.356 57.6887 19.7017 58.0768M11.8926 51.9571L8.15222 54.3171M14.5186 55.8642L10.7548 58.3207M27.2355 45.5721L25.2206 46.7169M30.9993 43.1156L29.0078 44.164M23.1327 47.7419L21.2141 48.9102M37.6816 33.2739C38.5181 33.1947 40.1498 32.3654 41.9852 33.22C43.8207 34.0747 44.723 35.8263 44.7338 37.4635C44.7424 38.7732 43.3294 40.6636 42.6217 41.4451M37.6816 33.2739L42.6217 41.4451"
        stroke="currentColor"
        strokeWidth="3"
      />
    </svg>
  );
};
export const PromotionsOptINSvg = () => {
  return (
    <svg
      width="22"
      height="27"
      viewBox="0 0 22 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 24.3884H6.25993C7.27079 24.3884 8.29253 24.4937 9.27633 24.6964C11.0166 25.0549 12.8488 25.0983 14.6069 24.8138C15.4738 24.6734 16.326 24.4589 17.0975 24.0865C17.7939 23.7504 18.6469 23.2766 19.2199 22.7459C19.7921 22.216 20.388 21.3487 20.8109 20.6707C21.1736 20.0894 20.9982 19.3762 20.4245 18.943C19.7873 18.4619 18.8417 18.462 18.2046 18.9433L16.3974 20.3084C15.697 20.8375 14.932 21.3245 14.0206 21.4699C13.911 21.4874 13.7962 21.5033 13.6764 21.5172M13.6764 21.5172C13.6403 21.5214 13.6038 21.5254 13.5668 21.5292M13.6764 21.5172C13.8222 21.486 13.9669 21.396 14.1028 21.2775C14.746 20.7161 14.7866 19.77 14.2285 19.1431C14.0991 18.9977 13.9475 18.8764 13.7791 18.7759C10.9817 17.1074 6.62942 18.3782 4 20.2429M13.6764 21.5172C13.6399 21.525 13.6033 21.5292 13.5668 21.5292M13.5668 21.5292C13.0434 21.5829 12.4312 21.5968 11.7518 21.5326"
        stroke="currentColor"
        strokeWidth="1.5"
        stroke-linecap="round"
      />
      <rect
        x="1"
        y="18"
        width="3"
        height="8"
        rx="1.5"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.4452 0.239124C11.1123 -0.079708 11.8877 -0.079708 12.5548 0.239124C12.8446 0.377636 13.1101 0.604134 13.4778 0.917755C13.4969 0.934033 13.5163 0.950546 13.5359 0.967294C13.7145 1.11946 13.7707 1.16625 13.8276 1.20439C13.9723 1.30139 14.1349 1.36871 14.3058 1.40246C14.373 1.41573 14.4458 1.42241 14.6797 1.44107C14.7055 1.44312 14.7308 1.44514 14.7558 1.44712C15.2376 1.48535 15.5855 1.51296 15.8884 1.61993C16.5855 1.86616 17.1338 2.41451 17.3801 3.11164C17.487 3.4145 17.5147 3.76242 17.5529 4.24418C17.5549 4.26918 17.5569 4.29455 17.5589 4.32029C17.5776 4.55415 17.5843 4.627 17.5975 4.6942C17.6313 4.86513 17.6986 5.02766 17.7956 5.17239C17.8337 5.22929 17.8805 5.28552 18.0327 5.46409C18.0495 5.48374 18.066 5.50311 18.0823 5.5222C18.3959 5.88987 18.6224 6.15541 18.7609 6.4452C19.0797 7.11226 19.0797 7.88774 18.7609 8.5548C18.6224 8.84459 18.3959 9.11013 18.0823 9.4778C18.066 9.49689 18.0495 9.51626 18.0327 9.53591C17.8805 9.71448 17.8337 9.77071 17.7956 9.82761C17.6986 9.97234 17.6313 10.1349 17.5975 10.3058C17.5843 10.373 17.5776 10.4459 17.5589 10.6797C17.5569 10.7055 17.5549 10.7308 17.5529 10.7558C17.5147 11.2376 17.487 11.5855 17.3801 11.8884C17.1338 12.5855 16.5855 13.1338 15.8884 13.3801C15.5855 13.487 15.2376 13.5147 14.7558 13.5529C14.7308 13.5549 14.7055 13.5569 14.6797 13.5589C14.4458 13.5776 14.373 13.5843 14.3058 13.5975C14.1349 13.6313 13.9723 13.6986 13.8276 13.7956C13.7707 13.8337 13.7145 13.8805 13.5359 14.0327C13.5163 14.0495 13.4969 14.066 13.4778 14.0823C13.1101 14.3959 12.8446 14.6224 12.5548 14.7609C11.8877 15.0797 11.1123 15.0797 10.4452 14.7609C10.1554 14.6224 9.88986 14.3959 9.52218 14.0822C9.50309 14.066 9.48374 14.0495 9.46409 14.0327C9.28552 13.8805 9.22929 13.8337 9.17239 13.7956C9.02766 13.6986 8.86513 13.6313 8.6942 13.5975C8.627 13.5843 8.55415 13.5776 8.32029 13.5589C8.29455 13.5569 8.26918 13.5549 8.24418 13.5529C7.76242 13.5147 7.4145 13.487 7.11164 13.3801C6.41451 13.1338 5.86616 12.5855 5.61993 11.8884C5.51296 11.5855 5.48535 11.2376 5.44712 10.7558C5.44514 10.7308 5.44312 10.7055 5.44107 10.6797C5.42241 10.4458 5.41573 10.373 5.40246 10.3058C5.36871 10.1349 5.30139 9.97234 5.20439 9.82761C5.16625 9.77071 5.11946 9.71448 4.96729 9.53591C4.95055 9.51626 4.93403 9.4969 4.91776 9.47782C4.60413 9.11014 4.37764 8.8446 4.23912 8.5548C3.92029 7.88774 3.92029 7.11226 4.23912 6.4452C4.37764 6.15541 4.60413 5.88987 4.91775 5.52219C4.93403 5.5031 4.95055 5.48374 4.96729 5.46409C5.11946 5.28552 5.16625 5.22929 5.20439 5.17239C5.30139 5.02766 5.36871 4.86513 5.40246 4.6942C5.41573 4.627 5.42241 4.55415 5.44107 4.32029C5.44312 4.29455 5.44514 4.26918 5.44712 4.24418C5.48535 3.76242 5.51296 3.4145 5.61993 3.11164C5.86616 2.41451 6.41451 1.86616 7.11164 1.61993C7.4145 1.51296 7.76242 1.48535 8.24418 1.44712C8.26918 1.44514 8.29455 1.44312 8.32029 1.44107C8.55415 1.42241 8.627 1.41573 8.6942 1.40246C8.86513 1.36871 9.02766 1.30139 9.17239 1.20439C9.22929 1.16625 9.28552 1.11946 9.46409 0.967294C9.48374 0.950546 9.5031 0.934032 9.52218 0.917754C9.88986 0.604133 10.1554 0.377636 10.4452 0.239124ZM12.068 1.25767C11.7088 1.08599 11.2912 1.08599 10.932 1.25767C10.7932 1.32405 10.6468 1.44264 10.1963 1.82653C10.1889 1.83283 10.1816 1.83905 10.1744 1.8452C10.0266 1.97123 9.91867 2.06323 9.80092 2.14215C9.53214 2.32229 9.23029 2.44732 8.91286 2.51C8.77379 2.53745 8.63243 2.5487 8.43878 2.56412C8.42934 2.56487 8.41978 2.56563 8.41009 2.5664C7.82011 2.61349 7.63275 2.63313 7.48762 2.68439C7.11224 2.81698 6.81698 3.11224 6.68439 3.48762C6.63313 3.63275 6.61349 3.82011 6.5664 4.41009C6.56563 4.41978 6.56487 4.42934 6.56412 4.43878C6.5487 4.63243 6.53745 4.77379 6.51 4.91286C6.44732 5.23029 6.32229 5.53214 6.14215 5.80092C6.06323 5.91867 5.97123 6.02658 5.84519 6.17442C5.83905 6.18162 5.83283 6.18892 5.82653 6.19632C5.44264 6.64679 5.32405 6.79316 5.25767 6.93203C5.08599 7.29122 5.08599 7.70878 5.25767 8.06797C5.32405 8.20684 5.44264 8.35321 5.82653 8.80368C5.83283 8.81108 5.83905 8.81838 5.8452 8.82558C5.97123 8.97342 6.06323 9.08133 6.14215 9.19908C6.32229 9.46786 6.44732 9.76971 6.51 10.0871C6.53745 10.2262 6.5487 10.3676 6.56412 10.5612C6.56487 10.5707 6.56563 10.5802 6.5664 10.5899C6.61349 11.1799 6.63313 11.3673 6.68439 11.5124C6.81698 11.8878 7.11224 12.183 7.48762 12.3156C7.63275 12.3669 7.82011 12.3865 8.41009 12.4336L8.43877 12.4359C8.63243 12.4513 8.77379 12.4626 8.91286 12.49C9.23029 12.5527 9.53214 12.6777 9.80092 12.8579C9.91867 12.9368 10.0266 13.0288 10.1744 13.1548L10.1963 13.1735C10.6468 13.5574 10.7932 13.676 10.932 13.7423C11.2912 13.914 11.7088 13.914 12.068 13.7423C12.2068 13.676 12.3532 13.5574 12.8037 13.1735L12.8256 13.1548C12.9734 13.0288 13.0813 12.9368 13.1991 12.8579C13.4679 12.6777 13.7697 12.5527 14.0871 12.49C14.2262 12.4626 14.3676 12.4513 14.5612 12.4359L14.5899 12.4336C15.1799 12.3865 15.3673 12.3669 15.5124 12.3156C15.8878 12.183 16.183 11.8878 16.3156 11.5124C16.3669 11.3673 16.3865 11.1799 16.4336 10.5899L16.4359 10.5612C16.4513 10.3676 16.4626 10.2262 16.49 10.0871C16.5527 9.76971 16.6777 9.46786 16.8579 9.19908C16.9368 9.08133 17.0288 8.97342 17.1548 8.82559L17.1735 8.80368C17.5574 8.35321 17.676 8.20684 17.7423 8.06797C17.914 7.70878 17.914 7.29122 17.7423 6.93203C17.676 6.79316 17.5574 6.64679 17.1735 6.19632L17.1548 6.1744C17.0288 6.02657 16.9368 5.91866 16.8579 5.80092C16.6777 5.53214 16.5527 5.23029 16.49 4.91286C16.4626 4.77379 16.4513 4.63243 16.4359 4.43877L16.4336 4.41009C16.3865 3.82011 16.3669 3.63275 16.3156 3.48762C16.183 3.11224 15.8878 2.81698 15.5124 2.68439C15.3673 2.63313 15.1799 2.61349 14.5899 2.5664C14.5802 2.56563 14.5707 2.56487 14.5612 2.56412C14.3676 2.5487 14.2262 2.53745 14.0871 2.51C13.7697 2.44732 13.4679 2.32229 13.1991 2.14215C13.0813 2.06323 12.9734 1.97123 12.8256 1.84519C12.8184 1.83905 12.8111 1.83283 12.8037 1.82653C12.3532 1.44264 12.2068 1.32405 12.068 1.25767Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.157 4.84304C14.3774 5.06348 14.3774 5.42087 14.157 5.64131L9.64131 10.157C9.42087 10.3774 9.06348 10.3774 8.84304 10.157C8.62261 9.93652 8.62261 9.57913 8.84304 9.35869L13.3587 4.84304C13.5791 4.62261 13.9365 4.62261 14.157 4.84304Z"
        fill="currentColor"
      />
      <path
        d="M14.1341 9.38152C14.1341 9.79717 13.7972 10.1341 13.3815 10.1341C12.9659 10.1341 12.6289 9.79717 12.6289 9.38152C12.6289 8.96587 12.9659 8.62891 13.3815 8.62891C13.7972 8.62891 14.1341 8.96587 14.1341 9.38152Z"
        fill="currentColor"
      />
      <path
        d="M10.3711 5.61848C10.3711 6.03413 10.0341 6.37109 9.61848 6.37109C9.20283 6.37109 8.86587 6.03413 8.86587 5.61848C8.86587 5.20283 9.20283 4.86587 9.61848 4.86587C10.0341 4.86587 10.3711 5.20283 10.3711 5.61848Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const MembersSvg = () => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 0.25C5.37665 0.25 3.25 2.37665 3.25 5C3.25 7.62335 5.37665 9.75 8 9.75C10.6234 9.75 12.75 7.62335 12.75 5C12.75 2.37665 10.6234 0.25 8 0.25ZM4.75 5C4.75 3.20507 6.20507 1.75 8 1.75C9.79493 1.75 11.25 3.20507 11.25 5C11.25 6.79493 9.79493 8.25 8 8.25C6.20507 8.25 4.75 6.79493 4.75 5Z"
        fill="currentColor"
      />
      <path
        d="M14 1.25C13.5858 1.25 13.25 1.58579 13.25 2C13.25 2.41421 13.5858 2.75 14 2.75C15.2426 2.75 16.25 3.75736 16.25 5C16.25 6.24264 15.2426 7.25 14 7.25C13.5858 7.25 13.25 7.58579 13.25 8C13.25 8.41421 13.5858 8.75 14 8.75C16.0711 8.75 17.75 7.07107 17.75 5C17.75 2.92893 16.0711 1.25 14 1.25Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.67815 12.5204C4.07752 11.7208 5.96067 11.25 8 11.25C10.0393 11.25 11.9225 11.7208 13.3219 12.5204C14.7 13.3079 15.75 14.5101 15.75 16C15.75 17.4899 14.7 18.6921 13.3219 19.4796C11.9225 20.2792 10.0393 20.75 8 20.75C5.96067 20.75 4.07752 20.2792 2.67815 19.4796C1.3 18.6921 0.25 17.4899 0.25 16C0.25 14.5101 1.3 13.3079 2.67815 12.5204ZM3.42236 13.8228C2.26701 14.483 1.75 15.2807 1.75 16C1.75 16.7193 2.26701 17.517 3.42236 18.1772C4.55649 18.8253 6.17334 19.25 8 19.25C9.82666 19.25 11.4435 18.8253 12.5776 18.1772C13.733 17.517 14.25 16.7193 14.25 16C14.25 15.2807 13.733 14.483 12.5776 13.8228C11.4435 13.1747 9.82666 12.75 8 12.75C6.17334 12.75 4.55649 13.1747 3.42236 13.8228Z"
        fill="currentColor"
      />
      <path
        d="M17.1607 12.2674C16.7561 12.1787 16.3561 12.4347 16.2674 12.8393C16.1787 13.2439 16.4347 13.6439 16.8393 13.7326C17.6317 13.9064 18.2649 14.2048 18.6829 14.5468C19.1014 14.8892 19.25 15.2237 19.25 15.5C19.25 15.7507 19.1294 16.045 18.7969 16.3539C18.462 16.665 17.9475 16.9524 17.2838 17.1523C16.8871 17.2717 16.6624 17.69 16.7818 18.0867C16.9013 18.4833 17.3196 18.708 17.7162 18.5886C18.5388 18.3409 19.2743 17.9578 19.8178 17.4529C20.3637 16.9457 20.75 16.2786 20.75 15.5C20.75 14.6352 20.2758 13.912 19.6328 13.3859C18.9893 12.8593 18.1225 12.4783 17.1607 12.2674Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const PromotionsHistorySvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="17"
      viewBox="0 0 18 17"
      fill="none"
    >
      <path
        d="M14.55 2.45C12.9776 0.884279 10.849 0.00522494 8.63 0.00522494C6.41101 0.00522494 4.28239 0.884279 2.71 2.45L1.5 3.66V0.75C1.5 0.551088 1.42098 0.360322 1.28033 0.21967C1.13968 0.0790175 0.948912 0 0.75 0C0.551088 0 0.360322 0.0790175 0.21967 0.21967C0.0790175 0.360322 2.85177e-09 0.551088 2.85177e-09 0.75V5.49C-1.72974e-05 5.68984 0.0786798 5.88165 0.219052 6.0239C0.359424 6.16614 0.550173 6.24737 0.75 6.25H5.5C5.69891 6.25 5.88968 6.17098 6.03033 6.03033C6.17098 5.88968 6.25 5.69891 6.25 5.5C6.25 5.30109 6.17098 5.11032 6.03033 4.96967C5.88968 4.82902 5.69891 4.75 5.5 4.75H2.5L3.77 3.51C5.05985 2.22274 6.80771 1.49978 8.63 1.49978C10.4523 1.49978 12.2001 2.22274 13.49 3.51C19.68 10.2 10.49 19.42 3.77 13.23C3.62937 13.0896 3.43875 13.0107 3.24 13.0107C3.04125 13.0107 2.85063 13.0896 2.71 13.23C2.63924 13.2989 2.58301 13.3814 2.54461 13.4724C2.50621 13.5634 2.48643 13.6612 2.48643 13.76C2.48643 13.8588 2.50621 13.9566 2.54461 14.0476C2.58301 14.1386 2.63924 14.2211 2.71 14.29C4.28008 15.8601 6.40957 16.7421 8.63 16.7421C10.8504 16.7421 12.9799 15.8601 14.55 14.29C16.1201 12.7199 17.0021 10.5904 17.0021 8.37C17.0021 6.14957 16.1201 4.02008 14.55 2.45Z"
        fill="currentColor"
      />
      <path
        d="M8.5 4.12C8.30189 4.12259 8.11263 4.20243 7.97253 4.34253C7.83244 4.48262 7.75259 4.67189 7.75 4.87V8.37C7.75018 8.56884 7.82931 8.75948 7.97 8.89999L10.5 11.37C10.5692 11.4401 10.6518 11.4957 10.7428 11.5335C10.8338 11.5712 10.9315 11.5905 11.03 11.59C11.1617 11.5708 11.2859 11.5169 11.3899 11.4339C11.4939 11.3509 11.5739 11.2416 11.6218 11.1174C11.6696 10.9933 11.6836 10.8586 11.6622 10.7272C11.6408 10.5959 11.5848 10.4726 11.5 10.37L9.22 8.09V4.87C9.21773 4.67691 9.14204 4.49192 9.00831 4.35262C8.87458 4.21332 8.69284 4.13015 8.5 4.12Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const AgreementSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="27"
      viewBox="0 0 22 27"
      fill="none"
    >
      <path
        d="M10 4V8L12.5 6L14.5 8V4M2.5 10.5H14.5M2.5 13.5H11.5M2.5 16.5H8.5M2.5 19.5H10.5M2.5 22.5C5.3 22.5 6.66667 22.5 7 22.5"
        stroke="currentColor"
        strokeWidth="1.3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <rect
        x="0.65"
        y="3.65"
        width="16.7"
        height="22.7"
        rx="1.35"
        stroke="currentColor"
        strokeWidth="1.3"
      />
      <path
        d="M17 25H19C20.1046 25 21 24.1046 21 23V3C21 1.89543 20.1095 1 19.0049 1C15.6979 1 8.93875 1 3.82673 1C3.29629 1 2.76644 1.21665 2.6123 1.72419C2.54597 1.94261 2.5 2.20292 2.5 2.5C2.5 3.3 2.5 3.83333 2.5 4"
        stroke="currentColor"
        strokeWidth="1.3"
      />
    </svg>
  );
};
export const AchSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
    >
      <path
        d="M12.5751 7.09012C12.9457 7.09012 13.3011 6.94075 13.5631 6.67487C13.8252 6.40899 13.9724 6.04839 13.9724 5.67238C13.9724 5.29637 13.8252 4.93576 13.5631 4.66989C13.3011 4.40401 12.9457 4.25464 12.5751 4.25464C12.2046 4.25464 11.8492 4.40401 11.5871 4.66989C11.3251 4.93576 11.1779 5.29637 11.1779 5.67238C11.1779 6.04839 11.3251 6.40899 11.5871 6.67487C11.8492 6.94075 12.2046 7.09012 12.5751 7.09012ZM13.5155 0.31687C13.2439 0.111147 12.9141 0 12.5751 0C12.2362 0 11.9064 0.111147 11.6348 0.31687L0.49602 8.75384C-0.447116 9.46767 0.0509993 10.9882 1.22678 10.9882H2.09586V19.4982C1.4687 19.8 0.938828 20.2763 0.567827 20.8715C0.196825 21.4668 -7.71254e-05 22.1567 2.26618e-08 22.861V25.3421C2.26618e-08 25.8312 0.391227 26.2282 0.873274 26.2282H11.7871C11.515 25.6701 11.3311 25.0721 11.2422 24.456H1.74655V22.861C1.74655 22.344 1.94896 21.8482 2.30926 21.4826C2.66955 21.117 3.15822 20.9117 3.66775 20.9117H11.7871C12.1785 20.1088 12.747 19.4083 13.4484 18.8644V10.9875H16.4176V17.7331C16.5338 17.7256 16.6503 17.7218 16.7669 17.7217H18.1641V10.9875H21.3079V17.7217H23.0544V10.9875H23.9235C25.1 10.9875 25.5974 9.46696 24.655 8.75313L13.5155 0.31687ZM11.7019 19.1395H8.73274V10.9875H11.7019V19.1395ZM6.98619 19.1395H3.84241V10.9875H6.98619V19.1395ZM2.80426 9.21531L12.5751 1.81542L22.3453 9.21602L2.80426 9.21531ZM16.9415 19.1395C16.3635 19.1321 15.7898 19.2412 15.2537 19.4605C14.7176 19.6798 14.2297 20.0049 13.8184 20.417C13.4071 20.8291 13.0805 21.32 12.8576 21.8612C12.6347 22.4023 12.5199 22.983 12.5199 23.5696C12.5199 24.1561 12.6347 24.7368 12.8576 25.278C13.0805 25.8191 13.4071 26.31 13.8184 26.7221C14.2297 27.1342 14.7176 27.4593 15.2537 27.6787C15.7898 27.898 16.3635 28.0071 16.9415 27.9996H17.9894C18.2211 27.9996 18.4432 27.9063 18.6069 27.7401C18.7707 27.5739 18.8627 27.3486 18.8627 27.1136C18.8627 26.8786 18.7707 26.6532 18.6069 26.487C18.4432 26.3208 18.2211 26.2275 17.9894 26.2275H16.9415C16.2467 26.2275 15.5803 25.9474 15.089 25.4489C14.5977 24.9504 14.3217 24.2742 14.3217 23.5692C14.3217 22.8642 14.5977 22.1881 15.089 21.6895C15.5803 21.191 16.2467 20.9109 16.9415 20.9109H17.9894C18.2211 20.9109 18.4432 20.8176 18.6069 20.6514C18.7707 20.4852 18.8627 20.2599 18.8627 20.0249C18.8627 19.7899 18.7707 19.5645 18.6069 19.3983C18.4432 19.2321 18.2211 19.1388 17.9894 19.1388L16.9415 19.1395ZM23.5784 19.1395C24.1564 19.1321 24.7301 19.2412 25.2662 19.4605C25.8023 19.6798 26.2902 20.0049 26.7015 20.417C27.1128 20.8291 27.4394 21.32 27.6623 21.8612C27.8852 22.4023 28 22.983 28 23.5696C28 24.1561 27.8852 24.7368 27.6623 25.278C27.4394 25.8191 27.1128 26.31 26.7015 26.7221C26.2902 27.1342 25.8023 27.4593 25.2662 27.6787C24.7301 27.898 24.1564 28.0071 23.5784 27.9996H22.5305C22.2989 27.9996 22.0767 27.9063 21.913 27.7401C21.7492 27.5739 21.6572 27.3486 21.6572 27.1136C21.6572 26.8786 21.7492 26.6532 21.913 26.487C22.0767 26.3208 22.2989 26.2275 22.5305 26.2275H23.5784C24.2732 26.2275 24.9396 25.9474 25.4309 25.4489C25.9222 24.9504 26.1982 24.2742 26.1982 23.5692C26.1982 22.8642 25.9222 22.1881 25.4309 21.6895C24.9396 21.191 24.2732 20.9109 23.5784 20.9109H22.5305C22.2989 20.9109 22.0767 20.8176 21.913 20.6514C21.7492 20.4852 21.6572 20.2599 21.6572 20.0249C21.6572 19.7899 21.7492 19.5645 21.913 19.3983C22.0767 19.2321 22.2989 19.1388 22.5305 19.1388L23.5784 19.1395ZM16.0682 23.5699C16.0682 23.0801 16.4595 22.6838 16.9415 22.6838H23.5784C23.81 22.6838 24.0321 22.7772 24.1959 22.9434C24.3597 23.1095 24.4517 23.3349 24.4517 23.5699C24.4517 23.8049 24.3597 24.0303 24.1959 24.1965C24.0321 24.3627 23.81 24.456 23.5784 24.456H16.9415C16.4595 24.456 16.0682 24.059 16.0682 23.5699Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const RightSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="27"
      height="18"
      viewBox="0 0 27 18"
      fill="none"
    >
      <path
        d="M2.02334 9.77177L10.3529 16.1629C10.4125 16.2086 10.4968 16.2032 10.55 16.1501L25.5234 1.24268"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
    </svg>
  );
};
export const DownloadsSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M8 12L3 7L4.4 5.55L7 8.15V0H9V8.15L11.6 5.55L13 7L8 12ZM2 16C1.45 16 0.979002 15.804 0.587002 15.412C0.195002 15.02 -0.000664969 14.5493 1.69779e-06 14V11H2V14H14V11H16V14C16 14.55 15.804 15.021 15.412 15.413C15.02 15.805 14.5493 16.0007 14 16H2Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const DownArrowSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="36"
      height="21"
      viewBox="0 0 36 21"
      fill="none"
    >
      <path
        d="M2 2L18 18L34 2"
        stroke="currentColor"
        strokeWidth="4"
        stroke-linecap="round"
      />
    </svg>
  );
};

export const HomeSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
    >
      <path
        d="M2 18L5.55556 14.4444M5.55556 14.4444L18 2L30.4444 14.4444M5.55556 14.4444V32.2222C5.55556 32.6937 5.74286 33.1459 6.07625 33.4793C6.40965 33.8127 6.86184 34 7.33333 34H12.6667M30.4444 14.4444L34 18M30.4444 14.4444V32.2222C30.4444 32.6937 30.2571 33.1459 29.9237 33.4793C29.5903 33.8127 29.1382 34 28.6667 34H23.3333M12.6667 34C13.1382 34 13.5903 33.8127 13.9237 33.4793C14.2571 33.1459 14.4444 32.6937 14.4444 32.2222V25.1111C14.4444 24.6396 14.6317 24.1874 14.9651 23.854C15.2985 23.5206 15.7507 23.3333 16.2222 23.3333H19.7778C20.2493 23.3333 20.7015 23.5206 21.0349 23.854C21.3683 24.1874 21.5556 24.6396 21.5556 25.1111V32.2222C21.5556 32.6937 21.7429 33.1459 22.0763 33.4793C22.4097 33.8127 22.8618 34 23.3333 34M12.6667 34H23.3333"
        stroke="currentColor"
        strokeWidth="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const ChartSvg = () => {
  return (
    <svg
      width="800px"
      height="800px"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 10C21 6.13401 17.866 3 14 3V10H21Z"
        stroke="currentColor"
        strokeWidth="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11 21C15.4183 21 19 17.4183 19 13H11V5C6.58172 5 3 8.58172 3 13C3 17.4183 6.58172 21 11 21Z"
        stroke="currentColor"
        strokeWidth="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const ListSvg = () => {
  return (
    <svg
      width="800px"
      height="800px"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 6L21 6.00078M8 12L21 12.0008M8 18L21 18.0007M3 6.5H4V5.5H3V6.5ZM3 12.5H4V11.5H3V12.5ZM3 18.5H4V17.5H3V18.5Z"
        stroke="currentColor"
        strokeWidth="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const ShortUpSvg = () => {
  return (
    <svg
      width="50"
      height="40"
      viewBox="0 0 50 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.6411 0.928572C12.1042 0.339286 11.3559 0 10.5637 0C9.77144 0 9.0232 0.339286 8.48624 0.928572L0.739817 9.5C-0.30771 10.6607 -0.237288 12.4732 0.915872 13.5357C2.06903 14.5982 3.84719 14.5268 4.89471 13.3571L7.74681 10.2054V37.1429C7.74681 38.7232 9.0056 40 10.5637 40C12.1218 40 13.3806 38.7232 13.3806 37.1429V10.2054L16.2327 13.3661C17.2802 14.5268 19.0671 14.6071 20.2115 13.5446C21.3559 12.4821 21.4351 10.6696 20.3876 9.50893L12.6411 0.9375V0.928572ZM27.465 0C25.9069 0 24.6481 1.27679 24.6481 2.85714C24.6481 4.4375 25.9069 5.71429 27.465 5.71429H30.2818C31.8399 5.71429 33.0987 4.4375 33.0987 2.85714C33.0987 1.27679 31.8399 0 30.2818 0H27.465ZM27.465 11.4286C25.9069 11.4286 24.6481 12.7054 24.6481 14.2857C24.6481 15.8661 25.9069 17.1429 27.465 17.1429H35.9156C37.4737 17.1429 38.7325 15.8661 38.7325 14.2857C38.7325 12.7054 37.4737 11.4286 35.9156 11.4286H27.465ZM27.465 22.8571C25.9069 22.8571 24.6481 24.1339 24.6481 25.7143C24.6481 27.2946 25.9069 28.5714 27.465 28.5714H41.5494C43.1074 28.5714 44.3662 27.2946 44.3662 25.7143C44.3662 24.1339 43.1074 22.8571 41.5494 22.8571H27.465ZM27.465 34.2857C25.9069 34.2857 24.6481 35.5625 24.6481 37.1429C24.6481 38.7232 25.9069 40 27.465 40H47.1831C48.7412 40 50 38.7232 50 37.1429C50 35.5625 48.7412 34.2857 47.1831 34.2857H27.465Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const ShortDownSvg = () => {
  return (
    <svg
      width="50"
      height="40"
      viewBox="0 0 50 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.6411 39.0714C12.1042 39.6607 11.3559 40 10.5637 40C9.77144 40 9.0232 39.6607 8.48624 39.0714L0.739817 30.5C-0.30771 29.3393 -0.237288 27.5268 0.915872 26.4643C2.06903 25.4018 3.84719 25.4732 4.89471 26.6429L7.74681 29.7946V2.85714C7.74681 1.27679 9.0056 0 10.5637 0C12.1218 0 13.3806 1.27679 13.3806 2.85714V29.7946L16.2327 26.6339C17.2802 25.4732 19.0671 25.3929 20.2115 26.4554C21.3559 27.5179 21.4351 29.3304 20.3876 30.4911L12.6411 39.0625V39.0714ZM27.465 40C25.9069 40 24.6481 38.7232 24.6481 37.1429C24.6481 35.5625 25.9069 34.2857 27.465 34.2857H30.2818C31.8399 34.2857 33.0987 35.5625 33.0987 37.1429C33.0987 38.7232 31.8399 40 30.2818 40H27.465ZM27.465 28.5714C25.9069 28.5714 24.6481 27.2946 24.6481 25.7143C24.6481 24.1339 25.9069 22.8571 27.465 22.8571H35.9156C37.4737 22.8571 38.7325 24.1339 38.7325 25.7143C38.7325 27.2946 37.4737 28.5714 35.9156 28.5714H27.465ZM27.465 17.1429C25.9069 17.1429 24.6481 15.8661 24.6481 14.2857C24.6481 12.7054 25.9069 11.4286 27.465 11.4286H41.5494C43.1074 11.4286 44.3662 12.7054 44.3662 14.2857C44.3662 15.8661 43.1074 17.1429 41.5494 17.1429H27.465ZM27.465 5.71429C25.9069 5.71429 24.6481 4.4375 24.6481 2.85714C24.6481 1.27679 25.9069 0 27.465 0H47.1831C48.7412 0 50 1.27679 50 2.85714C50 4.4375 48.7412 5.71429 47.1831 5.71429H27.465Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const RepresentativeSvg = () => {
  return (
    <svg
      width="109"
      height="96"
      viewBox="0 0 109 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M63.5035 1.23636C61.1312 1.99019 58.7588 4.163 57.8498 6.42449L57.3398 7.68827V23.5631V39.4157L58.1824 41.1008C59.4018 43.584 61.3085 45.136 63.9913 45.8455C64.8116 46.0672 66.9401 46.1559 71.9287 46.1559H78.7354V49.6146C78.7354 51.5436 78.8241 53.2508 78.9571 53.4946C79.2453 54.0046 80.3095 54.5811 81.019 54.5811C81.3073 54.5811 84.5221 52.7186 88.2913 50.3906L95.0758 46.2002L98.7119 46.1115C102.237 46.045 102.392 46.0228 103.789 45.3577C105.895 44.3378 107.181 43.1184 108.157 41.1008L109 39.4157V23.4301V7.46656L108.29 6.00324C107.403 4.22951 105.629 2.47796 103.856 1.63544L102.57 1.03681L83.5022 0.992471C68.1817 0.948128 64.2574 1.01464 63.5035 1.23636ZM101.461 5.60415C102.614 5.93672 104.1 7.42221 104.432 8.57513C104.787 9.83891 104.765 37.3759 104.432 38.418C104.055 39.5488 103.213 40.5686 102.237 41.0564C101.483 41.4555 100.929 41.4999 97.8251 41.4999C93.679 41.4999 94.4106 41.2116 87.604 45.4686L83.2805 48.1513L83.1697 45.5129C83.0366 42.5419 82.8593 42.1207 81.4181 41.7216C80.9525 41.5885 77.3386 41.4999 72.7934 41.4999C65.4325 41.4999 64.9225 41.4777 64.1022 41.0564C63.1266 40.5686 62.2841 39.5488 61.9072 38.418C61.5746 37.3981 61.5524 9.83891 61.9072 8.5973C62.2176 7.48873 63.5257 6.09192 64.6564 5.69283C65.3881 5.42678 68.5365 5.38243 83.0588 5.36026C95.231 5.36026 100.84 5.42678 101.461 5.60415Z"
        fill="currentColor"
      />
      <path
        d="M71.8848 12.3219C70.621 13.0314 70.3771 14.7829 71.397 15.8028L72.04 16.4458H83.1701H94.3002L94.9432 15.8028C95.9853 14.7608 95.6749 12.8762 94.3667 12.2776C93.4799 11.8785 72.6165 11.9228 71.8848 12.3219Z"
        fill="currentColor"
      />
      <path
        d="M71.8623 21.3901C70.6207 22.0109 70.3769 23.8511 71.3967 24.8932L72.0397 25.5361H83.1698H94.2999L94.9651 24.871C95.5859 24.2502 95.6302 24.0728 95.5194 23.1416C95.4307 22.3878 95.2533 21.9665 94.8099 21.6118L94.2334 21.1018H83.325C75.0107 21.1018 72.2836 21.1683 71.8623 21.3901Z"
        fill="currentColor"
      />
      <path
        d="M78.3363 30.7464C77.5603 31.4116 77.3386 32.2763 77.7377 33.2075C78.3363 34.6265 78.2698 34.6265 86.6728 34.6265H94.2998L94.9428 33.9835C95.4527 33.4735 95.5857 33.141 95.5857 32.4093C95.5857 31.6777 95.4527 31.3451 94.9428 30.8351L94.2998 30.1922H86.6506H79.0014L78.3363 30.7464Z"
        fill="currentColor"
      />
      <path
        d="M28.4063 11.9229C22.4643 13.0315 17.9856 18.1753 17.9856 23.8733V25.4697L16.3893 25.6027C13.4848 25.8244 11.6002 27.0217 10.4251 29.4162C9.82651 30.6357 9.71565 31.1013 9.73783 32.4094C9.73783 34.294 10.4251 35.9347 11.7333 37.2428L12.6423 38.1518L12.3319 39.4378C11.7333 41.8988 11.7776 42.0318 14.0834 45.0915C15.2364 46.6213 16.3449 47.9294 16.5445 48.0181C18.0965 48.6168 19.7594 47.5525 19.7594 46.0005C19.7594 45.2689 19.5155 44.7811 18.2073 43.0517C16.8327 41.2115 16.6553 40.8789 16.7884 40.2803C16.9879 39.2826 17.0101 39.2826 18.5399 39.2826H19.9589L20.4023 40.502C21.4222 43.2069 23.1959 45.9562 25.1914 47.9294C25.9674 48.6833 26.4108 49.3263 26.4108 49.6367C26.4108 50.1023 26.3 50.1466 25.2801 50.1466C23.9054 50.1466 15.6798 51.9425 13.4848 52.7185C6.8777 55.0909 2.26602 59.5473 1.04659 64.7798C0.758358 65.9992 0.691844 68.4381 0.691844 80.2555C0.691844 95.7978 0.625329 95.1105 2.13299 95.5982C3.10854 95.9308 3.90672 95.6869 4.57186 94.8887L5.12615 94.2236V80.6546C5.12615 69.1033 5.17049 66.8861 5.48089 65.7775C6.47861 61.8753 9.9152 58.727 14.9925 57.0419C17.2983 56.2881 24.7036 54.5809 25.7235 54.5809H26.4108V56.0442C26.4108 58.0175 26.7877 58.727 28.4506 59.8356C31.1112 61.5871 33.2618 62.3409 35.7229 62.3409C38.2948 62.3409 41.9087 60.8998 43.8155 59.1261L44.8132 58.217V56.3546V54.5144L46.0991 54.6474C46.7864 54.7139 48.2276 55.0465 49.314 55.3569C51.0877 55.8669 51.3094 55.889 52.0189 55.6008C53.5488 54.9578 53.8592 52.9402 52.5954 51.8538C51.7972 51.1887 47.7842 50.1466 46.0326 50.1466C44.3919 50.1466 44.4141 49.7697 46.21 47.9294C48.5602 45.5128 50.2009 42.7857 51.3316 39.4156C51.9746 37.4645 52.5732 34.2053 52.5732 32.5646C52.5732 31.8107 52.7062 31.3008 53.0166 30.9239C53.3936 30.4361 53.4601 30.0149 53.4601 28.1081C53.4601 26.8887 53.3049 25.2258 53.1497 24.4276C51.9746 18.8626 48.0059 14.4283 42.4852 12.5437C40.7336 11.9229 40.6228 11.9229 34.836 11.8785C31.599 11.8564 28.7167 11.8785 28.4063 11.9229ZM41.044 16.8671C45.301 18.1974 48.2498 21.8114 48.8927 26.4674L49.0036 27.3099H46.0548C42.3965 27.3099 41.1549 27.0882 39.0486 26.0461C36.1663 24.6493 33.9935 21.9888 33.1731 18.8626C32.9958 18.1974 32.8406 17.3327 32.8406 16.9115V16.1576L36.2328 16.2907C38.7604 16.3794 39.9576 16.5124 41.044 16.8671ZM28.1845 18.6187C28.1845 22.277 26.6769 24.9376 23.7724 26.4231C22.3534 27.1326 22.3534 27.1326 22.4643 24.5828C22.5973 21.9001 23.1738 20.3924 24.7258 18.7961C25.5461 17.9535 27.475 16.7119 28.0293 16.6676C28.118 16.6676 28.1845 17.5545 28.1845 18.6187ZM34.703 28.7289C37.8292 30.9682 40.2458 31.6999 44.9906 31.8994C46.7199 31.9659 48.1389 32.099 48.1389 32.1655C48.1389 32.8306 47.4073 36.7772 47.119 37.7305C45.9661 41.6549 42.8843 45.5793 39.8246 47.0648C38.3391 47.7964 38.1617 47.8186 35.7229 47.8186C33.3948 47.8186 33.0623 47.7742 31.8428 47.1978C27.209 45.025 23.8833 39.5486 23.3733 33.2519C23.2625 31.6999 23.2846 31.5225 23.6615 31.3895C26.4108 30.4361 29.404 28.2411 30.6234 26.2235L31.1777 25.3367L32.2641 26.5561C32.8406 27.2212 33.9491 28.1968 34.703 28.7289ZM18.2295 30.68C18.5399 31.0791 18.6286 31.5669 18.6508 32.8972V34.6265H17.3205C15.7463 34.6265 14.9481 34.294 14.5269 33.4958C14.0169 32.4981 14.1278 31.5669 14.8594 30.8352C15.4137 30.2809 15.6798 30.1922 16.6553 30.1922C17.5644 30.1922 17.8969 30.2809 18.2295 30.68ZM32.9292 52.2751C34.703 52.652 36.8536 52.652 38.4943 52.2529C40.5341 51.7651 40.401 51.6543 40.3345 54.071L40.268 56.2438L38.7604 56.9754C37.4966 57.5962 36.9866 57.7293 35.7672 57.7293C34.2374 57.7293 32.7962 57.308 31.6876 56.532C31.089 56.1107 31.0668 56.0442 31.0668 53.8936C31.0668 52.2751 31.1334 51.7208 31.3329 51.8316C31.4659 51.9203 32.1976 52.1199 32.9292 52.2751Z"
        fill="currentColor"
      />
      <path
        d="M58.3594 55.113C57.0956 55.8225 56.8518 57.5741 57.8716 58.594C59.3128 60.0129 61.663 59.0374 61.663 57.0198C61.663 55.2904 59.8893 54.2705 58.3594 55.113Z"
        fill="currentColor"
      />
      <path
        d="M94.4771 55.1792C93.1246 55.4009 91.107 56.2213 89.9984 56.9751C88.9342 57.7511 75.986 63.6709 75.4095 63.6709C75.2765 63.6709 73.7245 62.8062 71.9508 61.7641C68.1594 59.5026 67.7604 59.3474 66.674 59.547C65.2993 59.813 64.5898 61.4759 65.2993 62.7619C65.4767 63.0723 67.0952 64.1808 69.2237 65.4224L72.8598 67.5509L72.9263 72.0739C72.9707 76.3087 72.9485 76.5747 72.5937 76.486C72.372 76.4195 69.1128 75.2001 65.3215 73.7589C61.5523 72.3178 58.1157 71.054 57.7388 70.9432C56.8963 70.7214 55.5882 71.2092 55.2113 71.9187C54.9009 72.4952 54.923 94.1346 55.2334 94.711C55.8764 95.9083 57.8053 96.0857 58.8031 95.0214L59.3352 94.445L59.4017 85.4655C59.446 77.1068 59.4904 76.486 59.8451 76.5969C60.0447 76.6412 63.4591 77.905 67.4278 79.4127C71.3965 80.8982 74.9439 82.1176 75.3208 82.1176C75.853 82.1176 78.2697 80.6986 85.0985 76.4417L94.1667 70.7658H96.4947C101.062 70.7658 104.432 69.1251 106.139 66.0654C106.716 65.0234 106.782 64.6686 106.782 63.0057C106.782 60.7442 106.317 59.6357 104.72 58.0393C102.459 55.7557 98.1575 54.5584 94.4771 55.1792ZM98.5788 59.7909C100.286 60.0791 102.104 61.4094 102.348 62.6067C102.57 63.5822 101.661 64.8238 100.197 65.5333C97.5367 66.8414 93.9671 66.4423 92.1269 64.6686C91.3509 63.9369 91.1513 63.5822 91.1513 63.0057C91.1513 61.5203 92.9472 60.0791 95.2974 59.68C96.3616 59.5026 96.8937 59.5248 98.5788 59.7909ZM86.717 64.2695C86.7392 64.979 87.5595 66.5088 88.4464 67.4844L89.3333 68.4378L83.7682 71.8965C80.6864 73.8033 78.0479 75.4218 77.9149 75.5105C77.6932 75.6435 77.6267 74.8232 77.6267 71.7192V67.7505L81.9058 65.8437C84.2338 64.8016 86.2958 63.9148 86.451 63.9148C86.584 63.8926 86.717 64.07 86.717 64.2695Z"
        fill="currentColor"
      />
      <path
        d="M13.6177 70.9213C13.3516 70.9657 12.8639 71.3204 12.5535 71.6752L11.9992 72.3625V83.3152C11.9992 95.4652 11.9548 95.1105 13.4403 95.5982C14.4159 95.9308 15.214 95.6869 15.8792 94.8887L16.4335 94.2236V83.2709V72.3181L15.8348 71.6752C15.1919 71.01 14.4824 70.7661 13.6177 70.9213Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const InfoIcon = () => {
  return <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="#000" d="M12 17q.425 0 .713-.288T13 16v-4q0-.425-.288-.712T12 11t-.712.288T11 12v4q0 .425.288.713T12 17m0-8q.425 0 .713-.288T13 8t-.288-.712T12 7t-.712.288T11 8t.288.713T12 9m0 13q-2.075 0-3.9-.788t-3.175-2.137T2.788 15.9T2 12t.788-3.9t2.137-3.175T8.1 2.788T12 2t3.9.788t3.175 2.137T21.213 8.1T22 12t-.788 3.9t-2.137 3.175t-3.175 2.138T12 22m0-2q3.35 0 5.675-2.325T20 12t-2.325-5.675T12 4T6.325 6.325T4 12t2.325 5.675T12 20m0-8" /></svg>
}

/*---------------- Vendor portal - login field icons ----------------*/
export const UserOutlineSvg = () => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
      <circle cx="12" cy="7" r="4" />
    </svg>
  );
};

export const LockSvg = () => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="3" y="11" width="18" height="11" rx="2" />
      <path d="M7 11V7a5 5 0 0 1 10 0v4" />
    </svg>
  );
};

export const EyeOutlineSvg = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8Z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  );
};

export const EyeOffOutlineSvg = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8Z" />
      <path d="M3 3l18 18" />
    </svg>
  );
};

/*---------------- Vendor portal - login brand panel ----------------*/
export const VendorWaveTopSvg = () => {
  return (
    <svg
      className="va-wave va-wave-top"
      viewBox="0 0 500 120"
      preserveAspectRatio="none"
      height="120"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 60 Q125 10 250 55 T500 45 V0 H0 Z" fill="rgba(255,255,255,.05)" />
    </svg>
  );
};

export const VendorWaveBottomSvg = () => {
  return (
    <svg
      className="va-wave va-wave-bottom"
      viewBox="0 0 500 100"
      preserveAspectRatio="none"
      height="100"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 55 Q125 95 250 60 T500 70 V100 H0 Z" fill="rgba(143,189,255,.12)" />
    </svg>
  );
};

// donut in the dashboard mockup - decorative, colours come from _vendor-login.scss
export const VendorDonutSvg = () => {
  return (
    <svg className="va-donut" viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg">
      <circle className="va-track" cx="18" cy="18" r="14.2" pathLength="100" />
      <circle className="va-seg1" cx="18" cy="18" r="14.2" pathLength="100" transform="rotate(-90 18 18)" />
      <circle className="va-seg2" cx="18" cy="18" r="14.2" pathLength="100" transform="rotate(-90 18 18)" />
    </svg>
  );
};
// activity trail - opens the vendor log modal from the Zoho vendor list
export const ActivityLogSvg = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7v5l3 2" />
    </svg>
  );
};

export const UserIcon = () => (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
    </svg>
);

export const MailIcon = () => (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="4" width="20" height="16" rx="2" />
        <path d="m22 7-10 6L2 7" />
    </svg>
);

export const PhoneIcon = () => (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.8 19.8 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.12 4.2 2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.1 9.9a16 16 0 0 0 6 6l1.26-1.26a2 2 0 0 1 2.11-.45c.9.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92Z" />
    </svg>
);

export const ChevronIcon = () => (
    <svg className="vp-mchevron" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="m6 9 6 6 6-6" />
    </svg>
);

export const EyeIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7Z" />
        <circle cx="12" cy="12" r="3" />
    </svg>
);

/*==================================================================
  Vendor portal icons - every inline svg the vendor screens used to
  carry sits here, so the portal draws from one sheet like the rest
  of the app. Sizes are kept as each screen had them.
==================================================================*/

/*---------------- Vendor portal - side / mobile nav ----------------*/
const vendorNavSvgProps = {
    width: 15,
    height: 15,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.9,
    strokeLinecap: "round",
    strokeLinejoin: "round",
};

export const VendorNavDashboardSvg = () => (
    <svg {...vendorNavSvgProps}>
        <rect x="3" y="3" width="7" height="9" rx="1" />
        <rect x="14" y="3" width="7" height="5" rx="1" />
        <rect x="14" y="12" width="7" height="9" rx="1" />
        <rect x="3" y="16" width="7" height="5" rx="1" />
    </svg>
);

export const VendorNavMembersSvg = () => (
    <svg {...vendorNavSvgProps}>
        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <path d="M22 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" />
    </svg>
);

export const VendorNavTicketsSvg = () => (
    <svg {...vendorNavSvgProps}>
        <path d="M14 9a2 2 0 0 1-2 2H6l-4 4V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2Z" />
        <path d="M18 9h2a2 2 0 0 1 2 2v11l-4-4h-6a2 2 0 0 1-2-2v-1" />
    </svg>
);

export const VendorNavDocumentsSvg = () => (
    <svg {...vendorNavSvgProps}>
        <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5Z" />
        <path d="M14 2v6h6" />
    </svg>
);

/*---------------- Vendor portal - header user menu ----------------*/
export const VendorMenuLockSvg = () => (
    <svg
        width="15"
        height="15"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        <rect x="3" y="11" width="18" height="11" rx="2" />
        <path d="M7 11V7a5 5 0 0 1 10 0v4" />
    </svg>
);

export const VendorMenuLogoutSvg = () => (
    <svg
        width="15"
        height="15"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
        <path d="m16 17 5-5-5-5" />
        <path d="M21 12H9" />
    </svg>
);

/*---------------- Vendor portal - dashboard ----------------*/
// the four stat tiles share one look, only the glyph inside changes
const vendorStatSvgProps = {
    width: 18,
    height: 18,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.9,
    strokeLinecap: "round",
    strokeLinejoin: "round",
};

export const VendorStatMembersSvg = () => (
    <svg {...vendorStatSvgProps}>
        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
    </svg>
);

export const VendorStatTicketsSvg = () => (
    <svg {...vendorStatSvgProps}>
        <path d="M14 9a2 2 0 0 1-2 2H6l-4 4V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2Z" />
        <path d="M18 9h2a2 2 0 0 1 2 2v11l-4-4h-6a2 2 0 0 1-2-2v-1" />
    </svg>
);

export const VendorStatResolvedSvg = () => (
    <svg {...vendorStatSvgProps}>
        <path d="M22 11.1V12a10 10 0 1 1-5.9-9.1" />
        <path d="m9 11 3 3L22 4" />
    </svg>
);

export const VendorStatClockSvg = () => (
    <svg {...vendorStatSvgProps}>
        <circle cx="12" cy="12" r="10" />
        <path d="M12 6v6l4 2" />
    </svg>
);

export const VendorStatDocumentsSvg = () => (
    <svg {...vendorStatSvgProps}>
        <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5Z" />
        <path d="M14 2v6h6" />
    </svg>
);

// envelope on the "Open Support Tickets" banner button
export const VendorTicketsCtaSvg = () => (
    <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.9"
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        <path d="M4 4h16v16H4z" />
        <path d="m4 6 8 6 8-6" />
    </svg>
);

export const VendorChevronRightSvg = () => (
    <svg
        width="13"
        height="13"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        <path d="m9 18 6-6-6-6" />
    </svg>
);

/*---------------- Vendor portal - change password ----------------*/
export const VendorShieldSvg = () => (
    <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10Z" />
        <path d="m9 12 2 2 4-4" />
    </svg>
);

// rule checklist: a tick once the rule passes, a dash while it does not
export const VendorTickSvg = ({ done }) => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
        {done ? <path d="m5 12.5 4.5 4.5L19 7" /> : <path d="M6 12h12" />}
    </svg>
);

/*---------------- Vendor portal - members ----------------*/
export const VendorPinSvg = ({ size = 13 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
        <circle cx="12" cy="10" r="3" />
    </svg>
);

export const VendorMapSvg = ({ size = 13 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 6v15l6-3 6 3 6-3V3l-6 3-6-3-6 3Z" />
        <path d="M9 3v15M15 6v15" />
    </svg>
);

export const VendorExportSvg = () => (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5Z" />
        <path d="M14 2v6h6" />
    </svg>
);

export const VendorFunnelSvg = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
    </svg>
);

export const VendorBackSvg = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M19 12H5m7-7-7 7 7 7" />
    </svg>
);

/*---------------- Vendor portal - support tickets ----------------*/
export const VendorChevronDownSvg = () => (
    <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
        <path d="m6 9 6 6 6-6" />
    </svg>
);

export const VendorFilterSvg = () => (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M22 3H2l8 9.46V19l4 2v-8.54L22 3z" />
    </svg>
);

// shared by the ticket inbox and the members toolbar
export const VendorSearchSvg = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
        <circle cx="11" cy="11" r="8" />
        <path d="m21 21-4.3-4.3" />
    </svg>
);

export const VendorShareSvg = ({ size = 15 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="18" cy="5" r="3" />
        <circle cx="6" cy="12" r="3" />
        <circle cx="18" cy="19" r="3" />
        <line x1="8.6" y1="10.5" x2="15.4" y2="6.5" />
        <line x1="8.6" y1="13.5" x2="15.4" y2="17.5" />
    </svg>
);

export const VendorForwardSvg = ({ size = 15 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="15 17 20 12 15 7" />
        <path d="M4 18v-2a4 4 0 0 1 4-4h12" />
    </svg>
);

/* the mirror of Forward - the arrow curves back to the left instead of ahead */
export const VendorReplySvg = ({ size = 15 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="9 17 4 12 9 7" />
        <path d="M20 18v-2a4 4 0 0 0-4-4H4" />
    </svg>
);

export const VendorClockSvg = ({ size = 13 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10" />
        <path d="M12 6v6l4 2" />
    </svg>
);

export const VendorPencilSvg = ({ size = 13 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 20h9" />
        <path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z" />
    </svg>
);

export const VendorMailSvg = ({ size = 15 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2.5" y="5" width="19" height="14" rx="2.5" />
        <path d="m3 7 9 6 9-6" />
    </svg>
);

export const VendorInfoSvg = ({ size = 15 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="9" />
        <line x1="12" y1="11" x2="12" y2="16.5" />
        <circle cx="12" cy="7.7" r="0.9" fill="currentColor" stroke="none" />
    </svg>
);

export const VendorKebabSvg = ({ size = 17 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
        <circle cx="12" cy="5" r="2" />
        <circle cx="12" cy="12" r="2" />
        <circle cx="12" cy="19" r="2" />
    </svg>
);

export const VendorDownloadSvg = ({ size = 14 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 3v12" />
        <path d="m7 11 5 5 5-5" />
        <path d="M4 20h16" />
    </svg>
);

export const VendorSendSvg = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="m22 2-7 20-4-9-9-4Z" />
        <path d="M22 2 11 13" />
    </svg>
);

/* the detail header's fact strip - one icon per field */
export const VendorPersonSvg = ({ size = 12 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
        <circle cx="12" cy="7" r="4" />
    </svg>
);

export const VendorTagSvg = ({ size = 12 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12.6 2.7a2.4 2.4 0 0 0-1.7-.7H4a2 2 0 0 0-2 2v6.9c0 .6.3 1.2.7 1.7l8 8a2.4 2.4 0 0 0 3.4 0l6.9-6.9a2.4 2.4 0 0 0 0-3.4Z" />
        <circle cx="6.5" cy="6.5" r="1.5" />
    </svg>
);

export const VendorStoreSvg = ({ size = 12 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 10v10h18V10" />
        <path d="M3 10 5 3h14l2 7a3 3 0 0 1-6 0 3 3 0 0 1-6 0 3 3 0 0 1-6 0Z" />
    </svg>
);

export const VendorFlagSvg = ({ size = 12 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M4 22V4a6 6 0 0 1 8 0 6 6 0 0 0 8 0v9a6 6 0 0 1-8 0 6 6 0 0 0-8 0" />
    </svg>
);

export const VendorCalendarSvg = ({ size = 12 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="4" width="18" height="18" rx="2" />
        <path d="M16 2v4M8 2v4M3 10h18" />
    </svg>
);

// shared by the ticket detail close and the members filter card close
export const VendorCloseSvg = ({ size = 13 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
        <path d="M18 6 6 18M6 6l12 12" />
    </svg>
);

// empty state for the ticket inbox
export const VendorEmptyMailboxSvg = () => (
    <svg width="150" height="140" viewBox="0 0 150 140">
        <defs>
            <linearGradient id="vpTkLid" x1="0" y1="0" x2="1" y2="1">
                <stop offset="0" stopColor="#a78bfa" />
                <stop offset="1" stopColor="#7c3aed" />
            </linearGradient>
            <linearGradient id="vpTkBox" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0" stopColor="#38bdf8" />
                <stop offset="1" stopColor="#1d6fd8" />
            </linearGradient>
            <linearGradient id="vpTkPaper" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0" stopColor="#ffffff" />
                <stop offset="1" stopColor="#e8e8e8" />
            </linearGradient>
            <linearGradient id="vpTkFlap" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0" stopColor="#fbfbfb" />
                <stop offset="1" stopColor="#dcdcdc" />
            </linearGradient>
        </defs>
        <path d="M40 40 L75 18 L110 40 Z" fill="url(#vpTkLid)" />
        <path d="M28 52 L75 22 L122 52 L122 118 a8 8 0 0 1-8 8 L36 126 a8 8 0 0 1-8-8 Z" fill="url(#vpTkBox)" />
        <rect x="42" y="30" width="66" height="72" rx="5" fill="url(#vpTkPaper)" />
        <path d="M28 52 L75 86 L122 52 L122 118 a8 8 0 0 1-8 8 L36 126 a8 8 0 0 1-8-8 Z" fill="url(#vpTkFlap)" stroke="#d0d0d0" strokeWidth="1" />
        <path d="M28 118 L67 84 L75 90 L83 84 L122 118 a8 8 0 0 1-8 8 L36 126 a8 8 0 0 1-8-8 Z" fill="#f2f2f2" stroke="#d6d6d6" strokeWidth="1" />
    </svg>
);

export const VendorUploadSvg = ({ size = 15 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
        <path d="M17 8 12 3 7 8" />
        <path d="M12 3v12" />
    </svg>
);

export const VendorFolderSvg = ({ size = 20 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M4 20a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h5l2 3h7a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2Z" />
    </svg>
);

export const VendorFileSvg = ({ size = 19 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5Z" />
        <path d="M14 2v6h6" />
    </svg>
);

export const VendorTrashSvg = ({ size = 15 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 6h18" />
        <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
        <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6" />
    </svg>
);

export const VendorDropzoneSvg = ({ size = 20 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="3" width="18" height="18" rx="2" />
        <circle cx="9" cy="9" r="2" />
        <path d="m21 15-5-5L5 21" />
    </svg>
);
